﻿/* sindhi-bundle-builder.js — Plan B Feature B, Tasks 6+7: weight-split engine + step UI */
(function () {
  var root =
    document.querySelector('[data-bbx]') ||
    document.querySelector('.sindhi-bundle-builder');
  if (!root) return;

  var cfgEl = root.querySelector('[data-bbx-config]');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.error('[bbx] Failed to parse config JSON:', e);
    return;
  }

  /**
   * t(key, fallback, vars) — look up a string from cfg.strings.
   * key: flat key from cfg.strings (e.g. 'step1_heading')
   * fallback: English literal if the key is missing
   * vars: optional {name: value} map — replaces {{ name }} tokens
   */
  function htmlEntitiesDecode(s) {
    return String(s)
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function t(key, fallback, vars) {
    var raw = (cfg.strings && cfg.strings[key] != null) ? cfg.strings[key] : fallback;
    var s = htmlEntitiesDecode(raw);
    if (vars) {
      Object.keys(vars).forEach(function(k) {
        s = s.replace(new RegExp('%' + k + '%', 'g'), String(vars[k]));
      });
    }
    return s;
  }

  /**
   * The shopper-facing product name. Prefers `short_title` (resolved in
   * snippets/bbx-product-json.liquid from custom.short_name, else the text
   * before the first comma/dash of the catalog title) and falls back to the
   * full title for any object emitted before that field existed.
   *
   * Use this for anything the shopper reads at a glance — grid cards, preview
   * wedges, order-summary thumbnails. Do NOT use it for the info popup, image
   * alt text or aria-labels: those want the full merchandising title.
   */
  function displayName(product) {
    if (!product) return '';
    return product.short_title || product.title || '';
  }

  // ---------------------------------------------------------------------------
  // Accessibility: debounced screen-reader announcements
  // ---------------------------------------------------------------------------

  /**
   * Announce a message to screen readers via the dedicated #bbx-sr-live region.
   * Debounced at 150 ms so rapid intermediate states (weight rebalances on
   * every add/remove) are coalesced into a single announcement.
   *
   * Use aria-live="polite" for weight/state changes.
   * Errors and capacity-full alerts use role="alert" aria-live="assertive"
   * on their own dedicated elements — do NOT route those through here.
   */
  var _announceTimer = null;
  function announceToSR(text) {
    clearTimeout(_announceTimer);
    _announceTimer = setTimeout(function () {
      var el = document.getElementById('bbx-sr-live');
      if (!el) return;
      el.textContent = '';
      // Force reflow so repeated identical text re-triggers SR announcement
      void el.offsetWidth;
      el.textContent = text;
    }, 150);
  }

  // ---------------------------------------------------------------------------
  // Weight engine
  // ---------------------------------------------------------------------------

  /**
   * Split capacityG grams evenly across `count` slots.
   * Base = floor(capacity / count); last slot absorbs the rounding remainder.
   * Returns an array of integers summing exactly to capacityG.
   *
   * @param {number} capacityG - Total grams to distribute (integer).
   * @param {number} count     - Number of items to distribute across.
   * @returns {number[]}
   */
  function evenSplit(capacityG, count) {
    if (count <= 0) return [];
    var base = Math.floor(capacityG / count);
    var out = new Array(count).fill(base);
    out[count - 1] += capacityG - base * count; // last slot absorbs remainder
    return out;
  }

  /**
   * Normalise a variant's weight to grams using only the variant title.
   * Shopify's v.weight (gross shipping weight) is intentionally ignored —
   * it includes packaging and produces wrong per-gram rates (e.g. 1 kg walnut
   * has a 1.16 kg shipping weight → ₹758/kg instead of ₹880/kg).
   *
   * Supported title patterns: "500g", "500 g", "1 Kg", "1.5kg", "250 G"
   * If the title contains no parseable weight this returns null — the product
   * must then be marked unavailable (see productHasWeightTitle).
   *
   * @param {{ title?: string }} v
   * @returns {number|null} Weight in grams, or null if title has no parseable weight.
   */
  function variantGrams(v) {
    var m = /([\d.]+)\s*(kg|g)\b/i.exec(v.title || '');
    if (m) return parseFloat(m[1]) * (/kg/i.test(m[2]) ? 1000 : 1);
    return null;
  }

  /**
   * Returns true if at least one variant has a title-parseable weight.
   * Products without parseable weights cannot be pro-rated and are shown
   * as disabled with activation instructions.
   *
   * @param {{ variants: Array }} product
   * @returns {boolean}
   */
  function productHasWeightTitle(product) {
    return (product.variants || []).some(function (v) {
      return variantGrams(v) !== null;
    });
  }

  /**
   * Find the nearest variant by weight to the target allocation.
   * Used as the rate-selector for per-gram pricing.
   *
   * @param {{ variants: Array }} product
   * @param {number} allocatedG - Target grams for this slot.
   * @returns {object|null} The best-matching variant, or null.
   */
  function nearestVariant(product, allocatedG) {
    return product.variants.reduce(function (best, v) {
      var vg = variantGrams(v);
      if (vg == null) return best;
      if (best == null) return v;
      var bg = variantGrams(best);
      if (bg == null) return v;
      return Math.abs(vg - allocatedG) < Math.abs(bg - allocatedG) ? v : best;
    }, null);
  }

  /**
   * Allocated price (in PAISE) for `allocatedG` grams of this product.
   * Uses a linear per-gram rate derived from the nearest variant.
   *
   * Unit rule:
   *   v.price is already in PAISE (Liquid minor unit for INR).
   *   Result is in PAISE — divide by 100 only for display.
   *
   * @param {{ variants: Array }} product
   * @param {number} allocatedG - Grams allocated to this product in the bundle.
   * @returns {number} Price in paise (integer, rounded).
   */
  function allocatedPrice(product, allocatedG) {
    var nv = nearestVariant(product, allocatedG);
    if (!nv) return 0;
    var g = variantGrams(nv);
    if (!g) return 0;
    // nv.price is paise; (paise / g) * allocatedG = paise for this allocation
    return Math.round((nv.price / g) * allocatedG);
  }

  /**
   * Format paise as a localised money string using the store's moneyFormat.
   * moneyFormat from Liquid: e.g. "₹{{amount}}" or "₹{{amount_with_comma_separator}}"
   *
   * @param {number} paise
   * @returns {string}
   */
  function money(paise) {
    var rupees = (paise / 100).toFixed(2);
    var fmt = cfg.moneyFormat || '₹{{amount}}';
    // Support {{amount}}, {{amount_with_comma_separator}}, {{amount_no_decimals}}
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, function () {
        var parts = rupees.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      })
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(paise / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, rupees);
  }

  // ---------------------------------------------------------------------------
  // Shared namespace — Tasks 7-11 extend root.__bbx
  // ---------------------------------------------------------------------------
  root.__bbx = {
    cfg: cfg,
    // Engine functions
    evenSplit: evenSplit,
    variantGrams: variantGrams,
    productHasWeightTitle: productHasWeightTitle,
    nearestVariant: nearestVariant,
    allocatedPrice: allocatedPrice,
    money: money,
    // Mutable state scaffold — Tasks 7-11 populate this
    state: {
      bundles: [],                           // completed bundles (for multi-box)
      step: 1,                               // current builder step (1-4) for chrome indicator
      current: {
        pkg: null,                           // selected sindhi_bundle_package object
        items: [],                           // [{ product, allocatedG, priceP }]
        customisations: []                   // [{ customisation, priceP }]
      }
    }
  };

  // ---------------------------------------------------------------------------
  // Task 7 — Step UI: package picker, product grid, customisations, capacity pips
  // ---------------------------------------------------------------------------

  // DOM container references
  var elSteps     = root.querySelector('[data-bbx-steps]');
  var elCapacity  = root.querySelector('[data-bbx-capacity]');
  var elGrid      = root.querySelector('[data-bbx-grid]');
  var elSummary   = root.querySelector('[data-bbx-summary]');
  var elCta       = root.querySelector('[data-bbx-cta]');

  // Fix B (QA pass 2): the sticky CTA already shows "%count% items · %weight%
  // each" — this tracks the last-rendered per-item weight so refreshCta() can
  // pulse that existing text when it changes, replacing the deleted floating
  // "Weights updated" note while preserving the cue it existed for.
  var _bbxPrevPerItemG = null;
  var _bbxCtaChangeTimer = null;

  // ── Helpers ──────────────────────────────────────────────────────────────

  /** Resolve max_selections for the customisation layer from cfg.layers. */
  function custMaxSelections() {
    var layer = (cfg.layers || []).find(function (l) {
      return l.source_type === 'metaobject_customisation';
    });
    return layer ? (parseInt(layer.max_selections, 10) || 99) : 99;
  }

  /** Number of active packages. */
  function activePackageCount() {
    return (cfg.packages || []).length;
  }

  /**
   * Default add-ons for a freshly-started box: every "Ribbon" category
   * customisation (matches the category check the preview overlay already
   * uses, js:2184-ish). Capped at custMaxSelections() so a future merchant
   * adding more ribbon-category entries can't seed more than the layer allows.
   */
  function defaultCustomisations() {
    return (cfg.customisations || [])
      .filter(function (c) { return (c.category || '').toLowerCase() === 'ribbon'; })
      .slice(0, custMaxSelections())
      .map(function (c) {
        return { customisation: c, priceP: Math.round((parseFloat(c.price) || 0) * 100) };
      });
  }

  /**
   * Create a DOM element with optional class, text, and attributes.
   * @param {string} tag
   * @param {object} opts
   * @returns {HTMLElement}
   */
  function el(tag, opts) {
    opts = opts || {};
    var node = document.createElement(tag);
    if (opts.cls)  node.className = opts.cls;
    if (opts.text) node.textContent = opts.text;
    if (opts.html) node.innerHTML = opts.html;
    if (opts.attrs) {
      Object.keys(opts.attrs).forEach(function (k) {
        node.setAttribute(k, opts.attrs[k]);
      });
    }
    return node;
  }

  // ── Gap 1: Builder Chrome (header + step bar) ────────────────────────────

  /**
   * True when the mobile full-screen stepper is the active experience.
   * Evaluated live, never cached — a portrait/landscape rotate crosses the
   * 749px boundary and must be answered correctly on the next call.
   */
  function isStepperMode() {
    return cfg.mobileExperience === 'fullscreen-stepper' && window.innerWidth <= 749;
  }

  /**
   * True when a step-0 (template picker) screen actually exists to navigate to:
   * the merchant has the picker on (globally, and on mobile when we are in
   * stepper mode), Liquid emitted at least one template, and no box has been
   * finished yet — renderTemplatePicker() hides the picker for good once
   * state.bundles is non-empty, so offering a step-0 pill after that would
   * navigate to a permanently blank screen.
   */
  function hasStep0() {
    if (!cfg.showTemplatePicker) return false;
    if (isStepperMode() && !cfg.showTemplatePickerMobile) return false;
    if (!(cfg.templates || []).length) return false;
    if (root.__bbx.state.bundles.length > 0) return false;
    // Not just "does the wrapper exist" — renderTemplatePicker() filters out
    // cards whose items fail the weight-title check or reference an inactive
    // package, so cfg.templates.length can be > 0 while zero cards actually
    // render. Count the cards themselves.
    //
    // Deliberately NOT `!wrap.hidden` — showStepPanel() writes wrap.hidden as the
    // panel router, so it stops meaning "has cards" the moment we leave step 0.
    // The grid keeps its children while hidden, so card count survives routing.
    var grid = root.querySelector('[data-bbx-templates-grid]');
    return !!grid && grid.children.length > 0;
  }

  /**
   * Show exactly one step panel. 0 = template picker, >= 1 = builder body.
   *
   * Every DOM write here is stepper-mode-only. Desktop/tablet must be
   * completely unchanged (plan Global Constraint), so outside stepper mode this
   * is a total no-op and the legacy `wrap.hidden = …` call sites keep doing
   * exactly what they do today — picker and builder coexisting on the page.
   */
  function showStepPanel(n) {
    if (!isStepperMode()) return;
    var wrap = root.querySelector('[data-bbx-templates]');
    if (wrap) wrap.hidden = n !== 0;
    if (elSteps) elSteps.hidden = n === 0;
    if (elCta) elCta.hidden = n === 0;

    // Per-step panel routing.
    //
    // Every builder panel lives inside the single [data-bbx-steps] container,
    // so revealing that container reveals ALL of them unless each step says
    // explicitly what belongs to it. This used to special-case only steps 2
    // and 3, which left step 1 unrouted: going back to Package showed the
    // package picker with step 2's dry-fruits grid, capacity meter and
    // "Select a package to begin." still stacked underneath it.
    //
    // Routed explicitly for every step rather than toggling the delta, so a
    // future step cannot inherit a stale panel the same way.
    if (n >= 1) {
      var cusPanel = elSteps && elSteps.querySelector('.bbx-step--customisations');
      var pkgStep  = elSteps && elSteps.querySelector('.bbx-step--packages');
      var pkgBanner = root.querySelector('.bbx-pkg-banner');

      var showPkgPicker = (n === 1);          // step 1 IS the package choice
      var showFillings  = (n === 2);          // grid + capacity + live preview
      var showCus       = (n === 3);          // Personal Touches

      if (pkgStep)    pkgStep.style.display    = showPkgPicker ? '' : 'none';
      if (elGrid)     elGrid.style.display     = showFillings  ? '' : 'none';
      if (elCapacity) elCapacity.style.display = showFillings  ? '' : 'none';
      if (elPreview)  elPreview.style.display  = showFillings  ? '' : 'none';
      if (cusPanel)   cusPanel.style.display   = showCus       ? '' : 'none';
      // The banner is the compact "you picked X" summary. It is context on the
      // later steps and noise on step 1, where the full picker is on screen.
      if (pkgBanner)  pkgBanner.style.display  = showPkgPicker ? 'none' : '';
    }

    // SR announcement for every step transition (spec QA checklist item 11),
    // not just the sheet's initial open. goToStep, applyTemplate's
    // picker-to-builder switch and the "Build my own" skip handler all route
    // panel changes through this one function — announcing here once covers
    // all three call sites instead of repeating the same call three times.
    // stepLabel is a function declaration below this one in source order and
    // is hoisted, so it is safe to call here.
    var label = stepLabel(n);
    if (label) announceToSR(label);
  }

  /**
   * The one place step numbers and labels are defined. Both
   * renderBuilderChrome() and refreshChrome() consume this; before, each built
   * its own copy of the same 4-entry array and they were free to drift.
   *
   * Every def carries its own `n`. Navigation never derives a step number from
   * an array index, so suppressing the step-0 pill cannot silently renumber
   * Package and Dry Fruits.
   *
   * Steps 3 and 4 ("Personal Touches" / "Extras") exist on desktop/tablet as
   * legacy dead pills (the engine never navigates to step 4; step 3 now routes
   * to the Personal Touches panel in stepper mode). On mobile stepper, step 3
   * is a live destination — but only when cfg.customisations is non-empty.
   */
  function buildStepDefs() {
    if (isStepperMode()) {
      var defs = [];
      if (hasStep0()) defs.push({ n: 0, label: t('chrome_step0', 'Choose a Box') });
      defs.push({ n: 1, label: t('chrome_step1', 'Package') });
      defs.push({ n: 2, label: t('chrome_step2', 'Dry Fruits') });
      // Step 3 (Personal Touches) is only shown when there is something to choose.
      if ((cfg.customisations || []).length > 0) {
        defs.push({ n: 3, label: t('chrome_step3', 'Personal Touches') });
      }
      return defs;
    }
    return [
      { n: 1, label: t('chrome_step1', 'Package') },
      { n: 2, label: t('chrome_step2', 'Dry Fruits') },
      { n: 3, label: t('chrome_step3', 'Personal Touches') },
      { n: 4, label: t('chrome_step4', 'Extras') }
    ];
  }

  /** Human label for a step number, or '' when that step is not in the trail. */
  function stepLabel(n) {
    var match = buildStepDefs().filter(function (d) { return d.n === n; })[0];
    return match ? match.label : '';
  }

  /**
   * Data-based reachability gate — the single source of truth for whether step
   * n can be visited from any current state.
   *
   * Steps are gated on content/data, not on visit history:
   *   0  — only when hasStep0() (template picker exists and is relevant)
   *   1  — always reachable (Package picker is always present)
   *   2  — only when a package has been selected
   *   3  — only when a package is selected AND customisations are non-empty
   *
   * This replaces the old `n >= s` guard that conflated "not yet visited" with
   * "unreachable", which prevented forward navigation back to a step the user
   * had already completed (the QA bug: Package → Dry Fruits → back to Package
   * left the user stranded with no forward path to Dry Fruits).
   */
  function canGoToStep(n) {
    var hasPkg = !!(root.__bbx.state.current && root.__bbx.state.current.pkg);
    var hasCus = (cfg.customisations || []).length > 0;
    if (n === 0) return isStepperMode() ? hasStep0() : !!(cfg.templates || []).length;
    if (n === 1) return true;
    if (n === 2) return hasPkg;
    if (n === 3) return hasPkg && hasCus;
    return false;
  }

  /**
   * Single navigation path for the back button, the stepper pills and the CTA.
   * Navigation is data-gated (canGoToStep) — both backward AND forward moves
   * are permitted when the target step's data preconditions are satisfied.
   *
   * n === 0 is the template picker. In stepper mode it is a real destination
   * that sets state.step, replacing the back button's old inline "reveal the
   * picker but leave state.step at 1" branch — which left the chrome showing
   * Package as active over the template picker. Outside stepper mode (Stage 3
   * opus audit, finding 3) state.step is deliberately left untouched — the
   * legacy 4-entry desktop/tablet trail has no step-0 entry, and this is
   * exactly the original branch's own behavior, unchanged.
   */
  function goToStep(n) {
    if (n < 0) return;
    if (!canGoToStep(n)) return;
    if (n === 0 && !isStepperMode()) {
      // Desktop/tablet: reveal the template picker WITHOUT writing
      // state.step = 0. Outside stepper mode buildStepDefs() still returns
      // the legacy 4-entry trail with no step-0 entry — writing state.step = 0
      // here would make every pill render 'idle' (breaking the Package active
      // state) and strip role/tabindex via bindStepNav, making them
      // unclickable.
      //
      // Guarded by the ORIGINAL back-button condition — `tplWrap` plus a
      // non-empty cfg.templates, nothing else — NOT by hasStep0(). hasStep0()
      // adds showTemplatePicker / showTemplatePickerMobile / bundles.length
      // gates that are correct for the new stepper UX but would be new
      // behaviour on desktop/tablet, which the plan requires to stay
      // completely unchanged. The write is inline rather than via
      // showStepPanel() for the same reason: showStepPanel() is stepper-only.
      var tplWrap = root.querySelector('[data-bbx-templates]');
      if (tplWrap && (cfg.templates || []).length) {
        tplWrap.hidden = false;
        tplWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    root.__bbx.state.step = n;
    showStepPanel(n);
    refreshChrome();
    syncCtaText();
    if (n === 0) {
      var wrap = root.querySelector('[data-bbx-templates]');
      if (wrap) root.__bbx.scrollToInBuilder(wrap);
    }
  }

  /**
   * Keep the CTA button label in sync with the current step and builder state.
   * Only meaningful in stepper mode; no-ops otherwise (desktop/tablet wires
   * a single static label via wireDoneCta and never changes it).
   *
   * Called from selectPkg() (step→2) and goToStep() (any step change). IIFE 10's
   * wireDoneCta delegation handler reads the LIVE step when clicked, so text and
   * action are always in agreement.
   */
  function syncCtaText() {
    if (!isStepperMode()) return;
    var btn = elCta && elCta.querySelector('.bbx-cta-btn');
    if (!btn) return;
    var step = root.__bbx.state.step;
    var hasCus = (cfg.customisations || []).length > 0;
    var hasPkg = !!(root.__bbx.state.current && root.__bbx.state.current.pkg);
    // Step 1 is only ever a terminal step when there is nothing after it.
    // Coming BACK to Package from Dry Fruits with a box in progress used to
    // leave the button reading "Done — review box", which both mislabels the
    // action and skips the step the shopper was returning to edit.
    var goesForward = (step === 1 && hasPkg) || (step === 2 && hasCus);
    if (goesForward) {
      btn.textContent = t('cta_continue', 'Continue');
      return;
    }
    // Terminal step. Editing commits back into an existing box rather than
    // appending a new one, so the label has to say so — this used to be set
    // once by editBundle() and then frozen (syncCtaText bailed out entirely
    // while editing), which is why an edit could never walk forward to step 3.
    // Now the label follows the step like any other, and only the terminal
    // wording differs. isEditing/editingIndex live in the finalize IIFE, hence
    // the namespace hop and the defensive guards.
    var editing = !!(root.__bbx.isEditing && root.__bbx.isEditing());
    if (editing) {
      var editIdx = root.__bbx.editingIndex ? root.__bbx.editingIndex() : 0;
      btn.textContent = t('edit_save_changes', 'Save changes to Box %n%', { n: editIdx + 1 });
    } else {
      btn.textContent = t('cta_done_review', 'Done — review box');
    }
  }

  // ── Full-screen stepper sheet (mobile) ───────────────────────────────────
  // Module scope, not nested inside renderTemplatePicker() like the compact
  // popup was, so these stay callable when cfg.templates is empty — the sheet
  // must still open straight to Package in that case.

  var elSheet       = root.querySelector('[data-bbx-sheet]');
  var elSheetChrome = root.querySelector('[data-bbx-sheet-chrome]');
  var elSheetClose  = root.querySelector('[data-bbx-sheet-close]');
  var elTeaserPrev  = root.querySelector('[data-bbx-teaser-preview]');
  var elPreview     = root.querySelector('[data-bbx-preview]');
  var _stepperOpener = null;
  var _stepperPrevOverflow = '';

  var SHEET_FOCUSABLE_SEL =
    'a[href]:not([disabled]), button:not([disabled]), ' +
    '[tabindex]:not([tabindex="-1"]):not([disabled]), ' +
    'input:not([disabled]), select:not([disabled]), textarea:not([disabled])';

  function isStepperOpen() {
    return root.classList.contains('bbx-stepper-open');
  }

  /**
   * Where the chrome bar is mounted. In stepper mode it belongs to the sheet's
   * fixed bar, not to [data-bbx-steps] — the builder body is hidden on step 0
   * and the pill trail has to survive that.
   */
  function chromeHost() {
    return (isStepperMode() && elSheetChrome) ? elSheetChrome : elSteps;
  }

  function onSheetKeydown(e) {
    if (e.key === 'Escape') {
      // Stage 3 opus audit, finding 5: the drawer and order-summary panels
      // are DOM descendants of .bbx-sheet, and each has its OWN keydown trap
      // that calls preventDefault() on Escape (but not stopPropagation()) and
      // always runs first — it is bound deeper in the tree, so the bubble
      // phase reaches it before this listener. Checking e.defaultPrevented
      // defers to whichever nested layer just handled it, instead of ALSO
      // closing the whole sheet. The product-info popup mounts to
      // document.body, entirely outside .bbx-sheet's subtree — binding this
      // listener on elSheet itself (see openStepper/closeStepper below),
      // rather than on document, means the popup's Escape never reaches here
      // in the first place, so no defaultPrevented check is needed for it.
      if (e.defaultPrevented) return;
      closeStepper();
      return;
    }
    if (e.key !== 'Tab' || !elSheet) return;
    // Scan the whole sheet, and filter to what is actually rendered: the
    // hidden step panel is display:none so its controls must not be trapped.
    var focusable = Array.prototype.filter.call(
      elSheet.querySelectorAll(SHEET_FOCUSABLE_SEL),
      function (node) { return node.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /**
   * Entry step for a fresh open: the template picker when one exists, otherwise
   * Package. This is the merchant-toggle rule — with show_template_picker or
   * show_template_picker_mobile off, the sheet must never open on a blank
   * "Choose a Box" screen.
   */
  function stepperEntryStep() {
    return hasStep0() ? 0 : 1;
  }

  /**
   * Open the sheet. Deliberately does NOT reveal every template card the way
   * the deleted compact popup's openPopup() did: template_limit and its
   * "Show N more" button keep working normally inside the sheet, because
   * "reveal everything immediately" only ever made sense for the deleted
   * "View all boxes" trigger.
   */
  function openStepper(step) {
    if (!elSheet || !isStepperMode() || isStepperOpen()) return;
    var n = step == null ? stepperEntryStep() : step;
    _stepperOpener = document.activeElement;

    // A finished box's receipt (renderCompleteScreen) deliberately has no
    // chrome — it isn't part of the Package/Dry Fruits/Personal Touches
    // trail, and owns its own CTA (setReviewOrderCta — same reasoning as
    // refreshCta's guard above). Resuming a draft that ended there (teaser
    // "Continue" -> restoreDraft() -> openStepper()) used to unconditionally
    // rebuild the chrome bar and CTA text here, stamping a stale "Package"
    // pill and a "Done — review box" label over the receipt even though
    // state.step (reset to 1 by finalizeBundle) has nothing to do with what
    // is actually on screen.
    var onCompleteScreen = !!root.querySelector('.bbx-complete-screen');

    root.__bbx.state.step = n;

    // The live preview belongs to the builder while the sheet is open; it is
    // parked in the teaser while it is closed. One node, two homes.
    if (elPreview && elSteps && elGrid) elSteps.insertBefore(elPreview, elGrid);

    elSheet.setAttribute('role', 'dialog');
    elSheet.setAttribute('aria-modal', 'true');
    // Without the scroll lock the page keeps scrolling behind the sheet, so
    // dismissing lands the shopper somewhere they never navigated to.
    _stepperPrevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    root.classList.add('bbx-stepper-open');
    syncOverlayFlag();

    if (!onCompleteScreen) {
      // Re-render rather than refresh: the chrome host changes between
      // [data-bbx-steps] and the sheet bar, and the trail length changes with it.
      renderBuilderChrome();
      showStepPanel(n);
      // The sheet can open at any step (teaser resume lands on the saved step),
      // so the label has to be reconciled here too — not just on navigation.
      syncCtaText();
    }

    if (elSheetClose) elSheetClose.focus();
    // Bound to elSheet, not document (Stage 3 opus audit, finding 5): the
    // drawer/summary panels are descendants and their own trapFocus already
    // fires first in the bubble phase (see onSheetKeydown's Escape branch
    // above); the info popup mounts to document.body, outside this subtree
    // entirely, so binding here — rather than on document — means its
    // Escape presses never reach onSheetKeydown at all.
    elSheet.addEventListener('keydown', onSheetKeydown);
    announceToSR(t('stepper_aria', 'Build your box'));
  }

  /**
   * Flag on <body> for "the builder is showing a full-screen overlay right now"
   * (the stepper sheet, or the order summary — they are siblings, not nested,
   * so neither one's stacking context covers the other).
   *
   * Exists because the site-wide WhatsApp floater is position:fixed at
   * z-index 9000 — the same value as the sheet — and therefore painted OVER
   * the order summary's Total line and the sheet's CTA. Recomputed from live
   * DOM state rather than incremented/decremented, so closing the summary
   * while the sheet is still open cannot clear the flag prematurely.
   */
  function syncOverlayFlag() {
    var summaryOpen = !!root.querySelector('[data-bbx-summary].bbx-summary--open');
    var open = root.classList.contains('bbx-stepper-open') || summaryOpen;
    document.body.classList.toggle('bbx-overlay-open', open);
  }

  function closeStepper() {
    if (!elSheet || !isStepperOpen()) return;
    root.classList.remove('bbx-stepper-open');
    syncOverlayFlag();
    elSheet.removeAttribute('role');
    elSheet.removeAttribute('aria-modal');
    document.body.style.overflow = _stepperPrevOverflow;
    elSheet.removeEventListener('keydown', onSheetKeydown);

    if (elPreview && elTeaserPrev) elTeaserPrev.appendChild(elPreview);

    // Defined in the draft/teaser IIFE at the end of this file; guarded so this
    // controller works on its own.
    if (root.__bbx.saveDraft) root.__bbx.saveDraft();
    if (root.__bbx.renderTeaser) root.__bbx.renderTeaser();

    if (_stepperOpener && typeof _stepperOpener.focus === 'function') _stepperOpener.focus();
    _stepperOpener = null;
  }

  /**
   * Keep the DOM consistent when the viewport crosses the 749px boundary
   * (rotation is the real case). The sheet wrapper itself never moves — it is
   * CSS-gated — so this only has to put the preview back in its right home,
   * undo any panel hiding, and re-host the chrome.
   */
  var _prevStepperMode = null;
  function syncStepperLayout() {
    var mode = isStepperMode();
    if (mode === _prevStepperMode) return;
    _prevStepperMode = mode;
    if (!mode) {
      if (isStepperOpen()) closeStepper();
      if (elPreview && elSteps && elGrid) elSteps.insertBefore(elPreview, elGrid);
      if (elSteps) elSteps.hidden = false;
      if (elCta) elCta.hidden = false;
      // Reset any step-2/3 sub-panel display overrides so desktop shows
      // everything in its natural state (no inline display:none left over
      // from a stepper step-3 session).
      if (elGrid)     elGrid.style.display     = '';
      if (elCapacity) elCapacity.style.display = '';
      if (elPreview)  elPreview.style.display  = '';
      var cusPanel = elSteps && elSteps.querySelector('.bbx-step--customisations');
      if (cusPanel)  cusPanel.style.display   = '';
    } else if (!isStepperOpen()) {
      if (elPreview && elTeaserPrev) elTeaserPrev.appendChild(elPreview);
    }
    renderBuilderChrome();
    if (root.__bbx.renderTeaser) root.__bbx.renderTeaser();
  }

  var _stepperResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(_stepperResizeTimer);
    _stepperResizeTimer = setTimeout(syncStepperLayout, 150);
  });

  if (elSheetClose) elSheetClose.addEventListener('click', closeStepper);

  /**
   * Scroll an element into view in a way that works inside the sheet.
   *
   * Element.scrollIntoView() scrolls every scrollable ancestor, which handles
   * the sheet's own scroller correctly for elements INSIDE the builder body.
   * What it cannot do is scroll to the top of that body when the target IS the
   * body (editBundle and startNewBundle both scroll to [data-bbx-steps]) —
   * with the document locked that call silently does nothing.
   */
  function scrollToInBuilder(elm) {
    if (!elm) return;
    var tplPanel = root.querySelector('[data-bbx-templates]');
    if (isStepperOpen() && (elm === elSteps || elm === tplPanel)) {
      elm.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  root.__bbx.scrollToInBuilder = scrollToInBuilder;

  /**
   * Wire (once, at creation) and refresh (on every mod change) a step
   * item's back-nav affordance. Click/keydown are bound once — goToStep()
   * itself is the guard (no-op unless n < current step) — but the
   * role/tabindex/aria-label/cursor must be re-applied whenever a step's
   * mod changes between "done" (clickable) and "active"/"idle" (inert),
   * including on the lightweight refreshChrome() path that never rebuilds
   * the DOM. Shared by renderBuilderChrome() and refreshChrome() so there is
   * exactly one navigation path, per Fix 5's instruction to reuse the
   * back-button's goToStep rather than build a parallel system.
   */
  function bindStepNav(item, n, def, mod) {
    if (!item.__bbxNavBound) {
      item.__bbxNavBound = true;
      item.addEventListener('click', function () { goToStep(n); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          goToStep(n);
        }
      });
    }
    // A pill is clickable when data says that step is reachable — this covers
    // both backward navigation ('done' pills) and forward navigation to an
    // already-unlocked step ('idle' pills where canGoToStep(n) is true).
    // Forward navigation is deliberately STEPPER-ONLY: outside stepper mode
    // buildStepDefs() still returns the legacy 1..4 desktop trail whose steps
    // 3 and 4 the engine never navigates to, and canGoToStep() is
    // breakpoint-independent — so without this gate a desktop shopper could
    // click the previously-dead "Personal Touches" pill and write
    // state.step = 3, which then gets persisted by saveDraft and breaks the
    // "engine never sets state.step above 2" invariant desktop code relies on.
    var clickable = (mod === 'done')
      || (isStepperMode() && mod !== 'active' && canGoToStep(n));
    if (clickable) {
      item.classList.add('is-clickable');
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      var ariaKey = mod === 'done' ? 'chrome_step_back_aria' : 'chrome_step_go_aria';
      var ariaFallback = mod === 'done' ? 'Go back to %step%' : 'Go to %step%';
      item.setAttribute('aria-label', t(ariaKey, ariaFallback, { step: def.label }));
    } else {
      item.classList.remove('is-clickable');
      item.removeAttribute('role');
      item.removeAttribute('tabindex');
      item.removeAttribute('aria-label');
    }
  }

  /**
   * Render the dark-chocolate chrome bar (header + step pills) at the very top
   * of [data-bbx-steps]. Called once from init(); step pill classes are updated
   * by refreshChrome() whenever the active step changes.
   */
  function renderBuilderChrome() {
    var host = chromeHost();
    if (!host) return;
    // Scoped to root, not to the host: the host changes between the sheet bar
    // and [data-bbx-steps] on rotation, and a host-scoped query would leave a
    // second chrome bar behind in the old one.
    var existing = root.querySelector('.bbx-chrome');
    if (existing) existing.remove();

    var chromeStyle = cfg.chromeStyle || 'pills';
    var stepDefs = buildStepDefs();

    var chrome = el('div', { cls: 'bbx-chrome bbx-chrome--' + chromeStyle });

    // Header row
    var header = el('div', { cls: 'bbx-chrome__header' });
    var backBtn = el('button', {
      cls: 'bbx-chrome__back',
      attrs: { type: 'button', 'aria-label': t('chrome_back_aria', 'Back') },
      text: '←'
    });
    backBtn.addEventListener('click', function () {
      // goToStep(0) is now a real destination (the template picker), so back at
      // step 1 no longer needs its own inline reveal — and state.step stays in
      // sync with what is on screen.
      var cur = root.__bbx.state.step == null ? 1 : root.__bbx.state.step;
      goToStep(cur - 1);
    });
    header.appendChild(backBtn);

    var titles = el('div', { cls: 'bbx-chrome__titles' });
    titles.appendChild(el('div', {
      cls: 'bbx-chrome__title',
      text: t('chrome_title', 'Build Your Box')
    }));
    titles.appendChild(el('div', {
      cls: 'bbx-chrome__sub',
      text: t('chrome_sub', '4-step gifting builder')
    }));
    header.appendChild(titles);
    chrome.appendChild(header);

    // Step row — layout differs by chromeStyle
    var stepsRow = el('div', { cls: 'bbx-chrome__steps' });
    // `|| 1` was wrong: 0 is falsy, so step 0 rendered as step 1 active.
    var currentStep = root.__bbx.state.step == null ? 1 : root.__bbx.state.step;

    if (chromeStyle === 'progress') {
      // Progress style: numbered circles connected by horizontal lines
      stepDefs.forEach(function (def, idx) {
        // def.n drives navigation; idx + 1 drives the number the shopper reads,
        // so a step-0 pill shows "1" rather than "0".
        var n = def.n;
        var display = idx + 1;
        var mod = n < currentStep ? 'done' : (n === currentStep ? 'active' : 'idle');
        var item = el('div', { cls: 'bbx-chrome__step bbx-chrome__step--' + mod });
        var circle = el('div', { cls: 'bbx-chrome__step-circle' });
        circle.appendChild(el('span', {
          cls: 'bbx-chrome__step-num',
          text: mod === 'done' ? '✓' : String(display)
        }));
        item.appendChild(circle);
        item.appendChild(el('span', { cls: 'bbx-chrome__step-label', text: def.label }));
        bindStepNav(item, n, def, mod);
        stepsRow.appendChild(item);
        if (idx < stepDefs.length - 1) {
          stepsRow.appendChild(el('div', {
            cls: 'bbx-chrome__connector bbx-chrome__connector--' + (n < currentStep ? 'done' : 'idle')
          }));
        }
      });
    } else {
      // Pills style (default): equal-width pills spanning the full chrome bar
      stepDefs.forEach(function (def, idx) {
        var n = def.n;
        var display = idx + 1;
        var mod = n < currentStep ? 'done' : (n === currentStep ? 'active' : 'idle');
        var pill = el('div', { cls: 'bbx-chrome__step bbx-chrome__step--' + mod });
        pill.appendChild(el('span', {
          cls: 'bbx-chrome__step-num',
          text: mod === 'done' ? '✓' : String(display)
        }));
        // Must be a .bbx-chrome__step-label element, not a bare text node — the
        // narrow-screen CSS (<480px) hides this class on non-active pills so
        // the active step's full label doesn't get squeezed into ellipsis by
        // three equal-width pills. A bare text node was never matched by that
        // selector, so all three/four labels fought for space at once and the
        // active pill's highlight was unreadable in the resulting overflow.
        pill.appendChild(el('span', { cls: 'bbx-chrome__step-label', text: def.label }));
        bindStepNav(pill, n, def, mod);
        stepsRow.appendChild(pill);
      });
    }

    chrome.appendChild(stepsRow);
    host.insertBefore(chrome, host.firstChild);
    centerActiveChromeStep(false);
  }

  /**
   * Scroll the pill trail so the active step is centered — Sanjay's spec
   * (Aug 16 screenshot round): current step reads clearly in the middle,
   * neighbours only peek in at the edges (their 10%-wide flex-basis in the
   * pills CSS already reserves that peek; this is what brings the active
   * pill INTO that centered position after every step change). `smooth`
   * animates the scroll for step transitions; the initial chrome build
   * passes false so opening the sheet doesn't visibly slide.
   */
  function centerActiveChromeStep(smooth) {
    var stepsRow = root.querySelector('.bbx-chrome__steps');
    var activeEl = stepsRow && stepsRow.querySelector('.bbx-chrome__step--active');
    if (!activeEl) return;
    activeEl.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      inline: 'center',
      block: 'nearest'
    });
  }

  /**
   * Re-render only the step pills inside the existing chrome bar —
   * called when state.step changes without a full chrome re-render.
   */
  function refreshChrome() {
    var stepsRow = root.querySelector('.bbx-chrome__steps');
    if (!stepsRow) { renderBuilderChrome(); return; }

    // `|| 1` was wrong: 0 is falsy, so step 0 rendered as step 1 active.
    var currentStep = root.__bbx.state.step == null ? 1 : root.__bbx.state.step;
    var chromeStyle = cfg.chromeStyle || 'pills';
    var stepDefs = buildStepDefs();

    var steps = stepsRow.querySelectorAll('.bbx-chrome__step');
    // The trail can legitimately shrink mid-session — hasStep0() flips false as
    // soon as the first box is finished. Patching pills one-by-one against a
    // shorter def list would leave an orphaned pill wired to a stale step, so
    // rebuild instead.
    if (steps.length !== stepDefs.length) { renderBuilderChrome(); return; }

    steps.forEach(function (step, idx) {
      var def = stepDefs[idx];
      var n = def.n;
      var display = idx + 1;
      var mod = n < currentStep ? 'done' : (n === currentStep ? 'active' : 'idle');
      step.className = 'bbx-chrome__step bbx-chrome__step--' + mod;
      var numEl = step.querySelector('.bbx-chrome__step-num');
      if (numEl) numEl.textContent = mod === 'done' ? '✓' : String(display);
      bindStepNav(step, n, def, mod);
    });

    if (chromeStyle === 'progress') {
      var connectors = stepsRow.querySelectorAll('.bbx-chrome__connector');
      connectors.forEach(function (conn, idx) {
        var done = stepDefs[idx] && stepDefs[idx].n < currentStep;
        conn.className = 'bbx-chrome__connector bbx-chrome__connector--' + (done ? 'done' : 'idle');
      });
    }

    centerActiveChromeStep(true);
  }

  // ── Step 1: renderPackages() — Layer 1 ───────────────────────────────────

  /**
   * Render package selector cards into the builder's step region.
   * On selection, sets state.current.pkg, then shows Layer 2 (grid + capacity).
   */
  function renderPackages() {
    if (!elSteps) return;

    // Remove any existing package step
    var existing = elSteps.querySelector('.bbx-step--packages');
    if (existing) existing.remove();

    var step = el('div', { cls: 'bbx-step bbx-step--packages' });

    var hdr = el('h2', {
      cls: 'bbx-step__heading',
      text: t('step1_heading', 'Step 1: Choose Your Box')
    });
    step.appendChild(hdr);

    var sub = el('p', {
      cls: 'bbx-step__sub',
      text: t('step1_sub', 'Pick the size that\'s right for your gift.')
    });
    step.appendChild(sub);

    var grid = el('div', { cls: 'bbx-pkg-grid', attrs: { role: 'list' } });

    var packages = cfg.packages || [];

    if (!packages.length) {
      grid.appendChild(el('p', {
        cls: 'bbx-empty-state',
        text: t('pkg_no_packages', 'No packages available at the moment.')
      }));
    }

    packages.forEach(function (pkg) {
      var card = el('div', {
        cls: 'bbx-pkg-card',
        attrs: {
          role: 'listitem',
          tabindex: '0',
          'aria-label': pkg.name,
          'data-bbx-pkg-gid': pkg.gid
        }
      });

      // Image or letter placeholder
      var imgWrap = el('div', { cls: 'bbx-pkg-card__img-wrap' });
      if (pkg.image) {
        var img = el('img', {
          attrs: {
            src: pkg.image,
            alt: pkg.name,
            loading: 'lazy',
            width: '200',
            height: '200'
          }
        });
        img.className = 'bbx-pkg-card__img';
        imgWrap.appendChild(img);
      } else {
        var placeholder = el('div', {
          cls: 'bbx-pkg-card__img-placeholder',
          text: (pkg.name || 'B').charAt(0).toUpperCase()
        });
        imgWrap.appendChild(placeholder);
      }
      card.appendChild(imgWrap);

      // Name
      card.appendChild(el('p', { cls: 'bbx-pkg-card__name', text: pkg.name || '' }));

      // Weight capacity
      var capG = parseInt(pkg.weight_capacity_g, 10) || 0;
      var capLabel = capG >= 1000
        ? (capG / 1000) + 'kg'
        : capG + 'g';
      card.appendChild(el('p', {
        cls: 'bbx-pkg-card__cap',
        text: t('pkg_varieties', '%cap% · up to %max% varieties', { cap: capLabel, max: pkg.max_items || '?' })
      }));

      // Price — package.price is rupees decimal, ×100 → paise
      var pkgPriceP = Math.round((parseFloat(pkg.price) || 0) * 100);
      card.appendChild(el('p', {
        cls: 'bbx-pkg-card__price',
        text: money(pkgPriceP)
      }));

      // Select on click or Enter/Space keypress
      function selectPkg() {
        // Deselect others
        grid.querySelectorAll('.bbx-pkg-card').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');

        // Re-selecting the package that's already active (e.g. navigating back
        // to Package then forward to this same card — the only way to reach
        // step 1 doesn't leave any card visibly marked selected) must NOT wipe
        // items/customisations already in the box, whether from a template's
        // seeding or the shopper's own picks. Only a genuinely different
        // package resets the box.
        var cur = root.__bbx.state.current;
        var samePkg = cur.pkg && cur.pkg.gid === pkg.gid;

        if (!samePkg) {
          // Set state. Every gift box defaults to the "Ribbon" category add-on
          // pre-selected (Sanjay: gift trays ship with a ribbon+flower by
          // default) — templates get this from their own product-level
          // custom.bundle_addons (applyTemplate reads tpl.addon_gids); a
          // freehand package pick has no template to read from, so default it
          // here from cfg.customisations directly. Same shared helper either way.
          cur.pkg = pkg;
          cur.items = [];
          cur.customisations = defaultCustomisations();
        }

        // Advance step indicator to step 2
        root.__bbx.state.step = 2;
        // Route the panels, don't just move the step number. Without this the
        // grid/capacity/preview keep whatever display showStepPanel() last set
        // — so arriving at step 2 from a step-1 screen that had them hidden
        // (pill nav back to Package, or the banner's "Change" link) rendered a
        // BLANK Dry Fruits step: cards built by renderGrid() below, but the
        // container still display:none.
        showStepPanel(2);
        refreshChrome();
        syncCtaText();

        // Collapse the package grid to a compact banner
        var pkgStep = elSteps.querySelector('.bbx-step--packages');
        if (pkgStep) pkgStep.style.display = 'none';
        renderPkgBanner(pkg);

        // Advance: show grid + capacity
        renderGrid();
        // renderGrid() only renders the featured/per-package collection — any
        // preserved item (samePkg branch above) outside that set needs its own
        // card, same as applyTemplate()'s seeded items.
        ensureSeededItemCards(pkg);
        renderCapacity();
        renderCustomisations();

        // Scroll to grid (smooth)
        if (elGrid) {
          setTimeout(function () { scrollToInBuilder(elGrid); }, 80);
        }
      }

      card.addEventListener('click', selectPkg);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPkg(); }
      });

      grid.appendChild(card);
    });

    step.appendChild(grid);
    var chromeEl = elSteps.querySelector('.bbx-chrome');
    if (chromeEl && chromeEl.nextSibling) {
      elSteps.insertBefore(step, chromeEl.nextSibling);
    } else if (chromeEl) {
      elSteps.appendChild(step);
    } else {
      elSteps.insertBefore(step, elSteps.firstChild);
    }
  }

  // ── Gap 2: Package banner (compact, after selection) ─────────────────────

  /**
   * Render a compact package banner above the capacity bar after a package is
   * selected. Has a "Change" link that re-shows the package grid.
   */
  function renderPkgBanner(pkg) {
    if (!elSteps) return;
    var existing = elSteps.querySelector('.bbx-pkg-banner');
    if (existing) existing.remove();

    var capG = parseInt(pkg.weight_capacity_g, 10) || 0;
    var maxItems = parseInt(pkg.max_items, 10) || 0;
    var capLabel = capG >= 1000
      ? (capG / 1000).toFixed(capG % 1000 === 0 ? 0 : 1) + 'kg'
      : capG + 'g';

    var banner = el('div', { cls: 'bbx-pkg-banner' });

    banner.appendChild(el('div', { cls: 'bbx-pkg-banner__icon', text: '🪵' }));

    var info = el('div', { cls: 'bbx-pkg-banner__info' });
    info.appendChild(el('div', { cls: 'bbx-pkg-banner__name', text: pkg.name || '' }));
    info.appendChild(el('div', {
      cls: 'bbx-pkg-banner__sub',
      text: t('pkg_banner_sub', 'Up to %items% items · %cap% total', {
        items: maxItems,
        cap: capLabel
      })
    }));
    var pkgBannerPriceP = Math.round((parseFloat(pkg.price) || 0) * 100);
    if (pkgBannerPriceP > 0) {
      info.appendChild(el('div', { cls: 'bbx-pkg-banner__price', text: money(pkgBannerPriceP) }));
    }
    banner.appendChild(info);

    var changeBtn = el('button', {
      cls: 'bbx-pkg-banner__change',
      attrs: { type: 'button' },
      text: t('pkg_change', 'Change')
    });
    changeBtn.addEventListener('click', function () {
      // Remove banner and re-show package grid
      banner.remove();
      var pkgStep = elSteps.querySelector('.bbx-step--packages');
      if (pkgStep) pkgStep.style.display = '';

      // Reset state and step
      root.__bbx.state.current.pkg = null;
      root.__bbx.state.current.items = [];
      root.__bbx.state.current.customisations = [];
      root.__bbx.state.step = 1;
      refreshChrome();

      // Clear grid, capacity, customisations
      if (elGrid) elGrid.innerHTML = '';
      renderCapacity();
      var custStep = elSteps.querySelector('.bbx-step--customisations');
      if (custStep) custStep.remove();
      refreshCta();
    });
    banner.appendChild(changeBtn);

    // Insert banner: always before the static capacity bar so it sits
    // above the progress track and grid regardless of whether the package
    // step or chrome are present in the DOM (edit-bundle re-entry included).
    var insertRef = elCapacity || elSteps.firstChild;
    elSteps.insertBefore(banner, insertRef);
  }

  // ── Step 2: renderGrid() — Layer 2 (top-N product grid) ─────────────────

  /**
   * Returns the product list for the currently-selected package.
   *
   * A package's `recommended_products` are emitted by Liquid as full product
   * objects in the recommended collection's own (merchant-sorted) order, so
   * they are returned as-is. Falls back to cfg.featuredProducts when a package
   * has no recommended collection.
   *
   * Historical note: this previously filtered cfg.allProducts (never emitted)
   * by a GID set built from a *different* collection, so the intersection was
   * usually empty and per-package recommendation never worked.
   */
  function getProductsForCurrentPkg() {
    var pkg = root.__bbx.state.current && root.__bbx.state.current.pkg;
    if (pkg && pkg.recommended_products && pkg.recommended_products.length > 0) {
      return pkg.recommended_products;
    }
    return cfg.featuredProducts || [];
  }

  /**
   * Render the featured product selection grid into [data-bbx-grid].
   * Includes Add/Remove toggles, info button placeholders, and "Browse all" card.
   */
  function renderGrid() {
    if (!elGrid) return;
    elGrid.innerHTML = '';

    var state   = root.__bbx.state.current;
    var pkg     = state.pkg;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;
    var products = getProductsForCurrentPkg();

    // Products whose variant titles carry no parseable weight cannot be priced.
    // They previously rendered a card reading "Setup required" with Shopify
    // Admin instructions — customer-facing admin language. Omit them instead.
    var usable = [];
    var skipped = [];
    products.forEach(function (p) {
      if (productHasWeightTitle(p)) usable.push(p); else skipped.push(p.title || p.handle || p.id);
    });
    if (skipped.length) {
      console.warn('[bbx] Hidden from builder — no parseable weight in variant titles: ' + skipped.join(', '));
    }
    var totalProducts = usable.length; // count before slicing (drawer shows the rest)

    usable.forEach(function (product) {
      var card = buildProductCard(product, maxItems);
      elGrid.appendChild(card);
    });

    if (!usable.length) {
      elGrid.appendChild(el('p', {
        cls: 'bbx-grid-empty',
        text: t('grid_all_filtered', 'Browse all varieties to get started')
      }));
    }

    // "Browse all N varieties" card (stub for Task 9 drawer)
    var browseCard = el('div', {
      cls: 'bbx-grid-card bbx-grid-card--browse',
      attrs: {
        role: 'button',
        tabindex: '0',
        'aria-label': t('browse_all', 'Browse all varieties')
      }
    });
    browseCard.innerHTML =
      '<span class="bbx-browse-icon" aria-hidden="true">+</span>' +
      '<div>' +
        '<span class="bbx-browse-label">' + t('browse_all', 'Browse all varieties') + '</span>' +
        '<span class="bbx-browse-count">' + t('browse_hint', 'Search, filter by type, multi-select') + '</span>' +
      '</div>';
    browseCard.addEventListener('click', function () {
      if (root.__bbx.openDrawer) {
        root.__bbx.openDrawer();
      } else {
        console.log('[bbx] openDrawer stub — Task 9 not yet loaded');
      }
    });
    browseCard.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (root.__bbx.openDrawer) root.__bbx.openDrawer();
        else console.log('[bbx] openDrawer stub');
      }
    });
    elGrid.appendChild(browseCard);

    // §25: rebuild slider dots / arrows to match the new card set
    refreshSliderControls();
  }

  // ── §25: slider dots (mobile) + arrows (tablet) controller ───────────────
  // Dots are a decorative paging affordance (aria-hidden, non-focusable); the
  // scroll-snap rail itself stays keyboard/touch navigable. Tablet arrows are
  // real, labelled controls (rendered in Liquid). Idempotent; safe to re-run.
  //
  // Generalised (Task 15) to drive any scroll-snap track sharing this markup
  // shape (.bbx-grid-dot / .bbx-grid-arrow), so the template picker track
  // (Task 14) can reuse it instead of a second hand-rolled controller. Each
  // track gets its own instance with its own bound-state closure.
  var elGridDots   = root.querySelector('[data-bbx-grid-dots]');
  var elGridArrows = root.querySelector('[data-bbx-grid-arrows]');

  /**
   * Build a dots/arrows refresh() function for one scroll-snap track.
   * @param {{track:Element, dots:Element, arrows:Element, arrowAttr:string,
   *          mobileAttr:string, tabletAttr:string, showDotsAttr:string, showArrowsAttr:string}} opts
   * @returns {Function} refresh() — rebuild dots + toggle arrows for this track.
   */
  function makeSliderController(opts) {
    var track   = opts.track;
    var dotsEl  = opts.dots;
    var arrowsEl = opts.arrows;
    var bound = false;

    /** Active slider mode for the current viewport, or null. */
    function mode() {
      if (!track) return null;
      var w = window.innerWidth;
      if (w <= 749 && root.getAttribute(opts.mobileAttr) === 'slider') return 'mobile';
      if (w >= 750 && w <= 1023 && root.getAttribute(opts.tabletAttr) === 'slider') return 'tablet';
      return null;
    }

    /** Scroll distance for one card = first card width + inter-card gap. */
    function cardStep() {
      var first = track && track.firstElementChild;
      if (!first) return 0;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    /** Highlight the dot matching the current scroll position. */
    function updateActiveDot() {
      if (!dotsEl) return;
      var dots = dotsEl.querySelectorAll('.bbx-grid-dot');
      if (!dots.length) return;
      var step = cardStep();
      var idx = step ? Math.round(track.scrollLeft / step) : 0;
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }

    /** Rebuild dots (mobile) and toggle arrows (tablet) to match the live track. */
    function refresh() {
      var m = mode();

      // Dots — mobile slider only, when enabled
      if (dotsEl) {
        var showDots = root.getAttribute(opts.showDotsAttr) === 'true';
        dotsEl.innerHTML = '';
        // Mirror the CSS exactly (see the three .bbx-tpl-card display rules in
        // the section): a card is visible when it is NOT search-filtered AND
        // (it is not reveal-limit-hidden OR a search is active, because the
        // .bbx-templates--searching override at (1,3,0) lifts --hidden).
        // Counting --hidden alone painted dots for filtered-out cards and
        // skipped matches revealed by an active search.
        var _searching = !!root.querySelector('[data-bbx-templates].bbx-templates--searching');
        var visibleCount = track ? Array.prototype.filter.call(track.children, function (c) {
          if (c.classList.contains('bbx-tpl-card--filtered')) return false;
          return _searching || !c.classList.contains('bbx-tpl-card--hidden');
        }).length : 0;
        if (m === 'mobile' && showDots && visibleCount) {
          var n = visibleCount;
          for (var i = 0; i < n; i++) {
            (function (idx) {
              var dot = el('button', {
                cls: 'bbx-grid-dot' + (idx === 0 ? ' is-active' : ''),
                attrs: { type: 'button', tabindex: '-1', 'aria-hidden': 'true' }
              });
              dot.addEventListener('click', function () {
                track.scrollTo({ left: cardStep() * idx, behavior: 'smooth' });
              });
              dotsEl.appendChild(dot);
            })(i);
          }
          updateActiveDot();
        }
      }

      // Arrows — tablet slider only, when enabled
      if (arrowsEl) {
        var showArrows = root.getAttribute(opts.showArrowsAttr) === 'true';
        arrowsEl.style.display = (m === 'tablet' && showArrows) ? '' : 'none';
      }

      // Bind scroll / resize / arrow clicks once per track
      if (!bound && track) {
        bound = true;
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = null; updateActiveDot(); });
        }, { passive: true });
        var rt = null;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(refresh, 150);
        });
        if (arrowsEl) {
          var prev = arrowsEl.querySelector('[' + opts.arrowAttr + '="prev"]');
          var next = arrowsEl.querySelector('[' + opts.arrowAttr + '="next"]');
          if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
          if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
        }
      }
    }

    return refresh;
  }

  /** Product grid track — default instance, same behaviour as before Task 15. */
  var refreshSliderControls = makeSliderController({
    track: elGrid, dots: elGridDots, arrows: elGridArrows,
    arrowAttr: 'data-bbx-arrow',
    mobileAttr: 'data-bbx-mobile-layout', tabletAttr: 'data-bbx-tablet-layout',
    showDotsAttr: 'data-bbx-show-dots', showArrowsAttr: 'data-bbx-show-arrows'
  });

  /** Template picker track (Task 14 markup) — null-safe when the picker is off. */
  var refreshTemplateSliderControls = makeSliderController({
    track: root.querySelector('[data-bbx-templates-grid]'),
    dots: root.querySelector('[data-bbx-templates-dots]'),
    arrows: root.querySelector('[data-bbx-templates-arrows]'),
    arrowAttr: 'data-bbx-templates-arrow',
    mobileAttr: 'data-bbx-template-layout', tabletAttr: 'data-bbx-template-layout-tablet',
    showDotsAttr: 'data-bbx-template-show-dots', showArrowsAttr: 'data-bbx-template-show-arrows'
  });

  /**
   * Build a single product card for the grid.
   * Used by renderGrid() and the drawer (Task 9 will call this too).
   *
   * @param {object} product
   * @param {number} maxItems
   * @returns {HTMLElement}
   */
  function buildProductCard(product, maxItems) {
    var state         = root.__bbx.state.current;
    var isAdded       = state.items.some(function (it) { return it.product.id === product.id; });
    var isFull        = state.items.length >= maxItems;
    var match         = isAdded ? state.items.find(function (it) { return it.product.id === product.id; }) : null;
    // Callers only pass products that already passed productHasWeightTitle()
    // (renderGrid filters those out before invoking this) — no unavailable
    // state to render here.

    var cardCls = 'bbx-grid-card';
    if (isAdded) cardCls += ' is-added';

    var card = el('div', {
      cls: cardCls,
      attrs: {
        role: 'listitem',
        tabindex: '0',
        'data-bbx-product-id': product.id,
        'aria-label': (product.title || '') + (isAdded ? ' (' + t('card_added_state', 'added') + ')' : ''),
        'aria-pressed': isAdded ? 'true' : 'false'
      }
    });

    // ── Image area (fixed 82px height) ───────────────────────────────────────
    var imgWrap = el('div', { cls: 'bbx-grid-card__img-wrap' });

    if (product.featured_image) {
      var img = el('img', {
        attrs: {
          src: product.featured_image,
          alt: product.title || '',
          loading: 'lazy',
          width: '200',
          height: '200'
        }
      });
      img.className = 'bbx-grid-card__img';
      imgWrap.appendChild(img);
    } else {
      imgWrap.appendChild(el('div', {
        cls: 'bbx-grid-card__img-placeholder',
        text: (product.title || 'P').charAt(0).toUpperCase()
      }));
    }

    // Check badge — only when added
    if (isAdded) {
      imgWrap.appendChild(el('div', { cls: 'bbx-grid-card__check-badge', text: '✓' }));
    }

    // Info button — absolute top-right inside imgWrap, 20px bordered circle
    var infoBtn = el('button', {
      cls: 'bbx-info-btn',
      attrs: {
        type: 'button',
        'data-bbx-info': product.id,
        'aria-label': t('info_aria', 'Info about %title%', { title: product.title || 'this product' })
      },
      text: 'i'
    });
    // Stop card-click from firing when info is tapped
    infoBtn.addEventListener('click', function (e) { e.stopPropagation(); });
    imgWrap.appendChild(infoBtn);

    card.appendChild(imgWrap);

    // ── Body ─────────────────────────────────────────────────────────────────
    var body = el('div', { cls: 'bbx-grid-card__body' });

    body.appendChild(el('p', { cls: 'bbx-grid-card__title', text: displayName(product) }));

    // Vendor or first tag as sub-line
    var subText = product.vendor || (product.tags && product.tags[0]) || '';
    body.appendChild(el('p', { cls: 'bbx-grid-card__sub', text: subText }));

    if (isAdded) {
      // Show allocated price
      body.appendChild(el('p', {
        cls: 'bbx-grid-card__price',
        text: money(match ? match.priceP : 0)
      }));
      // Alloc line — kept alive with data-bbx-readout for refreshGridCardStates()
      var allocEl = el('p', { cls: 'bbx-grid-card__alloc' });
      allocEl.setAttribute('data-bbx-readout', product.id);
      allocEl.textContent = t('alloc_share', '%g%g share', { g: match ? match.allocatedG : 0 });
      body.appendChild(allocEl);
    } else {
      // "+ Add" in gold
      body.appendChild(el('p', {
        cls: 'bbx-grid-card__price-add',
        text: '+ ' + t('add', 'Add')
      }));
      // Would-get hint
      var pkg   = state.pkg;
      var capG  = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
      var wouldGetG = capG > 0 && !isFull
        ? evenSplit(capG, state.items.length + 1)[0]
        : 0;
      var hintEl = el('p', { cls: 'bbx-grid-card__alloc' });
      hintEl.setAttribute('data-bbx-readout', product.id);
      hintEl.textContent = wouldGetG > 0
        ? t('would_get', 'Would get %weight% each', { weight: wouldGetG + 'g' })
        : '';
      body.appendChild(hintEl);
    }

    card.appendChild(body);

    // ── Card-level click (add / remove) — no separate toggle button ──────────
    card.addEventListener('click', function (e) {
      var cur = root.__bbx.state.current;
      var idx = cur.items.findIndex(function (it) { return it.product.id === product.id; });
      if (idx !== -1) {
        cur.items.splice(idx, 1);
      } else {
        if (cur.items.length >= maxItems) return;
        cur.items.push({ product: product, allocatedG: 0, priceP: 0 });
      }
      rebalance();
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.click();
      }
    });

    return card;
  }

  /**
   * Prepend a grid card for every state.current.items entry the grid doesn't
   * already show. renderGrid() only ever renders getProductsForCurrentPkg()
   * (the featured/per-package collection), so any seeded or freehand item
   * outside that set would otherwise have no card at all — capacity/price
   * still counts it, but the shopper sees no "added" state for it. Shared by
   * applyTemplate() (template-seeded items) and selectPkg() (re-selecting an
   * already-active package must not lose items the grid rebuild dropped).
   */
  function ensureSeededItemCards(pkg) {
    var cur = root.__bbx.state.current;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;
    var elGridEl = root.querySelector('[data-bbx-grid]');
    if (!elGridEl) return;
    cur.items.slice().reverse().forEach(function (it) {
      if (elGridEl.querySelector('[data-bbx-product-id="' + it.product.id + '"]')) return;
      elGridEl.insertBefore(buildProductCard(it.product, maxItems), elGridEl.firstChild);
    });
    refreshSliderControls();
  }

  // ── Step 3: rebalance() ──────────────────────────────────────────────────

  /**
   * Recompute even weight split across current items.
   * Updates each item's allocatedG + priceP.
   * Refreshes capacity pips, readout labels on cards, and calls renderPreview hook.
   */
  function rebalance() {
    var state    = root.__bbx.state.current;
    var pkg      = state.pkg;
    var capG     = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;
    var items    = state.items;
    var splits   = evenSplit(capG, items.length);

    items.forEach(function (item, i) {
      item.allocatedG = splits[i] || 0;
      item.priceP     = allocatedPrice(item.product, item.allocatedG);
    });

    var perItemG = splits.length > 0 ? (splits[0] || 0) : 0;

    // Refresh capacity pips
    renderCapacity();

    // Refresh per-item readouts on cards in [data-bbx-grid]
    refreshGridCardStates(maxItems);

    // Task 8 hook — guard since it doesn't exist yet
    if (root.__bbx.renderPreview) {
      root.__bbx.renderPreview();
    }

    // Enable/disable Done button and update CTA price summary
    refreshCta();

    // Announce weight update to screen readers (debounced — coalesces rapid changes)
    if (items.length > 0 && splits.length > 0) {
      announceToSR(t('weight_rebalanced', 'Weights updated: %weight% per item', { weight: perItemG + 'g' }));
    }
  }

  /**
   * After rebalance, update toggle buttons and readout spans inside [data-bbx-grid]
   * without doing a full grid re-render (avoids DOM thrash).
   *
   * @param {number} maxItems
   */
  function refreshGridCardStates(maxItems) {
    if (!elGrid) return;
    var state  = root.__bbx.state.current;
    var isFull = state.items.length >= maxItems;
    var pkg    = state.pkg;
    var capG   = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;

    elGrid.querySelectorAll('[data-bbx-product-id]').forEach(function (card) {
      var pid     = parseInt(card.getAttribute('data-bbx-product-id'), 10);
      var match   = state.items.find(function (it) { return it.product.id === pid; });
      var isAdded = !!match;

      // Card-level state
      card.classList.toggle('is-added', isAdded);
      card.setAttribute('aria-pressed', isAdded ? 'true' : 'false');

      var imgWrap = card.querySelector('.bbx-grid-card__img-wrap');

      // ── Check badge (add / remove) ──────────────────────────────────────────
      var checkBadge = card.querySelector('.bbx-grid-card__check-badge');
      if (isAdded && !checkBadge && imgWrap) {
        var newCheck = document.createElement('div');
        newCheck.className = 'bbx-grid-card__check-badge';
        newCheck.textContent = '✓';
        imgWrap.appendChild(newCheck);
      } else if (!isAdded && checkBadge) {
        checkBadge.remove();
      }

      // ── Price / "+ Add" swap ────────────────────────────────────────────────
      var priceEl    = card.querySelector('.bbx-grid-card__price');
      var priceAddEl = card.querySelector('.bbx-grid-card__price-add');
      var body       = card.querySelector('.bbx-grid-card__body');

      if (isAdded) {
        // Remove "+ Add" element if present
        if (priceAddEl) priceAddEl.remove();
        // Add / update price element
        if (!priceEl && body) {
          priceEl = document.createElement('p');
          priceEl.className = 'bbx-grid-card__price';
          // Insert before the alloc element
          var allocEl = body.querySelector('[data-bbx-readout]');
          body.insertBefore(priceEl, allocEl || null);
        }
        if (priceEl) priceEl.textContent = money(match ? match.priceP : 0);
      } else {
        // Remove price element if present
        if (priceEl) priceEl.remove();
        // Add / update "+ Add" element
        if (!priceAddEl && body) {
          priceAddEl = document.createElement('p');
          priceAddEl.className = 'bbx-grid-card__price-add';
          // Insert before the alloc element
          var allocHint = body.querySelector('[data-bbx-readout]');
          body.insertBefore(priceAddEl, allocHint || null);
        }
        // A full box used to keep advertising "+ Add" on every other card,
        // while the click handler silently `return`ed — the shopper tapped and
        // nothing happened, with no explanation. Show the real reason instead.
        if (priceAddEl) {
          priceAddEl.textContent = isFull
            ? t('card_box_full', 'Box full')
            : '+ ' + t('add', 'Add');
        }
      }

      // Card-level affordance for the same state: dim it, mark it disabled for
      // assistive tech, and drop it out of the tab order. Cards already in the
      // box are NEVER disabled — tapping those removes an item, which is the
      // shopper's way out of a full box.
      card.classList.toggle('is-unavailable', isFull && !isAdded);
      if (isFull && !isAdded) {
        card.setAttribute('aria-disabled', 'true');
        card.setAttribute('tabindex', '-1');
      } else {
        card.removeAttribute('aria-disabled');
        card.setAttribute('tabindex', '0');
      }

      // ── Alloc / would-get readout ───────────────────────────────────────────
      var readout = card.querySelector('[data-bbx-readout]');
      if (readout) {
        if (isAdded) {
          readout.textContent = t('alloc_share', '%g%g share', { g: match ? match.allocatedG : 0 });
        } else {
          var wouldGetG = capG > 0 && !isFull
            ? evenSplit(capG, state.items.length + 1)[0]
            : 0;
          readout.textContent = wouldGetG > 0
            ? t('would_get', 'Would get %weight% each', { weight: wouldGetG + 'g' })
            : '';
        }
      }
    });

    // Update CTA state
    refreshCta();
  }

  /** Enable/disable the Add to Cart CTA and populate the two-row summary. */
  function refreshCta() {
    if (!elCta) return;
    // The complete screen owns the CTA (see setReviewOrderCta). `current` is
    // empty there by design, so letting this run would disable the one button
    // that reaches checkout.
    if (root.querySelector('.bbx-complete-screen')) return;
    var ctaBtn  = elCta.querySelector('.bbx-cta-btn');
    var state   = root.__bbx.state.current;
    var hasItems = state.items.length > 0;

    if (ctaBtn) ctaBtn.disabled = !hasItems;

    var summaryEl = elCta.querySelector('[data-bbx-cta-summary]');
    if (!summaryEl) return;

    summaryEl.style.display = hasItems ? 'flex' : 'none';
    if (!hasItems) return;

    var pkg      = state.pkg;
    var count    = state.items.length;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;
    var capG     = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
    var perItemG = count > 0 && capG > 0 ? Math.floor(capG / count) : 0;
    var slotsLeft = maxItems - count;

    var itemsTotal = state.items.reduce(function (s, it) { return s + (it.priceP || 0); }, 0);
    var custTotal  = state.customisations.reduce(function (s, c) { return s + (c.priceP || 0); }, 0);
    var pkgPriceP  = pkg ? Math.round((parseFloat(pkg.price) || 0) * 100) : 0;
    var grandTotal = itemsTotal + custTotal + pkgPriceP;

    var itemsEl = elCta.querySelector('[data-bbx-cta-items]');
    if (itemsEl) {
      itemsEl.innerHTML =
        '<strong>' + (count === 1
          ? t('items_count', '%count% item', { count: count })
          : t('items_count_plural', '%count% items', { count: count })
        ) + '</strong>' +
        (perItemG > 0 ? ' · ' + t('each_weight', '%weight% each', { weight: perItemG + 'g' }) : '') +
        (slotsLeft > 0 ? ' · ' + (slotsLeft === 1
          ? t('slots_left', '%count% slot left', { count: slotsLeft })
          : t('slots_left_plural', '%count% slots left', { count: slotsLeft })
        ) : '');

      // Pulse the existing weight text when it changes, so adding/removing an
      // item still has an on-screen cue now that the floating "Weights
      // updated" note is gone (the SR announcement in rebalance() is unaffected).
      var reducedMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion && perItemG > 0 && _bbxPrevPerItemG !== null && perItemG !== _bbxPrevPerItemG) {
        itemsEl.classList.remove('bbx-cta-items--changed');
        void itemsEl.offsetWidth; // restart animation on rapid consecutive changes
        itemsEl.classList.add('bbx-cta-items--changed');
        clearTimeout(_bbxCtaChangeTimer);
        _bbxCtaChangeTimer = setTimeout(function () {
          itemsEl.classList.remove('bbx-cta-items--changed');
        }, 1200);
      }
      if (perItemG > 0) _bbxPrevPerItemG = perItemG;
    }

    var totalEl = elCta.querySelector('[data-bbx-cta-total]');
    if (totalEl) totalEl.textContent = money(grandTotal);

    var noteEl = elCta.querySelector('[data-bbx-cta-note]');
    if (noteEl && pkg) {
      var noteText = money(pkgPriceP) + ' box';
      if (itemsTotal > 0) noteText += ' + ' + money(itemsTotal) + ' items';
      if (custTotal  > 0) noteText += ' + ' + money(custTotal)  + ' add-ons';
      noteEl.textContent = noteText;
    }

    var taxNoteEl = elCta.querySelector('[data-bbx-cta-tax-note]');
    if (taxNoteEl) {
      if (cfg.taxesIncluded === true) {
        taxNoteEl.textContent = t('taxes_note_after', '* Prices inclusive of GST');
        taxNoteEl.classList.add('is-visible');
      } else if (cfg.taxesIncluded === false) {
        taxNoteEl.textContent = t('taxes_note_before', '* Prices before GST · tax at checkout');
        taxNoteEl.classList.add('is-visible');
      }
    }
  }

  // ── Step 4: renderCapacity() — item-count pips ───────────────────────────

  /**
   * Render the segmented capacity track into [data-bbx-capacity].
   * Replaces the old pip-circle design with the mockup's segment bar + ticks + hint.
   * The old .bbx-pips CSS is kept in the Liquid for any external references,
   * but this function no longer generates pip HTML.
   */
  function renderCapacity() {
    if (!elCapacity) return;

    var state    = root.__bbx.state.current;
    var pkg      = state.pkg;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 0) : 0;
    var count    = state.items.length;
    var capG     = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
    var isFull   = count >= maxItems && maxItems > 0;

    if (!pkg) {
      // No package selected — show a minimal placeholder
      elCapacity.innerHTML =
        '<p class="bbx-pips__label">' +
          t('capacity_no_package', 'Select a package to begin.') +
        '</p>';
      elCapacity.setAttribute('aria-hidden', 'false');
      return;
    }

    // ── Label row ────────────────────────────────────────────────────────────
    var usedG = state.items.reduce(function (s, it) { return s + (it.allocatedG || 0); }, 0);
    var usedLabel = usedG >= 1000
      ? (usedG / 1000).toFixed(1) + 'kg'
      : usedG + 'g';
    var capLabel  = capG >= 1000
      ? (capG / 1000).toFixed(capG % 1000 === 0 ? 0 : 1) + 'kg'
      : capG + 'g';

    var topHtml =
      '<div class="bbx-cap-top">' +
        '<span class="bbx-cap-label">' + (isFull
          ? t('capacity_full_short', 'Full · %total%', { total: capLabel })
          : t('capacity_used', '%used% / %total% used', { used: usedLabel, total: capLabel })) + '</span>' +
        '<span class="bbx-cap-pill">' + t('items_used', '%count% of %total% items', { count: count, total: maxItems }) + '</span>' +
      '</div>';

    // ── Segment track ─────────────────────────────────────────────────────────
    var trackHtml = '<div class="bbx-cap-track">';
    var segColors = ['bbx-cs-1', 'bbx-cs-2', 'bbx-cs-3', 'bbx-cs-4'];
    state.items.forEach(function (item, idx) {
      var pct = capG > 0 ? ((item.allocatedG || 0) / capG * 100).toFixed(2) : 0;
      var cls = segColors[idx % segColors.length];
      trackHtml += '<div class="bbx-cs ' + cls + '" style="width:' + pct + '%"></div>';
    });
    trackHtml += '</div>';

    // ── Tick labels ───────────────────────────────────────────────────────────
    function fmtG(g) {
      return g >= 1000 ? (g / 1000).toFixed(g % 1000 === 0 ? 0 : 1) + 'kg' : g + 'g';
    }
    var tickHtml =
      '<div class="bbx-cap-ticks">' +
        '<span class="bbx-ct">0</span>' +
        '<span class="bbx-ct">' + fmtG(Math.round(capG / 4)) + '</span>' +
        '<span class="bbx-ct">' + fmtG(Math.round(capG / 2)) + '</span>' +
        '<span class="bbx-ct">' + fmtG(Math.round(capG * 3 / 4)) + '</span>' +
        '<span class="bbx-ct">' + fmtG(capG) + '</span>' +
      '</div>';

    // ── Hint line ─────────────────────────────────────────────────────────────
    var hintHtml = '';
    if (!isFull && maxItems > 0) {
      var slotsLeft = maxItems - count;
      var perItemG  = count < maxItems && maxItems > 0
        ? Math.floor(capG / maxItems)
        : 0;
      var slotsStr = slotsLeft === 1
        ? t('slots_left', '%count% slot left', { count: slotsLeft })
        : t('slots_left_plural', '%count% slots left', { count: slotsLeft });
      hintHtml =
        '<div class="bbx-cap-hint">' +
          t('capacity_hint', '%slots% — add more for %weight% each', { slots: slotsStr, weight: fmtG(perItemG) }) +
        '</div>';
    }

    elCapacity.innerHTML = topHtml + trackHtml + tickHtml + hintHtml;
    elCapacity.setAttribute('aria-hidden', 'false');
  }

  // ── Step 5: renderCustomisations() — Layer 3 ─────────────────────────────

  /**
   * Bind (once) a document-level click listener that closes any tap-opened
   * chip tooltip when the customer taps elsewhere. Hover/focus-within (CSS)
   * handle their own dismissal; this only covers the touch tap-to-open path.
   * Idempotent — safe to call on every renderCustomisations() pass.
   */
  var _bbxTooltipDismissBound = false;
  function bindChipTooltipDismiss() {
    if (_bbxTooltipDismissBound) return;
    _bbxTooltipDismissBound = true;
    document.addEventListener('click', function (e) {
      var openWraps = root.querySelectorAll('.bbx-chip-wrap.is-tooltip-open');
      openWraps.forEach(function (w) {
        if (!w.contains(e.target)) w.classList.remove('is-tooltip-open');
      });
    });
  }

  /**
   * Render customisation toggle chips into a step after the grid.
   * Multi-select up to the layer's max_selections.
   */
  function renderCustomisations() {
    if (!elSteps) return;

    var existing = elSteps.querySelector('.bbx-step--customisations');
    if (existing) existing.remove();

    var customisations = cfg.customisations || [];
    if (!customisations.length) return;

    var maxSel = custMaxSelections();
    var state  = root.__bbx.state.current;

    var step = el('div', { cls: 'bbx-step bbx-step--customisations' });

    step.appendChild(el('h2', {
      cls: 'bbx-step__heading',
      text: t('step3_heading', 'Step 3: Personal Touches (Optional)')
    }));

    step.appendChild(el('p', {
      cls: 'bbx-step__sub',
      text: maxSel === 99
        ? t('step3_sub_unlimited', 'Add a ribbon, message card, or gift wrap.')
        : t('step3_sub_limited', 'Choose up to %max% add-ons.', { max: maxSel })
    }));

    var chips = el('div', { cls: 'bbx-chips', attrs: { role: 'group', 'aria-label': t('customisations_label', 'Customisation options') } });

    customisations.forEach(function (cust, custIdx) {
      var isSelected = state.customisations.some(function (c) {
        return c.customisation.gid === cust.gid;
      });

      // Chip is wrapped so the variable-colour tooltip (a sibling, not a
      // nested button) can be positioned relative to it without nesting a
      // button inside a button (.bbx-chip is itself a <button>).
      var wrap = el('span', { cls: 'bbx-chip-wrap' });

      var chip = el('button', {
        cls: 'bbx-chip' + (isSelected ? ' is-selected' : '') + (cust.image ? ' bbx-chip--has-img' : ''),
        attrs: {
          type: 'button',
          'aria-pressed': isSelected ? 'true' : 'false',
          'data-bbx-cust-gid': cust.gid,
          'aria-label': cust.name
        }
      });

      if (cust.image) {
        var img = el('img', {
          attrs: { src: cust.image, alt: '', loading: 'lazy', width: '24', height: '24' }
        });
        img.className = 'bbx-chip__img';
        chip.appendChild(img);
      }

      chip.appendChild(el('span', { cls: 'bbx-chip__label', text: cust.name || '' }));

      // Price — customisation.price is rupees decimal, ×100 → paise
      var custPriceP = Math.round((parseFloat(cust.price) || 0) * 100);
      if (custPriceP > 0) {
        chip.appendChild(el('span', { cls: 'bbx-chip__price', text: '+' + money(custPriceP) }));
      } else {
        // Ribbon + Flower is 0.0 on live right now, and the old branch appended
        // nothing at all — the chip showed a name and no price, not "Free".
        chip.appendChild(el('span', { cls: 'bbx-chip__price', text: t('addon_free', 'Free') }));
      }
      chip.addEventListener('click', function () {
        var cur = root.__bbx.state.current;
        var idx = cur.customisations.findIndex(function (c) {
          return c.customisation.gid === cust.gid;
        });
        if (idx !== -1) {
          // Deselect
          cur.customisations.splice(idx, 1);
          chip.classList.remove('is-selected');
          chip.setAttribute('aria-pressed', 'false');
        } else {
          // Select — cap at maxSel
          if (cur.customisations.length >= maxSel) return;
          cur.customisations.push({
            customisation: cust,
            priceP: custPriceP
          });
          chip.classList.add('is-selected');
          chip.setAttribute('aria-pressed', 'true');
        }
        // Customisations don't affect weight, so no rebalance — but the preview
        // draws add-on overlays off state.current.customisations and rebalance()
        // is otherwise the only caller of renderPreview().
        if (root.__bbx.renderPreview) root.__bbx.renderPreview();
        refreshCta();
      });

      wrap.appendChild(chip);

      // Tooltip belongs to THIS chip only (Sanjay: "note is appearing against
      // all addons" — it read as applying to Message Card too, which has no
      // variable colour). Sibling of the chip button inside the wrapper, never
      // nested inside it — .bbx-chip is already a <button>.
      if (cust.variable_colour) {
        var tooltipId = (root.id || 'bbx') + '-chip-tooltip-' + custIdx;
        var noteText = t('addon_variable_colour_note', 'Note: colour of this add-on is variable.');

        chip.setAttribute('aria-describedby', tooltipId);

        var tipTrigger = el('button', {
          cls: 'bbx-chip-tooltip-trigger',
          attrs: {
            type: 'button',
            'aria-label': noteText,
            'aria-describedby': tooltipId
          },
          text: 'i'
        });
        // Tap-to-show for touch — hover/focus-within (CSS) already covers
        // mouse hover and keyboard focus on either button in the wrapper.
        tipTrigger.addEventListener('click', function (e) {
          e.stopPropagation();
          wrap.classList.toggle('is-tooltip-open');
        });
        wrap.appendChild(tipTrigger);

        var tooltip = el('span', {
          cls: 'bbx-chip-tooltip',
          text: noteText,
          attrs: { role: 'tooltip', id: tooltipId }
        });
        wrap.appendChild(tooltip);

        bindChipTooltipDismiss();
      }

      chips.appendChild(wrap);
    });

    step.appendChild(chips);

    // Insert before [data-bbx-drawer-mount] — after the grid, before the lazy drawer
    var drawerMountEl = elSteps.querySelector('[data-bbx-drawer-mount]');
    if (drawerMountEl) {
      elSteps.insertBefore(step, drawerMountEl);
    } else {
      elSteps.appendChild(step);
    }

    // In stepper mode, keep this panel hidden unless we're already on step 3.
    // renderCustomisations() runs eagerly inside selectPkg() before the user
    // advances to step 3, so without this guard the panel would be visible
    // on top of the Dry Fruits grid immediately after package selection.
    if (isStepperMode() && root.__bbx.state.step !== 3) {
      step.style.display = 'none';
    }
  }

  // ── Template picker ───────────────────────────────────────────────────────

  /**
   * Render merchant-curated starter templates. Shown only for the FIRST box —
   * a customer adding a 4th box has demonstrably chosen to build by hand.
   */
  function renderTemplatePicker() {
    var wrap = root.querySelector('[data-bbx-templates]');
    var grid = root.querySelector('[data-bbx-templates-grid]');
    if (!wrap || !grid) return;

    var templates = cfg.templates || [];

    // Liquid scans at most 50 products (its `for` cap). If we hit the cap and
    // still came up short, the merchant's annotated product is probably beyond
    // it — say so, or they get an empty picker with no explanation.
    if ((cfg.templatesScanned || 0) >= 50 && templates.length < (cfg.templateLimit || 6)) {
      console.warn('[bbx] Template scan hit Liquid\'s 50-product limit. Annotated ' +
        'products beyond the first 50 of the source collection will not appear — ' +
        'point "Template source collection" at a smaller, dedicated collection.');
    }

    // Distinguishes "no collection resolved" (0 scanned) from "collection has
    // products but none are annotated" (scanned > 0, none carry bundle_package) —
    // both produce an empty picker with no other signal.
    if ((cfg.templatesScanned || 0) > 0 && !cfg.templatesAnyBundlePackage) {
      console.warn('[bbx] Template source collection has products, but none carry ' +
        'the "custom.bundle_package" metafield — the template picker will stay ' +
        'empty until at least one product is annotated.');
    }

    if (!templates.length || root.__bbx.state.bundles.length > 0) {
      wrap.hidden = true;
      return;
    }

    grid.innerHTML = '';
    var oldMoreBtn = wrap.querySelector('[data-bbx-templates-more]');
    if (oldMoreBtn) oldMoreBtn.remove();
    var oldSearchWrap = wrap.querySelector('.bbx-templates__search-wrap');
    if (oldSearchWrap) oldSearchWrap.remove();
    wrap.classList.remove('bbx-templates--searching');

    var cards = [];
    templates.forEach(function (tpl) {
      // Weight filtering happens here in JS, not in Liquid — productHasWeightTitle
      // is the canonical implementation and Liquid cannot reproduce its regex
      // without drifting. Liquid dropped only nil references.
      var usable = (tpl.items || []).filter(productHasWeightTitle);
      if (!usable.length) return;

      var pkgExists = (cfg.packages || []).some(function (p) { return p.gid === tpl.package_gid; });
      if (!pkgExists) {
        console.warn('[bbx] Template "' + (tpl.name || tpl.id) + '" points at a package that is not active — hidden.');
        return;
      }

      // selectedVar tracks the currently-chosen size. Starts as the variant
      // Liquid's weight-matching logic flagged is_default, falls back to the
      // first variant. Updated by the size <select> onChange below.
      var variants = tpl.variants || [];
      var selectedVar = variants.find(function (v) { return v.is_default; }) ||
                        (variants.length ? variants[0] : null);

      var card = el('div', {
        cls: 'bbx-tpl-card',
        attrs: { role: 'listitem', 'data-bbx-tpl-id': tpl.id }
      });

      // buyBtn declared early so the size-select onChange closure can ref it
      // before the element is created further down.
      var buyBtn = null;

      // template_style "minimal" must not download an image it hides —
      // display:none still fetches a hidden <img src>, so skip creating it.
      if (tpl.image && cfg.templateStyle !== 'minimal') {
        var img = el('img', {
          attrs: { src: tpl.image, alt: '', loading: 'lazy', width: '300', height: '300' }
        });
        img.className = 'bbx-tpl-card__img';
        card.appendChild(img);
      }

      // Title links to the real PDP — the customer can read the full description,
      // FSSAI panel and reviews before deciding.
      var nameLink = el('a', { cls: 'bbx-tpl-card__name', attrs: { href: tpl.url } });
      nameLink.textContent = tpl.name || '';
      card.appendChild(nameLink);

      // Size selector — rendered only when the gift product has >1 variant
      // (e.g. 600g / 800g / 1kg). Single-variant trays show no selector.
      // Unavailable sizes are disabled in the list rather than dropped so the
      // shopper sees the full range and knows a size exists but is out of stock.
      if (variants.length > 1) {
        var sizeSelect = document.createElement('select');
        sizeSelect.className = 'bbx-tpl-card__size-select';
        sizeSelect.setAttribute('aria-label',
          t('template_size_aria', 'Size for %name%', { name: tpl.name || '' }));
        variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = String(v.id);
          opt.textContent = v.available
            ? v.title
            : (v.title + ' ' + t('template_size_soldout', '(Sold out)'));
          if (!v.available) opt.disabled = true;
          if (v.is_default) opt.selected = true;
          sizeSelect.appendChild(opt);
        });
        sizeSelect.addEventListener('change', function () {
          var vid = parseInt(this.value, 10);
          selectedVar = variants.find(function (v) { return v.id === vid; }) || selectedVar;
          var priceEl = card.querySelector('.bbx-tpl-card__price');
          if (priceEl) {
            priceEl.textContent = t('template_price_shown', '%price% as shown',
              { price: money(selectedVar.price) });
          }
          if (buyBtn) buyBtn.disabled = !selectedVar.available;
        });
        card.appendChild(sizeSelect);
      }

      if (cfg.showTemplateDescription && tpl.description) {
        card.appendChild(el('p', { cls: 'bbx-tpl-card__desc', text: tpl.description }));
      }
      // "₹2,499 as shown" — the gift product's real catalog price for the
      // currently selected size. Once the customer customises, the builder's
      // computed total takes over and the two will differ (spec §5.0b). That
      // divergence is expected and labelled, not reconciled.
      var displayPrice = selectedVar ? selectedVar.price : tpl.price;
      card.appendChild(el('p', {
        cls: 'bbx-tpl-card__price',
        text: t('template_price_shown', '%price% as shown', { price: money(displayPrice) })
      }));

      var actions = el('div', { cls: 'bbx-tpl-card__actions' });

      // Primary — buy the gift product as it ships. This is the theme's ordinary
      // product add-to-cart, NOT the bundle edge function: no new cart path.
      // With multi-variant: always render (user can switch to an in-stock size),
      // initial disabled state reflects the currently-selected variant.
      if (tpl.variant_id) {
        var initAvail = selectedVar ? selectedVar.available : tpl.available;
        buyBtn = el('button', {
          cls: 'bbx-tpl-card__cta bbx-tpl-card__cta--buy',
          attrs: {
            type: 'button',
            'aria-label': t('template_buy_aria', 'Add the %name% box to cart', { name: tpl.name || '' })
          },
          text: t('template_buy', 'Buy this box')
        });
        buyBtn.disabled = !initAvail;
        buyBtn.addEventListener('click', function () {
          buyTemplateAsIs(tpl, selectedVar ? selectedVar.id : null);
        });
        actions.appendChild(buyBtn);
      }

      // Secondary — seed the builder so the customer can swap varieties.
      var customiseBtn = el('button', {
        cls: 'bbx-tpl-card__cta bbx-tpl-card__cta--customise',
        attrs: {
          type: 'button',
          'aria-label': t('template_use_aria', 'Start from the %name% box', { name: tpl.name || '' })
        },
        text: t('template_use', 'Customise this box')
      });
      customiseBtn.addEventListener('click', function () {
        // When the selected variant has its own gift_pack_contents, seed from
        // those; otherwise fall back to the template-level items array.
        // `.length` matters: a variant whose gift_pack_contents is set but
        // whose referenced products have since been deleted/archived emits
        // "items": [], and an empty array is truthy — without this check it
        // would win over tpl.items and seed a silently EMPTY box.
        var varItems = (selectedVar && selectedVar.items && selectedVar.items.length)
          ? selectedVar.items
          : null;
        applyTemplate(tpl.id, varItems);
      });
      actions.appendChild(customiseBtn);

      card.appendChild(actions);
      cards.push(card);
    });

    // template_limit (theme editor "Max templates shown") is now an initial
    // reveal count, not a hard data cap — Liquid emits every matching template
    // (up to its own 50-product scan cap) and this "Show more" button reveals
    // the rest, so the merchant setting still bounds first paint without ever
    // hiding a curated template outright.
    var visibleLimit = cfg.templateLimit || 6;
    cards.forEach(function (card, i) {
      if (i >= visibleLimit) card.classList.add('bbx-tpl-card--hidden');
      grid.appendChild(card);
    });

    function revealAllCards() {
      cards.forEach(function (card) { card.classList.remove('bbx-tpl-card--hidden'); });
    }

    if (cards.length > visibleLimit) {
      var hiddenCount = cards.length - visibleLimit;
      var moreBtn = el('button', {
        cls: 'bbx-templates__more',
        attrs: { type: 'button', 'data-bbx-templates-more': '' },
        text: t('template_show_more', 'Show %count% more', { count: hiddenCount })
      });
      moreBtn.addEventListener('click', function () {
        revealAllCards();
        moreBtn.remove();
        refreshTemplateSliderControls();
      });
      grid.parentNode.insertBefore(moreBtn, grid.nextSibling);
    }

    // The compact tile-strip presentation and its "View all boxes" side popup
    // were deleted with the 2026-08-12 mobile-stepper redesign — the
    // full-screen sheet supersedes them. revealAllCards() above survives: it is
    // still the "Show N more" button's handler.

    // ── SKU search box ────────────────────────────────────────────────────────
    // Threshold: 0 = disabled, >0 = show when cards.length meets or exceeds it.
    // cfg.templateSearchMinCount defaults to 12 if unset (schema default).
    var searchMin = cfg.templateSearchMinCount != null ? cfg.templateSearchMinCount : 12;
    if (searchMin > 0 && cards.length >= searchMin) {
      var searchInputId = (root.id || 'bbx') + '-tpl-search';
      var searchWrap = el('div', { cls: 'bbx-templates__search-wrap' });

      // Visually-hidden label — same pattern used throughout this section for
      // screen-reader-only text (bbx-sr-only companion; see aria-label on all
      // other inputs). <label for=""> is preferred here so AT can associate it
      // without extra aria attributes on the input itself.
      var searchLbl = el('label', {
        cls: 'bbx-templates__search-label',
        attrs: { 'for': searchInputId }
      });
      searchLbl.textContent = t('template_search_aria', 'Search gift boxes by SKU');

      var searchInp = el('input', {
        cls: 'bbx-templates__search-input',
        attrs: {
          type: 'search',
          id: searchInputId,
          placeholder: t('template_search_placeholder', 'Search by SKU'),
          autocomplete: 'off',
          spellcheck: 'false'
        }
      });

      var noResultsEl = el('p', { cls: 'bbx-templates__search-no-results' });
      noResultsEl.textContent = t('template_search_no_results', 'No boxes match that SKU');
      noResultsEl.hidden = true;

      searchWrap.appendChild(searchLbl);
      searchWrap.appendChild(searchInp);
      searchWrap.appendChild(noResultsEl);
      // Insert search wrap directly above the grid
      grid.parentNode.insertBefore(searchWrap, grid);

      var _srchTimer = null;
      searchInp.addEventListener('input', function () {
        clearTimeout(_srchTimer);
        _srchTimer = setTimeout(function () {
          var q = searchInp.value.trim().toLowerCase();
          // Re-query each time: button may have been removed by revealAllCards()
          var currentMoreBtn = wrap.querySelector('[data-bbx-templates-more]');

          if (!q) {
            // Restore pre-search state:
            // - remove the searching class so the CSS override lifting --hidden no longer fires
            // - remove --filtered from every card (--hidden class is untouched throughout)
            // - restore the "Show more" button visibility if it hasn't been clicked
            wrap.classList.remove('bbx-templates--searching');
            cards.forEach(function (card) { card.classList.remove('bbx-tpl-card--filtered'); });
            noResultsEl.hidden = true;
            if (currentMoreBtn) currentMoreBtn.hidden = false;
            refreshTemplateSliderControls();
            return;
          }

          // Active search:
          // .bbx-templates--searching + :not(.bbx-tpl-card--filtered) CSS rule (specificity
          // 1,3,0) overrides .bbx-tpl-card--hidden (1,2,0), so matched cards are always
          // visible regardless of reveal state — without touching bbx-tpl-card--hidden.
          wrap.classList.add('bbx-templates--searching');
          // Hide "Show more" — it's meaningless while results are filtered
          if (currentMoreBtn) currentMoreBtn.hidden = true;

          var anyMatch = false;
          cards.forEach(function (card) {
            var tplId = parseInt(card.getAttribute('data-bbx-tpl-id'), 10);
            var tpl = (cfg.templates || []).find(function (x) { return x.id === tplId; });
            // Match if ANY variant SKU is a case-insensitive substring of the query.
            // Blank / missing SKU never matches — blank query already handled above.
            var matches = tpl && (tpl.variants || []).some(function (v) {
              return v.sku && v.sku.toLowerCase().indexOf(q) !== -1;
            });
            card.classList.toggle('bbx-tpl-card--filtered', !matches);
            if (matches) anyMatch = true;
          });

          noResultsEl.hidden = anyMatch;
          if (!anyMatch) {
            announceToSR(t('template_search_no_results', 'No boxes match that SKU'));
          }
          refreshTemplateSliderControls();
        }, 150);
      });
    }
    // ── end SKU search ────────────────────────────────────────────────────────

    wrap.hidden = cards.length === 0;

    // §25: rebuild slider dots / arrows to match the new card set
    refreshTemplateSliderControls();
  }

  /**
   * "Buy this box" — add the gift product's own variant via the theme's normal
   * cart endpoint. Deliberately NOT the bundle edge function: this product is
   * already a real, priced, purchasable SKU. Introduces no new cart code, and
   * stays compatible with Fastrr (CLAUDE.md section 6).
   */
  function buyTemplateAsIs(tpl, variantId) {
    var vid = (variantId != null) ? variantId : tpl.variant_id;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        announceToSR(t('template_added', '%name% added to cart', { name: tpl.name || '' }));
        // Close the stepper BEFORE the cart drawer. Otherwise the drawer opens
        // behind a full-screen sheet with document scroll still locked — the
        // shopper sees nothing happen on the primary conversion path.
        // No-op when the sheet is not open, so desktop is unaffected.
        closeStepper();
        // Reuse the theme's own drawer refresh — openCartDrawerOrNavigate()
        // finds <sindhi-cart-drawer>, calls ._refresh().then(.open()) and falls
        // back to /cart. Do NOT dispatch a bespoke event: the theme's real
        // constant is ThemeEvents.cartUpdate = 'cart:update' (assets/events.js:14),
        // and 'cart:refresh' exists nowhere.
        if (root.__bbx.openCartDrawerOrNavigate) root.__bbx.openCartDrawerOrNavigate();
        else window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[bbx] buy-as-is failed', err);
        // Fall back to the PDP rather than leaving the customer with a dead button.
        window.location.href = tpl.url;
      });
  }

  /**
   * Seed the builder from a template product's metafields, then let the
   * existing recalculation run. Introduces NO new pricing or cart path:
   * rebalance() -> allocatedPrice() -> nearestVariant() and addAllToCart()'s
   * variant resolution are untouched.
   *
   * Staleness was already handled at emit time in Liquid — deleted, archived
   * and unpublished products all resolve nil there and never reach JS, as do
   * products with no weight-parseable variant title. JS applies only the
   * max_items truncation.
   */
  function applyTemplate(id, overrideItems) {
    var tpl = (cfg.templates || []).find(function (x) { return x.id === id; });
    if (!tpl) return;

    var pkg = (cfg.packages || []).find(function (p) { return p.gid === tpl.package_gid; });
    if (!pkg) return; // package deactivated since the template was authored

    var cur = root.__bbx.state.current;
    cur.pkg = pkg;
    cur.items = [];
    cur.customisations = [];
    // `step` is a SIBLING of `current`, not a child: state is
    // { bundles, step, current: { pkg, items, customisations } } (js:199-207).
    // Every reader uses root.__bbx.state.step, and editBundle sets it that way —
    // writing cur.step would set a property nothing reads, leaving the stepper
    // on "Step 1: choose a package" over a fully seeded box.
    root.__bbx.state.step = 2; // package is already chosen

    var maxItems = parseInt(pkg.max_items, 10) || 1;
    // overrideItems is the selected variant's own gift_pack_contents when it
    // has one; otherwise fall back to the template-level items array.
    var srcItems = (overrideItems != null) ? overrideItems : (tpl.items || []);
    var tplItemTotal = srcItems.length;
    // Same weight filter as the picker: a product with no parseable weight
    // prices at 0 and yields an empty variant_gid at checkout.
    srcItems.filter(productHasWeightTitle).slice(0, maxItems).forEach(function (product) {
      cur.items.push({ product: product, allocatedG: 0, priceP: 0 });
    });
    // Fix 7 (branch review): the filter+slice above can silently drop
    // varieties (unparseable weight, or more items than the package's
    // max_items) with no signal to the shopper that their box is short.
    var tplCarriedCount = cur.items.length;
    var tplItemsDropped = tplCarriedCount < tplItemTotal;

    // Respect the layer's add-on cap — the chip handler enforces
    // custMaxSelections(), so pushing past it creates state the UI cannot
    // undo through normal interaction.
    (tpl.addon_gids || []).slice(0, custMaxSelections()).forEach(function (agid) {
      var cust = (cfg.customisations || []).find(function (c) { return c.gid === agid; });
      if (!cust) return;
      cur.customisations.push({
        customisation: cust,
        priceP: Math.round((parseFloat(cust.price) || 0) * 100)
      });
    });

    var wrap = root.querySelector('[data-bbx-templates]');
    if (wrap) wrap.hidden = true;
    // ADDITIVE, not a replacement: showStepPanel() is stepper-mode-only (a
    // no-op outside it — see IIFE 1), so the wrap.hidden write above still
    // does 100% of the work on desktop/tablet, byte-for-byte as today. In
    // stepper mode "Customise this box" must additionally advance the
    // visible panel from the picker to the builder inside the same sheet.
    showStepPanel(2);

    // Collapse the package step and show the banner, exactly as editBundle does
    // (js:4091-4117). Without this the customer sees an expanded Step 1 picker
    // with no card marked selected, no package banner, and the stepper stuck on
    // step 1 — while the grid below is already full of the template's items.
    showBuilder();
    renderPackages();
    var pkgStep = root.querySelector('.bbx-step--packages');
    if (pkgStep) pkgStep.style.display = 'none';
    renderPkgBanner(pkg);

    if (root.__bbx.resetPreviewAnimState) root.__bbx.resetPreviewAnimState();
    renderGrid();

    // renderGrid() renders getProductsForCurrentPkg() — the featured or
    // per-package collection — NOT state.current.items. A template's varieties
    // are by definition not guaranteed to be in the featured top 8, so without
    // this the customer sees a full preview and a full capacity meter above a
    // grid where NONE of their items appear and every Add button is disabled
    // (isFull). Their box would only be editable via the drawer.
    ensureSeededItemCards(pkg);

    renderCustomisations();
    rebalance();

    // The card showed the gift product's catalog price; from here the builder's
    // computed total governs. Say so once, rather than letting the number appear
    // to change for no reason (spec §5.0b).
    //
    // This uses its OWN element, separate from the capacity block rebalance()
    // redraws on every edit — the price note would be destroyed by the
    // customer's first edit otherwise, which is exactly when it's needed. It
    // lives in the CTA bar, next to the total it explains.
    var elPriceNote = root.querySelector('[data-bbx-tpl-price-note]');
    if (elPriceNote) {
      var priceNoteText = t('template_price_note', 'Custom boxes are priced by contents.');
      if (tplItemsDropped) {
        priceNoteText += ' ' + t('template_carried_over',
          'Only %carried% of %total% varieties from this box could be carried over.',
          { carried: tplCarriedCount, total: tplItemTotal });
      }
      elPriceNote.textContent = priceNoteText;
      elPriceNote.hidden = false;
    }

    var appliedText = t('template_applied', '%name% loaded — change anything you like', { name: tpl.name || '' });
    if (tplItemsDropped) {
      appliedText += ' ' + t('template_carried_over',
        'Only %carried% of %total% varieties from this box could be carried over.',
        { carried: tplCarriedCount, total: tplItemTotal });
    }
    announceToSR(appliedText);
  }

  root.__bbx.renderTemplatePicker = renderTemplatePicker;
  root.__bbx.applyTemplate = applyTemplate;

  // ── Step 7: Wire the flow on load ─────────────────────────────────────────

  /**
   * Restore the static builder scaffold (grid, capacity, preview, drawer-mount)
   * that was hidden by renderCompleteScreen, remove the complete-screen overlay,
   * and re-render the chrome bar. Called by startNewBundle() and editBundle().
   */
  function showBuilder() {
    var cs = elSteps ? elSteps.querySelector('.bbx-complete-screen') : null;
    if (cs) cs.remove();
    [elGrid, elCapacity,
     root.querySelector('[data-bbx-preview]'),
     root.querySelector('[data-bbx-drawer-mount]')
    ].forEach(function (e) { if (e) e.style.display = ''; });
    renderBuilderChrome();
    // This function's job is undoing the complete screen, so it blanket-shows
    // the builder scaffold — which silently UNDOES showStepPanel()'s routing
    // for every caller that runs it afterwards. That produced three separate
    // live instances of "step 1 shows step 2's dry-fruits grid": the
    // "Build my own" skip, startNewBundle() ("Add another box" / "Cancel and
    // start over"), and editBundle(). Re-asserting the route here fixes all
    // callers at once instead of patching each one — and stays correct for
    // callers that legitimately land on step 2, since the router shows exactly
    // that step's panels. No-op outside stepper mode.
    showStepPanel(root.__bbx.state.step);
  }

  /**
   * Expose render functions on root.__bbx so Tasks 8-11 can call them.
   * Also expose rebalance so the drawer (Task 9) can call it after adding products.
   */
  root.__bbx.renderPackages       = renderPackages;
  root.__bbx.renderGrid           = renderGrid;
  root.__bbx.renderCapacity       = renderCapacity;
  root.__bbx.renderCustomisations = renderCustomisations;
  root.__bbx.rebalance            = rebalance;
  root.__bbx.buildProductCard     = buildProductCard;
  root.__bbx.t                    = t;
  root.__bbx.announceToSR         = announceToSR;
  root.__bbx.renderBuilderChrome  = renderBuilderChrome;
  root.__bbx.renderPkgBanner      = renderPkgBanner;
  root.__bbx.showBuilder          = showBuilder;
  root.__bbx.isStepperMode        = isStepperMode;
  root.__bbx.hasStep0             = hasStep0;
  root.__bbx.showStepPanel        = showStepPanel;
  root.__bbx.goToStep             = goToStep;
  root.__bbx.stepLabel            = stepLabel;
  root.__bbx.openStepper          = openStepper;
  root.__bbx.closeStepper         = closeStepper;
  root.__bbx.isStepperOpen        = isStepperOpen;
  root.__bbx.stepperEntryStep     = stepperEntryStep;
  root.__bbx.refreshSliderControls = refreshSliderControls;
  // Every path that seeds state.current.items and then re-renders the grid must
  // call this, or those items count toward capacity/price while showing no
  // "added" card: applyTemplate(), selectPkg(), editBundle(), restoreDraft().
  root.__bbx.ensureSeededItemCards = ensureSeededItemCards;
  // restoreDraft() (a later IIFE) writes state.step directly and must be able
  // to bring the CTA label back in line with the step it restored.
  root.__bbx.syncCtaText          = syncCtaText;
  // The order summary lives in a later IIFE but shares the overlay flag.
  root.__bbx.syncOverlayFlag      = syncOverlayFlag;
  root.__bbx.displayName          = displayName;
  // Task 9 drawer will assign root.__bbx.openDrawer = function() { ... };

  // Initial render: if packages exist, show package picker first;
  // if there's exactly one package (no choice), auto-select and show grid.
  (function init() {
    var packages = cfg.packages || [];
    if (!packages.length) {
      // No packages configured — show grid + capacity in placeholder state
      renderBuilderChrome();
      renderGrid();
      renderCapacity();
      return;
    }

    // Render packages step first; chrome is inserted via insertBefore(firstChild) → goes to pos 0
    renderPackages();
    renderBuilderChrome();
    renderCapacity(); // shows "Select a package to begin" state

    // Auto-select-when-only-one-package REMOVED (Sanjay, 2026-08-13 QA).
    // It pre-filled a choice the shopper never made, and because
    // draftHasContent() counts a bare `current.pkg` as content, the very next
    // `pagehide` persisted a "saved box" for it — so a first-time visitor who
    // merely loaded the page and left came back to a teaser reading
    // "Your saved box · 0 items · Wooden Tray 1kg". Always show the package
    // step and let the shopper start from scratch, even when there is only one
    // package to choose (one extra tap, never a pre-made decision).

    // Template picker — on-ramp before Step 1, not a modal: the builder body
    // below it stays visible. No packages means no picker (early return above).
    var _tplSkip = root.querySelector('[data-bbx-templates-skip]');
    if (_tplSkip) {
      _tplSkip.addEventListener('click', function () {
        var w = root.querySelector('[data-bbx-templates]');
        if (w) w.hidden = true;
        // ADDITIVE, not a replacement: see the Step 4 correction note above —
        // the wrap.hidden write does 100% of the work on desktop/tablet;
        // showStepPanel is stepper-mode-only. Skipping the picker lands on
        // Package (step 1); set the step before swapping panels so the
        // chrome and the visible screen agree.
        root.__bbx.state.step = 1;
        // showBuilder() BEFORE showStepPanel(): it unconditionally resets
        // elGrid/elCapacity/elPreview to display:'' (it exists to undo the
        // complete screen), so calling it after the router silently undid the
        // routing and left step 1 showing step 2's dry-fruits grid — the very
        // bug the explicit router was added to fix, still reachable via
        // "Build my own". Router must run last so it wins.
        showBuilder();
        showStepPanel(1);
        refreshChrome();
      });
    }
    renderTemplatePicker();
    // Park the preview and host the chrome correctly for the current viewport.
    syncStepperLayout();
  })();

  // ---------------------------------------------------------------------------
  // Self-check (dev assertions — surface regressions on staging)
  // ---------------------------------------------------------------------------
  (function selfCheck() {
    // ── Task 6 engine checks ─────────────────────────────────────────────────
    var s3 = evenSplit(1000, 3);
    console.assert(
      s3.length === 3 &&
      s3[0] === 333 &&
      s3[1] === 333 &&
      s3[2] === 334 &&
      s3.reduce(function (a, b) { return a + b; }, 0) === 1000,
      '[bbx] evenSplit(1000,3) wrong', s3
    );
    console.assert(
      evenSplit(1000, 4).join(',') === '250,250,250,250',
      '[bbx] evenSplit(1000,4) wrong',
      evenSplit(1000, 4)
    );
    console.assert(
      evenSplit(1000, 1)[0] === 1000,
      '[bbx] evenSplit(1000,1) wrong'
    );
    console.assert(
      evenSplit(1000, 0).length === 0,
      '[bbx] evenSplit(1000,0) should return []'
    );

    // variantGrams — title-only (Shopify weight intentionally excluded)
    console.assert(
      variantGrams({ title: '500g' }) === 500,
      '[bbx] variantGrams 500g wrong'
    );
    console.assert(
      variantGrams({ title: '1 Kg' }) === 1000,
      '[bbx] variantGrams 1 Kg wrong'
    );
    console.assert(
      variantGrams({ title: '500g Pack' }) === 500,
      '[bbx] variantGrams title with suffix wrong'
    );
    console.assert(
      variantGrams({ title: 'Default Title' }) === null,
      '[bbx] variantGrams no-weight title should return null'
    );
    console.assert(
      variantGrams({ weight: 0.5, weight_unit: 'kg' }) === null,
      '[bbx] variantGrams must not use Shopify weight'
    );

    // ── Task 7 step-flow logic check ─────────────────────────────────────────
    // Simulate: 1kg/4-item package, add 2 products.
    var mockPkg = { gid: 'gid://test/1', name: 'Test Box', weight_capacity_g: 1000, max_items: 4, price: 299 };
    var mockP1  = { id: 1, title: 'Cashews', featured_image: '', variants: [{ gid: 'v1', title: '500g', price: 60000, weight: 500, weight_unit: 'g' }] };
    var mockP2  = { id: 2, title: 'Almonds', featured_image: '', variants: [{ gid: 'v2', title: '1kg', price: 80000, weight: 1000, weight_unit: 'g' }] };

    // evenSplit with 2 items in a 1000g box → [500, 500]
    var split2 = evenSplit(1000, 2);
    console.assert(
      split2.join(',') === '500,500',
      '[bbx T7] evenSplit(1000,2) should be [500,500]', split2
    );

    // allocatedPrice for Cashews at 500g: rate = 60000/500 * 500 = 60000 paise = ₹600
    var p1price = allocatedPrice(mockP1, 500);
    console.assert(
      p1price === 60000,
      '[bbx T7] allocatedPrice(Cashews,500g) should be 60000 paise', p1price
    );

    // allocatedPrice for Almonds at 500g: rate = 80000/1000 * 500 = 40000 paise = ₹400
    var p2price = allocatedPrice(mockP2, 500);
    console.assert(
      p2price === 40000,
      '[bbx T7] allocatedPrice(Almonds,500g) should be 40000 paise', p2price
    );

    // Max-items guard: 4-item box with 4 items is full, cannot add 5th
    var mockItems = [
      { product: mockP1, allocatedG: 250, priceP: 15000 },
      { product: mockP2, allocatedG: 250, priceP: 10000 },
      { product: mockP1, allocatedG: 250, priceP: 15000 },
      { product: mockP2, allocatedG: 250, priceP: 10000 }
    ];
    var isFull = mockItems.length >= parseInt(mockPkg.max_items, 10);
    console.assert(isFull === true, '[bbx T7] maxItems guard: 4/4 should be full');

    // money() formatting
    var moneyStr = money(60000);
    console.assert(
      typeof moneyStr === 'string' && moneyStr.length > 0,
      '[bbx T7] money(60000) should return a non-empty string', moneyStr
    );

    // ── Step-machine checks (mobile stepper spec 2026-08-12) ─────────────────
    // buildStepDefs must always carry an explicit `n` on every entry — the
    // whole point of the refactor is that nothing derives a step number from
    // an array index.
    var _defs = buildStepDefs();
    console.assert(
      _defs.length > 0 && _defs.every(function (d) { return typeof d.n === 'number'; }),
      '[bbx] buildStepDefs must return entries carrying a numeric n', _defs
    );
    // Outside stepper mode the trail is the legacy 4 entries, numbered 1..4.
    if (!isStepperMode()) {
      console.assert(
        _defs.length === 4 && _defs[0].n === 1 && _defs[3].n === 4,
        '[bbx] desktop/tablet stepDefs must stay the legacy 1..4 trail', _defs
      );
    }
    // Data-gated navigation: step 3 requires a selected package AND
    // non-empty customisations. At self-check time neither exists, so
    // canGoToStep(3) returns false and the move is correctly refused.
    var _savedStep = root.__bbx.state.step;
    root.__bbx.state.step = 2;
    goToStep(3);
    console.assert(root.__bbx.state.step === 2, '[bbx] goToStep must refuse step 3 when pkg/customisations not set');
    goToStep(-1);
    console.assert(root.__bbx.state.step === 2, '[bbx] goToStep must refuse negative steps');
    root.__bbx.state.step = _savedStep;

    console.log('[bbx] Task 7 self-check complete.');
  })();
})();

// ---------------------------------------------------------------------------
// Task 8 — Live tray preview + product info popup
// ---------------------------------------------------------------------------
// Appended as a second IIFE that waits for root.__bbx to exist (it's set
// synchronously in the first IIFE above, so by the time DOMContentLoaded or
// the defer fires this is always safe).
(function () {
  'use strict';

  // ── Locate root the same way the first IIFE does ─────────────────────────
  var root =
    document.querySelector('[data-bbx]') ||
    document.querySelector('.sindhi-bundle-builder');
  if (!root || !root.__bbx) return;

  var bbx = root.__bbx;
  var t = function(key, fallback, vars) { return bbx.t ? bbx.t(key, fallback, vars) : fallback; };

  // ── Engine helpers (evenSplit is on the namespace from Task 6) ───────────
  var evenSplit = bbx.evenSplit;

  // ── Internal tracking for animation detection ─────────────────────────────
  // Stores the previous render's item snapshot: { productId → allocatedG }
  var _prevAllocations = {};      // { productId: allocatedG }
  var _prevItemIds     = [];      // ordered list of product ids from last render

  /** Clear entrance/flash animation tracking between boxes. */
  function resetPreviewAnimState() {
    _prevItemIds = [];
    _prevAllocations = {};
  }
  bbx.resetPreviewAnimState = resetPreviewAnimState;

  // ── Helper: initial letter fallback when no image ─────────────────────────
  function initialLetter(title) {
    return (title || 'P').charAt(0).toUpperCase();
  }

  // ── Shape families ────────────────────────────────────────────────────────
  /**
   * Which family renderer draws each package shape.
   * Unrecognised values fall back to 'radial' so a future admin `choices` value
   * cannot blank the preview.
   */
  var SHAPE_FAMILY = {
    'round-tray': 'radial',
    'tin':        'radial',
    'basket':     'radial',
    'box':        'grid',
    'hamper':     'grid',
    'pouch':      'grid',
    'jar':        'stack'
  };

  function shapeFamily(shape) {
    return SHAPE_FAMILY[shape] || 'radial';
  }

  /**
   * Fallback wedge colours — rotating set of 4 so adjacent wedges stay
   * distinguishable when products have no fill image. Index is wedge POSITION,
   * not product id: stable ordering beats stable per-product colour.
   *
   * These four must be genuinely distinguishable from each other, because with
   * zero flat-lays shot this IS the day-one appearance. The theme's --gold-pale
   * (#f7f0e3), --sage-pale (#e6e9df) and --cream-warm (#fdfbf7) are three
   * near-identical off-whites — using all three would render a 4-item vessel as
   * three indistinguishable cream wedges plus one brown one. Hence gold / sage /
   * dark-chocolate / burgundy, which separate at a glance.
   * Each pair is contrast-verified >= 4.5:1 (spec 3.5).
   */
  var WEDGE_FALLBACK = [
    { bg: 'var(--bbx-wedge-1)', fg: 'var(--bbx-wedge-1-fg)' },
    { bg: 'var(--bbx-wedge-2)', fg: 'var(--bbx-wedge-2-fg)' },
    { bg: 'var(--bbx-wedge-3)', fg: 'var(--bbx-wedge-3-fg)' },
    { bg: 'var(--bbx-wedge-4)', fg: 'var(--bbx-wedge-4-fg)' }
  ];

  /**
   * Geometry for wedge `i` of `n`, for a given family.
   * Returns { cls, style } — style is an inline CSS string.
   *
   * radial: n===1 full circle; n===2 halves via absolute inset; n>=3 clip-path
   *         polygon from centre. Polygon radius 110% so the straight chord
   *         still covers the arc at spans up to 120deg (50/cos(60deg) = 100).
   * grid:   CSS grid cell — caller sets grid-template on the container.
   * stack:  horizontal band — caller sets grid-template-rows on the container.
   */
  function wedgeGeometry(family, n, i) {
    if (family !== 'radial') {
      return { cls: 'bbx-wedge bbx-wedge--cell', style: '' };
    }
    if (n === 1) {
      return { cls: 'bbx-wedge bbx-wedge--full', style: '' };
    }
    if (n === 2) {
      return {
        cls: 'bbx-wedge bbx-wedge--half',
        style: i === 0 ? 'inset:0 50% 0 0;' : 'inset:0 0 0 50%;'
      };
    }
    var R = 110;
    var a0 = (-90 + (360 / n) * i) * Math.PI / 180;
    var a1 = (-90 + (360 / n) * (i + 1)) * Math.PI / 180;
    var x0 = (50 + R * Math.cos(a0)).toFixed(2);
    var y0 = (50 + R * Math.sin(a0)).toFixed(2);
    var x1 = (50 + R * Math.cos(a1)).toFixed(2);
    var y1 = (50 + R * Math.sin(a1)).toFixed(2);
    // Every slice is a FULL-SQUARE box at inset:0, differentiated only by
    // clip-path. Flex-centring would therefore put every label at the centre of
    // the circle, stacking N clipped name fragments on the pivot. Emit the
    // wedge centroid so the label can be positioned per-slice instead.
    var am = (-90 + (360 / n) * (i + 0.5)) * Math.PI / 180;
    var cx = (50 + 30 * Math.cos(am)).toFixed(2);
    var cy = (50 + 30 * Math.sin(am)).toFixed(2);
    return {
      cls: 'bbx-wedge bbx-wedge--slice',
      style: 'clip-path:polygon(50% 50%,' + x0 + '% ' + y0 + '%,' + x1 + '% ' + y1 + '%);' +
             '--wx:' + cx + '%;--wy:' + cy + '%;'
    };
  }

  /**
   * Fill for one wedge. fill_image ONLY — featured_image is never a fill
   * source (spec 3.5), because drawer-added products carry a pack shot there.
   */
  function wedgeFillStyle(item, i) {
    var img = item.product.fill_image;
    if (img) {
      return 'background-image:url(' + img + ');background-size:cover;background-position:center;';
    }
    var pair = WEDGE_FALLBACK[i % WEDGE_FALLBACK.length];
    return 'background:' + pair.bg + ';color:' + pair.fg + ';';
  }

  /** True when this wedge is showing a photo rather than a fallback colour. */
  function wedgeHasImage(item) {
    return !!item.product.fill_image;
  }

  /**
   * Wedge label. Full title (truncated) normally; initial letter only when
   * wedges get too narrow to read — n>=5 on mobile (spec 3.5).
   */
  function wedgeLabel(item, n) {
    var title = (bbx.displayName ? bbx.displayName(item.product) : (item.product.title || ''));
    var isNarrow = n >= 5 && window.innerWidth <= 749;
    if (isNarrow) return initialLetter(title);
    return title.substring(0, 20);
  }

  // ── renderPreview() ───────────────────────────────────────────────────────
  /**
   * Build the wooden tray slot markup and mount it into [data-bbx-preview].
   * Called by rebalance() (already wired in Task 7) and once after package pick.
   *
   * Animations (Fix 9, branch review — corrected to match what actually
   * renders; this comment previously described the old fixed slot-grid
   * tray's behaviour, which was replaced by the shape-family vessel below):
   *  - bbx-slot-pop: applied to .bbx-wedge elements for product IDs not
   *    present in the previous render (see _prevItemIds below). CSS:
   *    .bbx-wedge.bbx-slot-pop.
   *  - glow ring: applied via [data-bbx-full="true"] on .bbx-vessel when
   *    item count === maxItems. CSS: .bbx-vessel[data-bbx-full="true"].
   *  - wtFlash was planned for a per-item weight badge but never
   *    implemented — the vessel design has no weight-badge element to
   *    flash. Not resurrected here; removed from this doc comment.
   */
  function renderPreview() {
    var elPreview = root.querySelector('[data-bbx-preview]');
    if (!elPreview) return;

    var state    = bbx.state.current;
    var pkg      = state.pkg;
    var items    = state.items;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 4) : 4;
    var capG     = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
    var n        = items.length;
    var family   = shapeFamily(pkg && pkg.shape);
    var isFull   = n > 0 && n >= maxItems;

    // Total so far (items only)
    var itemsTotal = items.reduce(function (sum, it) { return sum + (it.priceP || 0); }, 0);

    var html = '';

    html += '<p class="bbx-tray-eyebrow" aria-hidden="true">' +
      t('tray_eyebrow', 'Your box · live preview') +
      '</p>';

    // Vessel — decorative graphic, aria-hidden (spec 3.6). Composition, weights
    // and remaining capacity are conveyed in text by the meta strip and grid cards.
    html += '<div class="bbx-vessel bbx-vessel--' + family +
      '" data-bbx-shape="' + (pkg && pkg.shape ? pkg.shape : 'round-tray') + '"' +
      (isFull ? ' data-bbx-full="true"' : '') + ' aria-hidden="true">';

    if (n === 0) {
      html += '<div class="bbx-vessel__empty"></div>';
    } else {
      var containerStyle = '';
      if (family === 'grid') {
        containerStyle = 'grid-template-columns:repeat(' + Math.ceil(Math.sqrt(n)) + ',1fr);';
      } else if (family === 'stack') {
        containerStyle = 'grid-template-rows:repeat(' + n + ',1fr);';
      }
      html += '<div class="bbx-vessel__fill" style="' + containerStyle + '">';

      items.forEach(function (item, i) {
        var geo  = wedgeGeometry(family, n, i);
        var pid  = item.product.id;
        var isNew = _prevItemIds.indexOf(pid) === -1;
        html += '<div class="' + geo.cls + (isNew ? ' bbx-slot-pop' : '') +
          (wedgeHasImage(item) ? ' bbx-wedge--img' : '') +
          '" data-bbx-slot-pid="' + pid + '"' +
          ' style="' + geo.style + wedgeFillStyle(item, i) + '">' +
          '<span class="bbx-wedge__label">' + wedgeLabel(item, n) + '</span>' +
          '</div>';
      });

      html += '</div>'; // /bbx-vessel__fill
    }

    // Vessel divider — the package's OWN moulded partition, not the Ribbon +
    // Flower add-on. Radial lines are drawn at the actual wedge boundaries
    // (same -90deg start + 360/n step used by wedgeGeometry above), so the
    // divider always matches the current item count instead of a fixed
    // 4-way cross. At 1-2 items a partition line reads as a print error
    // (Sanjay QA), so it's suppressed below n=3.
    var dividerStyle = (pkg && pkg.divider_style) || 'none';
    if (dividerStyle === 'cross' && n >= 3) {
      var dividerStep = 360 / n;
      var dividerBg = 'background:repeating-conic-gradient(from -90deg, var(--bbx-divider-color) 0deg 1.5deg, transparent 1.5deg ' + dividerStep + 'deg);';
      html += '<div class="bbx-vessel__divider" aria-hidden="true" style="' + dividerBg + '"></div>';
    }

    // Add-on overlays — gated on SELECTION, never on state.step. The engine
    // never sets state.step above 2 (selectPkg -> 2, banner Change -> 1,
    // editBundle -> 2, startNewBundle -> 1, back button decrements only), so a
    // step-gated overlay would never draw.
    var hasRibbon = (state.customisations || []).some(function (c) {
      return c.customisation && (c.customisation.category || '').toLowerCase() === 'ribbon';
    });
    if (hasRibbon) {
      html += '<div class="bbx-vessel__ribbon" aria-hidden="true"></div>';
      html += '<div class="bbx-vessel__flower" aria-hidden="true"></div>';
    }

    html += '<div class="bbx-vessel__rim" aria-hidden="true"></div>';
    html += '</div>'; // /bbx-vessel

    // Meta strip below the tray
    html += '<div class="bbx-tray-meta">';
    html += '<span class="bbx-tray-meta-label">' +
      t('items_used', '%count% of %total% items', { count: items.length, total: maxItems });
    if (capG) html += ' · ' + capG + 'g';
    html += '</span>';
    html += '<span class="bbx-tray-meta-val">' + bbx.money(itemsTotal) + '</span>';
    html += '</div>';

    // Fill progress bar
    var fillPct = maxItems > 0 ? Math.round((items.length / maxItems) * 100) : 0;
    html += '<div class="bbx-tray-progress" aria-hidden="true">' +
      '<div class="bbx-tray-progress-fill" style="width:' + fillPct + '%;"></div>' +
      '</div>';

    // Mount
    elPreview.innerHTML = html;
    elPreview.setAttribute('aria-hidden', 'false');

    // Update prev-state tracker ──────────────────────────────────────────────
    _prevItemIds = items.map(function (it) { return it.product.id; });
    _prevAllocations = {};
    items.forEach(function (it) {
      _prevAllocations[it.product.id] = it.allocatedG;
    });
  }

  // Register on namespace so rebalance() in Task 7 can call it
  bbx.renderPreview = renderPreview;

  // ── openInfo(productId) ───────────────────────────────────────────────────
  /**
   * Open the product info popup (bottom sheet on mobile, centered modal on desktop).
   * Lazy-fetches /products/<handle>.js for description + nutrition (best-effort).
   * A11y: focus trap, Esc close, overlay click close, restore focus, aria-modal.
   *
   * The "Add to Box" button reuses the same add/rebalance path as the grid card.
   */
  function openInfo(productId) {
    // Find product in featuredProducts config (fast; already inlined)
    var product = (bbx.cfg.featuredProducts || []).find(function (p) {
      return p.id === productId || p.id === parseInt(productId, 10);
    });
    if (!product) return;

    // Compute live allocation context
    var state    = bbx.state.current;
    var pkg      = state.pkg;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;
    var isAdded  = state.items.some(function (it) { return it.product.id === product.id; });
    var isFull   = state.items.length >= maxItems;
    var wouldGetG = pkg
      ? evenSplit(parseInt(pkg.weight_capacity_g, 10) || 0, state.items.length + 1).slice(-1)[0]
      : 0;
    var wouldPay  = wouldGetG ? bbx.allocatedPrice(product, wouldGetG) : 0;
    var slotsLeft = maxItems - state.items.length;

    // Remember the element that triggered the popup (for focus restore)
    var _opener = document.activeElement;

    // ── Overlay & dialog ─────────────────────────────────────────────────────
    var overlay = document.createElement('div');
    overlay.className = 'bbx-popup-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    var dialog = document.createElement('div');
    dialog.className = 'bbx-popup';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', product.title || 'Product details');

    // ── Build dialog HTML ────────────────────────────────────────────────────
    var html = '';

    // Close button
    html += '<button class="bbx-popup-close" type="button" ' +
      'aria-label="' + t('popup_close', 'Close product details') + '">' +
      '×' +
      '</button>';

    // Image
    html += '<div class="bbx-popup-img-wrap">';
    if (product.featured_image) {
      html += '<img class="bbx-popup-img" src="' + product.featured_image +
        '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="eager" width="320" height="320">';
    } else {
      html += '<div class="bbx-popup-img-placeholder" aria-hidden="true">' +
        initialLetter(product.title) + '</div>';
    }
    html += '</div>';

    // Name
    html += '<h2 class="bbx-popup-name">' + (product.title || '') + '</h2>';

    // Origin tag — vendor or parsed origin from tags
    var origin = product.vendor || '';
    if (!origin) {
      var originTag = (product.tags || []).find(function (t) {
        return /^origin:/i.test(t);
      });
      if (originTag) origin = originTag.replace(/^origin:/i, '').trim();
    }
    if (origin) {
      html += '<p class="bbx-popup-origin">' + origin + '</p>';
    }

    // Trust tags — filter known trust keywords
    var TRUST_KEYWORDS = ['Natural', 'FSSAI', 'Vegan', 'Organic', 'No Additives',
      'Preservative Free', 'Gluten Free', 'Sugar Free', 'Raw', 'Dry Roasted'];
    var trustTags = (product.tags || []).filter(function (t) {
      return TRUST_KEYWORDS.some(function (kw) {
        return t.toLowerCase() === kw.toLowerCase();
      });
    });
    if (trustTags.length) {
      html += '<div class="bbx-popup-tags">';
      trustTags.forEach(function (t) {
        html += '<span class="bbx-popup-tag">' + t + '</span>';
      });
      html += '</div>';
    }

    // Description placeholder (lazy-fetched below)
    html += '<p class="bbx-popup-desc bbx-popup-desc--loading" id="bbx-popup-desc-' + product.id + '">' +
      t('popup_loading_desc', 'Loading details…') +
      '</p>';

    // Nutrition strip placeholder (lazy-fetched below — best-effort)
    html += '<div class="bbx-popup-nutrition" id="bbx-popup-nutrition-' + product.id + '" hidden></div>';

    // Live allocation note
    if (pkg) {
      html += '<p class="bbx-popup-alloc-note">';
      if (isAdded) {
        var curItem = state.items.find(function (it) { return it.product.id === product.id; });
        html += t('popup_alloc_in_box', 'In your box:') + ' <strong>' + (curItem ? curItem.allocatedG : 0) + 'g</strong>';
      } else if (!isFull) {
        html += slotsLeft === 1
          ? t('popup_alloc_would_get', 'Adding this gives each item %g%g · %n% slot left', { g: '<strong>' + wouldGetG + 'g</strong>', n: slotsLeft })
          : t('popup_alloc_would_get_plural', 'Adding this gives each item %g%g · %n% slots left', { g: '<strong>' + wouldGetG + 'g</strong>', n: slotsLeft });
      } else {
        html += t('popup_box_full_remove', 'Box is full — remove an item to add this');
      }
      html += '</p>';
    }

    // "View Product Page" link
    if (product.handle) {
      html += '<a class="bbx-popup-view-link" href="/products/' + product.handle + '" target="_blank" rel="noopener">' +
        t('popup_view_product', 'View full product page') +
        '</a>';
    }

    // "Add to Box" CTA — reuses the same toggle logic as the grid card
    if (!isAdded && !isFull) {
      html += '<button class="bbx-popup-add-btn" type="button" data-bbx-popup-add="' + product.id + '">' +
        t('popup_add_to_box', 'Add to Box · %g%g · %price%', { g: wouldGetG, price: bbx.money(wouldPay) }) +
        '</button>';
    } else if (isAdded) {
      html += '<button class="bbx-popup-add-btn bbx-popup-add-btn--remove" type="button" data-bbx-popup-remove="' + product.id + '">' +
        t('popup_remove_from_box', 'Remove from Box') +
        '</button>';
    } else {
      html += '<button class="bbx-popup-add-btn" type="button" disabled>' +
        t('popup_box_full_disabled', 'Box is full') +
        '</button>';
    }

    dialog.innerHTML = html;

    // Mount overlay + dialog into body
    document.body.appendChild(overlay);
    document.body.appendChild(dialog);
    document.body.classList.add('bbx-popup-open');

    // ── Lazy-fetch product details ────────────────────────────────────────────
    if (product.handle) {
      fetch('/products/' + product.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;

          // Description — strip HTML tags, truncate at ~200 chars
          var descEl = document.getElementById('bbx-popup-desc-' + product.id);
          if (descEl) {
            var rawDesc = (data.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
            var short   = rawDesc.length > 200 ? rawDesc.substring(0, 200) + '…' : rawDesc;
            if (short) {
              descEl.textContent = short;
              descEl.classList.remove('bbx-popup-desc--loading');
            } else {
              descEl.remove();
            }
          }

          // Nutrition strip — best-effort from metafields if present in .js payload
          // Shopify's /products/<handle>.js does NOT include metafields by default;
          // we check for a `metafields` key that some themes expose via liquid.
          // If absent, we omit gracefully — this is the documented fallback.
          var nutritionEl = document.getElementById('bbx-popup-nutrition-' + product.id);
          if (nutritionEl && data.metafields) {
            var nf = (data.metafields || []).find(function (m) {
              return m.namespace === 'custom' && m.key === 'nutrition_profile';
            });
            if (nf && nf.value) {
              try {
                var nutrition = typeof nf.value === 'string' ? JSON.parse(nf.value) : nf.value;
                var nutHtml = buildNutritionStrip(nutrition);
                if (nutHtml) {
                  nutritionEl.innerHTML = nutHtml;
                  nutritionEl.removeAttribute('hidden');
                }
              } catch (e) {
                // Omit gracefully — nutrition is best-effort
              }
            }
          }
        })
        .catch(function () {
          // Network error — remove loading state, leave blank
          var descEl = document.getElementById('bbx-popup-desc-' + product.id);
          if (descEl) descEl.remove();
        });
    } else {
      // No handle — clear loading state immediately
      var descEl = document.getElementById('bbx-popup-desc-' + product.id);
      if (descEl) descEl.remove();
    }

    // ── Focus trap setup ─────────────────────────────────────────────────────
    var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function getFocusable() {
      return Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE));
    }
    function trapFocus(e) {
      var focusable = getFocusable();
      if (!focusable.length) { e.preventDefault(); return; }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      if (e.key === 'Escape') { closePopup(); }
    }
    dialog.addEventListener('keydown', trapFocus);

    // ── Close popup ──────────────────────────────────────────────────────────
    function closePopup() {
      if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.classList.remove('bbx-popup-open');
      // Restore focus to the opener (ⓘ button)
      if (_opener && typeof _opener.focus === 'function') {
        _opener.focus();
      }
    }

    // Overlay click closes
    overlay.addEventListener('click', closePopup);

    // Close button
    var closeBtn = dialog.querySelector('.bbx-popup-close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    // ── Add / Remove actions ─────────────────────────────────────────────────
    // These reuse the same shared add/remove + rebalance path as the grid card.
    var addBtn = dialog.querySelector('[data-bbx-popup-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var cur = bbx.state.current;
        var already = cur.items.some(function (it) { return it.product.id === product.id; });
        if (!already && cur.items.length < maxItems) {
          cur.items.push({ product: product, allocatedG: 0, priceP: 0 });
          bbx.rebalance();
        }
        closePopup();
      });
    }
    var removeBtn = dialog.querySelector('[data-bbx-popup-remove]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        var cur = bbx.state.current;
        var idx = cur.items.findIndex(function (it) { return it.product.id === product.id; });
        if (idx !== -1) {
          cur.items.splice(idx, 1);
          bbx.rebalance();
        }
        closePopup();
      });
    }

    // ── Set focus into dialog ─────────────────────────────────────────────────
    // Small rAF so the CSS transition has started (bottom-sheet slide up)
    requestAnimationFrame(function () {
      var focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    });
  }

  // ── buildNutritionStrip() — best-effort from metafield payload ────────────
  /**
   * Build a compact nutrition strip HTML from a nutrition_profile metafield object.
   * Omits gracefully if the data shape is unexpected.
   *
   * @param {object} nutrition
   * @returns {string} HTML string, or '' if nothing renderable.
   */
  function buildNutritionStrip(nutrition) {
    if (!nutrition || typeof nutrition !== 'object') return '';

    // Try common field names from the sindhi_nutrition_profile metaobject
    var fields = [
      { label: 'Calories',      key: 'calories',      unit: 'kcal' },
      { label: 'Protein',       key: 'protein_g',     unit: 'g'    },
      { label: 'Total Fat',     key: 'fat_g',         unit: 'g'    },
      { label: 'Sat. Fat',      key: 'saturated_fat_g', unit: 'g', bold: true },
      { label: 'Carbs',         key: 'carbs_g',       unit: 'g'    },
      { label: 'Total Sugar',   key: 'sugar_g',       unit: 'g',   bold: true },
      { label: 'Fibre',         key: 'fibre_g',       unit: 'g'    },
      { label: 'Sodium',        key: 'sodium_mg',     unit: 'mg',  bold: true }
    ];

    var rows = fields.filter(function (f) {
      return nutrition[f.key] !== undefined && nutrition[f.key] !== null;
    });
    if (!rows.length) return '';

    var html = '<p class="bbx-popup-nutrition-title">' +
      t('nutrition_title', 'Nutrition per 100g') +
      '</p><div class="bbx-popup-nutrition-grid">';
    rows.forEach(function (f) {
      html += '<div class="bbx-popup-nutrition-cell' + (f.bold ? ' is-bold' : '') + '">' +
        '<span class="bbx-popup-nutrition-label">' + f.label + '</span>' +
        '<span class="bbx-popup-nutrition-value">' + nutrition[f.key] + f.unit + '</span>' +
        '</div>';
    });
    html += '</div>';
    return html;
  }

  // ── Wire [data-bbx-info] buttons via event delegation ────────────────────
  root.addEventListener('click', function (e) {
    var infoBtn = e.target.closest('[data-bbx-info]');
    if (!infoBtn) return;
    var productId = parseInt(infoBtn.getAttribute('data-bbx-info'), 10);
    if (!isNaN(productId)) openInfo(productId);
  });

  // ── Expose on namespace for external callers ──────────────────────────────
  bbx.openInfo      = openInfo;
  bbx.renderPreview = renderPreview; // redundant but explicit

  // ── Initial render (in case a package was auto-selected in Task 7 init) ──
  renderPreview();

  // Self-check — asserts real renderer behaviour, not a local re-implementation.
  (function selfCheckPreview() {
    function assert(cond, msg) { if (!cond) console.error('[bbx][selfcheck] ' + msg); }
    assert(wedgeGeometry('radial', 1, 0).cls.indexOf('--full') !== -1, 'n=1 should be full');
    assert(wedgeGeometry('radial', 2, 1).style === 'inset:0 0 0 50%;', 'n=2 second half inset wrong');
    assert(wedgeGeometry('radial', 4, 0).style.indexOf('clip-path:polygon(50% 50%,') === 0, 'n=4 should clip');
    assert(wedgeGeometry('radial', 3, 0).style.indexOf('--wx:') !== -1, 'slice must emit a centroid');
    assert(wedgeGeometry('grid', 5, 2).cls.indexOf('--cell') !== -1, 'grid family should use cells');
    assert(shapeFamily('nonsense-shape') === 'radial', 'unknown shape must fall back to radial');
    [3, 4, 5, 6, 7, 8].forEach(function (n) { assert(n >= 3, 'divider should draw at n=' + n); });
    [1, 2].forEach(function (n) { assert(n < 3, 'divider should suppress at n=' + n); });
  })();
})();

// ---------------------------------------------------------------------------
// Task 9 — Lazy "browse all" drawer via Section Rendering API
// ---------------------------------------------------------------------------
// Fetches /?section_id=sindhi-bundle-drawer once on first openDrawer() call,
// caches the HTML on root.__bbx.drawerHTML, then builds the full drawer chrome
// (overlay, panel, search, category chips, selected chips, "Add N items" CTA).
// All add/remove logic reuses the same state.current.items path + rebalance()
// as the grid cards. A11y: focus trap, Esc, restore focus, aria-modal.
(function () {
  'use strict';

  var root =
    document.querySelector('[data-bbx]') ||
    document.querySelector('.sindhi-bundle-builder');
  if (!root || !root.__bbx) return;

  var bbx = root.__bbx;
  var t = function(key, fallback, vars) { return bbx.t ? bbx.t(key, fallback, vars) : fallback; };

  // ── Internal state ────────────────────────────────────────────────────────

  /** Cached raw HTML string from the SRA fetch. null = not yet loaded. */
  var _drawerHTML  = null;

  /** Whether the drawer is currently visible. */
  var _drawerOpen  = false;

  /** Whether an SRA fetch is in flight — guards against double-fetch on rapid re-open. */
  var _drawerFetching = false;

  /** The element that triggered openDrawer() — restored on close. */
  var _openerEl    = null;

  /** Live references to the mounted overlay/panel so close() can reach them. */
  var _overlay     = null;
  var _panel       = null;
  var _slotZone    = null;
  var _maxItems    = 1;
  var _waFloater   = null;
  var _waFloaterDisplay = '';

  /** Pending selection: product objects selected in drawer but not yet confirmed. */
  var _pending     = [];  // [{ product, variants }]

  // ── Focusable selector for focus-trap ─────────────────────────────────────
  var FOCUSABLE_SEL =
    'a[href]:not([disabled]), button:not([disabled]), ' +
    '[tabindex]:not([tabindex="-1"]):not([disabled]), ' +
    'input:not([disabled]), select:not([disabled]), textarea:not([disabled])';

  // ── Helpers ───────────────────────────────────────────────────────────────

  /**
   * Parse the data-variants JSON attribute from a drawer row.
   * Returns the parsed array, or [] on error.
   * @param {HTMLElement} row
   * @returns {Array}
   */
  function parseRowVariants(row) {
    var raw = row.getAttribute('data-variants') || '[]';
    try {
      // The Liquid escape filter HTML-encodes quotes; unescape before parse.
      var unescaped = raw
        .replace(/&quot;/g, '"')
        .replace(/&#x27;/g, "'")
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, '&');
      return JSON.parse(unescaped);
    } catch (e) {
      console.warn('[bbx T9] Failed to parse data-variants:', e);
      return [];
    }
  }

  /**
   * Build a product-like object from a drawer row that is compatible with
   * the engine's featuredProducts shape:
   *   { id, gid, title, handle, featured_image, tags, variants }
   *
   * @param {HTMLElement} row
   * @returns {object}
   */
  function rowToProduct(row) {
    var gid       = row.getAttribute('data-product-gid') || '';
    var id        = parseInt(row.getAttribute('data-product-id') || '0', 10);
    var handle    = row.getAttribute('data-handle') || '';
    var tagsRaw   = row.getAttribute('data-tags') || '';
    var tags      = tagsRaw ? tagsRaw.split('|').map(function (t) {
      return t.trim()
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#x27;/g, "'")
        .replace(/&#39;/g, "'");
    }).filter(Boolean) : [];
    var variants  = parseRowVariants(row);
    var nameEl    = row.querySelector('.bbx-drawer-row__name');
    var title     = nameEl ? nameEl.textContent.trim() : '';
    var imgEl     = row.querySelector('.bbx-drawer-row__img');
    var featured_image = imgEl ? imgEl.getAttribute('src') : '';
    var fill_image = row.getAttribute('data-fill-image') || '';

    return { id: id, gid: gid, title: title, handle: handle, featured_image: featured_image, fill_image: fill_image, tags: tags, variants: variants };
  }

  // ── Category chips (derived from row data-tags) ───────────────────────────

  /**
   * Collect all unique category tags from rows, excluding low-signal tags.
   * Returns sorted array of unique non-empty tag strings.
   *
   * @param {NodeList|Array} rows
   * @returns {string[]}
   */
  function deriveCategories(rows) {
    var seen = {};
    var categories = [];
    // Suppress internal/low-signal tags — includes GST/tax/HSN to prevent Shopify tax tags leaking
    var SKIP = /^(origin:|fssai|natural|vegan|organic|seasonal|instock|new|sale|featured|gst|tax|hsn|__)/i;
    Array.prototype.forEach.call(rows, function (row) {
      var raw = row.getAttribute('data-tags') || '';
      if (!raw) return;
      raw.split('|').forEach(function (t) {
        t = t.trim();
        t = t.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&#39;/g, "'");
        // Case-insensitive dedup: "Best Seller" and "best seller" are the same chip
        var key = t.toLowerCase();
        if (!t || SKIP.test(t) || seen[key]) return;
        seen[key] = true;
        categories.push(t);
      });
    });
    return categories.sort();
  }

  // ── Search filter ─────────────────────────────────────────────────────────

  /**
   * Filter rows by search query (title match) and active category chip.
   * Hides non-matching rows; shows matching ones.
   *
   * @param {NodeList|Array} rows
   * @param {string} query
   * @param {string} activeCategory  Empty string = no category filter.
   */
  function filterRows(rows, query, activeCategory) {
    var q = query.trim().toLowerCase();
    Array.prototype.forEach.call(rows, function (row) {
      var nameEl = row.querySelector('.bbx-drawer-row__name');
      var title  = nameEl ? nameEl.textContent.toLowerCase() : '';
      var tags   = (row.getAttribute('data-tags') || '').toLowerCase();

      var matchesQuery    = !q || title.indexOf(q) !== -1;
      var matchesCategory = !activeCategory ||
        tags.split('|').some(function (t) {
          var decoded = t.trim()
            .replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#39;/g, "'");
          return decoded === activeCategory.toLowerCase();
        });

      var usable = !row.classList.contains('is-unavailable');
      row.style.display = (usable && matchesQuery && matchesCategory) ? '' : 'none';
    });
  }

  // ── Pending-selection management ──────────────────────────────────────────

  /**
   * Return true if a product ID is already in the committed items list.
   * @param {number} productId
   * @returns {boolean}
   */
  function isCommitted(productId) {
    return bbx.state.current.items.some(function (it) {
      return it.product.id === productId;
    });
  }

  /**
   * Return true if a product ID is in the pending drawer selection.
   * @param {number} productId
   * @returns {boolean}
   */
  function isPending(productId) {
    return _pending.some(function (p) { return p.product.id === productId; });
  }

  // ── Build the "Add N items" CTA label ─────────────────────────────────────

  /**
   * Re-render the confirm CTA label based on _pending count.
   * @param {HTMLElement} ctaBtn
   */
  function refreshConfirmCta(ctaBtn) {
    if (!ctaBtn) return;
    var n = _pending.length;
    if (n === 0) {
      ctaBtn.textContent = t('drawer_cta_empty', 'Select items to add');
      ctaBtn.disabled = true;
    } else {
      ctaBtn.textContent = n === 1
        ? t('drawer_cta_n_one', 'Add %n% item to box', { n: n })
        : t('drawer_cta_n_other', 'Add %n% items to box', { n: n });
      ctaBtn.disabled = false;
    }
  }

  /**
   * Update the gram-per-item note in the footer.
   * @param {HTMLElement} gramEl
   */
  function refreshGramNote(gramEl) {
    if (!gramEl) return;
    var pkg  = bbx.state.current.pkg;
    var capG = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
    if (!capG || !_maxItems) { gramEl.style.display = 'none'; return; }
    var each = Math.floor(capG / _maxItems);
    gramEl.textContent = t('drawer_gram_note', 'Each item: ~%g%g', { g: each });
    gramEl.style.display = '';
  }

  /**
   * Rebuild the slot zone (committed + pending items) pinned below the drawer header.
   * @param {HTMLElement} slotZone
   */
  function refreshSlotZone(slotZone) {
    if (!slotZone) return;
    var track = slotZone.querySelector('.bbx-drawer-slots__track');
    if (!track) return;
    track.innerHTML = '';
    var committed = (bbx.state.current.items || []).map(function (it) {
      return { product: it.product, type: 'committed' };
    });
    var pending = _pending.map(function (p) {
      return { product: p.product, type: 'pending' };
    });
    var all = committed.concat(pending);

    // Update the count label
    var headerEl = slotZone.querySelector('[data-bbx-slot-header]');
    if (headerEl) {
      headerEl.textContent = all.length === 0
        ? t('slot_zone_title', 'Your Box')
        : 'Your Box  ·  ' + all.length + ' / ' + _maxItems;
    }

    for (var i = 0; i < _maxItems; i++) {
      var slot = document.createElement('div');
      if (i < all.length) {
        var entry = all[i];
        slot.className = 'bbx-drawer-slot bbx-drawer-slot--' + entry.type;
        var thumbDiv = document.createElement('div');
        thumbDiv.className = 'bbx-drawer-slot__thumb';
        if (entry.product.featured_image) {
          var sImg = document.createElement('img');
          sImg.src = entry.product.featured_image;
          sImg.alt = entry.product.title || '';
          sImg.className = 'bbx-drawer-slot__img';
          thumbDiv.appendChild(sImg);
        } else {
          var sLetter = document.createElement('span');
          sLetter.className = 'bbx-drawer-slot__letter';
          sLetter.textContent = (entry.product.title || '?').charAt(0).toUpperCase();
          thumbDiv.appendChild(sLetter);
        }
        if (entry.type === 'pending') {
          var sRemove = document.createElement('button');
          sRemove.type = 'button';
          sRemove.className = 'bbx-drawer-slot__remove';
          sRemove.setAttribute('aria-label', 'Remove ' + (entry.product.title || ''));
          sRemove.textContent = '×';
          (function (pid) {
            sRemove.addEventListener('click', function (e) {
              e.stopPropagation();
              var idx = _pending.findIndex(function (p) { return p.product.id === pid; });
              if (idx !== -1) _pending.splice(idx, 1);
              var panelRows = _panel ? _panel.querySelectorAll('[data-bbx-drawer-row]') : [];
              refreshSlotZone(slotZone);
              refreshAllRowStates(panelRows, _maxItems);
              var cta    = _panel ? _panel.querySelector('.bbx-drawer-confirm-btn') : null;
              var gramEl = _panel ? _panel.querySelector('[data-bbx-gram-note]') : null;
              if (cta)    refreshConfirmCta(cta);
              if (gramEl) refreshGramNote(gramEl);
            });
          })(entry.product.id);
          thumbDiv.appendChild(sRemove);
        }
        slot.appendChild(thumbDiv);
        var sName = document.createElement('span');
        sName.className = 'bbx-drawer-slot__name';
        sName.textContent = (entry.product.title || '').split(' ')[0];
        slot.appendChild(sName);
      } else {
        slot.className = 'bbx-drawer-slot bbx-drawer-slot--empty';
        var sph = document.createElement('span');
        sph.className = 'bbx-drawer-slot__ph';
        sph.textContent = String(i + 1);
        slot.appendChild(sph);
      }
      track.appendChild(slot);
    }
  }

  // ── Selected-items chips (above the CTA) ─────────────────────────────────

  /**
   * Re-render the pending chips strip inside the drawer footer.
   * Each chip has a dismiss (×) button that removes the product from _pending.
   *
   * @param {HTMLElement} chipsEl    Container for chips.
   * @param {HTMLElement} ctaBtn     Passed through for CTA refresh.
   * @param {NodeList}    rows       All drawer rows (to revert their button state).
   */
  function refreshPendingChips(chipsEl, ctaBtn, rows) {
    if (!chipsEl) return;
    chipsEl.innerHTML = '';

    _pending.forEach(function (entry) {
      var chip = document.createElement('span');
      chip.className = 'bbx-dchip';
      chip.setAttribute('data-bbx-dchip', entry.product.id);

      var label = document.createElement('span');
      label.className = 'bbx-dchip__label';
      label.textContent = entry.product.title || '';
      chip.appendChild(label);

      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'bbx-dchip__dismiss';
      dismiss.setAttribute('aria-label', t('drawer_chip_remove_aria', 'Remove %title% from selection', { title: entry.product.title || '' }));
      dismiss.textContent = '×'; // ×

      dismiss.addEventListener('click', function () {
        var idx = _pending.findIndex(function (p) { return p.product.id === entry.product.id; });
        if (idx !== -1) _pending.splice(idx, 1);

        // Revert the row's button state
        if (rows) {
          Array.prototype.forEach.call(rows, function (row) {
            var pid = parseInt(row.getAttribute('data-product-id') || '0', 10);
            if (pid === entry.product.id) {
              setRowButtonState(row, false, false);
            }
          });
        }
        refreshPendingChips(chipsEl, ctaBtn, rows);
        refreshConfirmCta(ctaBtn);
      });

      chip.appendChild(dismiss);
      chipsEl.appendChild(chip);
    });
  }

  /**
   * Set the add/remove button appearance on a drawer row.
   * @param {HTMLElement} row
   * @param {boolean} added
   * @param {boolean} disabled
   */
  function setRowButtonState(row, added, disabled) {
    var btn = row.querySelector('[data-bbx-drawer-add]');
    if (!btn) return;
    row.classList.toggle('is-added', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.textContent = added ? t('drawer_row_added', 'In Box') : t('drawer_row_add', '+ Add');
    btn.disabled = disabled && !added;
    btn.setAttribute('aria-disabled', (disabled && !added) ? 'true' : 'false');
    var nameEl = row.querySelector('.bbx-drawer-row__name');
    var title  = nameEl ? nameEl.textContent.trim() : '';
    btn.setAttribute('aria-label', (added ? t('remove', 'Remove') + ' ' : t('add', 'Add') + ' ') + title + (added ? ' from selection' : ' to box'));
  }

  // ── Refresh all row button states ─────────────────────────────────────────

  /**
   * After a state change (add/remove pending), update all row button states.
   * Rules:
   *  - committed items:  button shows "Added", disabled (already in box from grid)
   *  - pending items:    button shows "Added", not disabled (can dismiss)
   *  - box full + not in set: disabled
   *  - otherwise: enabled, text "Add"
   *
   * @param {NodeList} rows
   * @param {number}   maxItems
   */
  function refreshAllRowStates(rows, maxItems) {
    var committedCount = bbx.state.current.items.length;
    var pendingCount   = _pending.length;
    var totalCount     = committedCount + pendingCount;
    var isFull         = totalCount >= maxItems;

    Array.prototype.forEach.call(rows, function (row) {
      var pid = parseInt(row.getAttribute('data-product-id') || '0', 10);

      // Mark rows whose product has no parseable variant weight title
      if (!row.hasAttribute('data-bbx-weight-checked')) {
        row.setAttribute('data-bbx-weight-checked', '1');
        var product = rowToProduct(row);
        if (!bbx.productHasWeightTitle(product)) {
          // Hide rather than disable — the old branch injected merchant admin
          // instructions into a customer-facing tooltip. The class is what
          // filterRows() checks, so hiding survives search and category filtering.
          row.classList.add('is-unavailable');
          row.style.display = 'none';
          row.setAttribute('aria-hidden', 'true');
          return;
        }
      }

      if (row.classList.contains('is-unavailable')) return;

      var committed = isCommitted(pid);
      var pending   = isPending(pid);
      var inSet     = committed || pending;
      setRowButtonState(row, inSet, isFull && !inSet);
    });
  }

  // ── Drawer chrome builder ─────────────────────────────────────────────────

  /**
   * Mount the drawer chrome (overlay + slide-up panel) into [data-bbx-drawer-mount].
   * The rawHtml parameter is the innerHTML of the fetched SRA section.
   *
   * @param {string} rawHtml
   */
  function mountDrawer(rawHtml) {
    var mountEl = root.querySelector('[data-bbx-drawer-mount]');
    if (!mountEl) { console.error('[bbx T9] No [data-bbx-drawer-mount] found.'); return; }

    // Compute context
    var state    = bbx.state.current;
    var pkg      = state.pkg;
    var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;
    _maxItems = maxItems;

    // Reset pending on each open (fresh slate; committed items persist)
    _pending = [];

    // ── Overlay ──────────────────────────────────────────────────────────────
    var overlay = document.createElement('div');
    overlay.className = 'bbx-drawer-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('data-bbx-drawer-overlay', '');

    // ── Panel ─────────────────────────────────────────────────────────────────
    var panel = document.createElement('div');
    panel.className = 'bbx-drawer-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', t('drawer_label', 'Browse all varieties'));
    panel.setAttribute('data-bbx-drawer-panel', '');

    // ── Handle bar (visual drag affordance) ──────────────────────────────────
    var handleBar = document.createElement('div');
    handleBar.className = 'bbx-drawer-handle-bar';
    var handle = document.createElement('div');
    handle.className = 'bbx-drawer-handle';
    handleBar.appendChild(handle);
    panel.appendChild(handleBar);

    // ── Panel header ──────────────────────────────────────────────────────────
    var header = document.createElement('div');
    header.className = 'bbx-drawer-header';

    var headingWrap = document.createElement('div');
    headingWrap.className = 'bbx-drawer-header__text';

    var heading = document.createElement('h2');
    heading.className = 'bbx-drawer-heading';
    heading.textContent = t('drawer_heading', 'All Varieties');
    headingWrap.appendChild(heading);

    var drawerSub = document.createElement('p');
    drawerSub.className = 'bbx-drawer-sub';
    drawerSub.textContent = t('drawer_label', 'Browse and select items to add');
    headingWrap.appendChild(drawerSub);

    header.appendChild(headingWrap);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'bbx-drawer-close';
    closeBtn.setAttribute('aria-label', t('drawer_close', 'Close variety browser'));
    closeBtn.textContent = '×'; // ×
    header.appendChild(closeBtn);

    panel.appendChild(header);

    // ── Slot zone (box composition pinned below header) ───────────────────────
    var slotZone   = document.createElement('div');
    slotZone.className = 'bbx-drawer-slots';
    var slotLabel  = document.createElement('span');
    slotLabel.className = 'bbx-drawer-slots__label';
    slotLabel.setAttribute('data-bbx-slot-header', '');
    slotLabel.textContent = t('slot_zone_title', 'Your Box');
    slotZone.appendChild(slotLabel);
    var slotTrack  = document.createElement('div');
    slotTrack.className = 'bbx-drawer-slots__track';
    slotZone.appendChild(slotTrack);
    panel.appendChild(slotZone);
    _slotZone = slotZone;

    // ── Search bar ────────────────────────────────────────────────────────────
    var searchWrap = document.createElement('div');
    searchWrap.className = 'bbx-drawer-search-wrap';

    var searchIcon = document.createElement('span');
    searchIcon.className = 'bbx-drawer-search-icon';
    searchIcon.setAttribute('aria-hidden', 'true');
    searchIcon.textContent = '⌕';
    searchWrap.appendChild(searchIcon);

    var searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.className = 'bbx-drawer-search';
    searchInput.placeholder = t('drawer_search_placeholder', 'Search varieties…');
    searchInput.setAttribute('aria-label', t('drawer_search_aria', 'Search varieties'));
    searchInput.autocomplete = 'off';
    searchWrap.appendChild(searchInput);

    panel.appendChild(searchWrap);

    // ── Insert the SRA-fetched row HTML ───────────────────────────────────────
    // Parse the raw HTML into a temporary container so we can extract the
    // .bbx-drawer-section node (the SRA wraps in a <div id="shopify-section-...">).
    var tmpDiv = document.createElement('div');
    tmpDiv.innerHTML = rawHtml;

    var drawerSection = tmpDiv.querySelector('[data-bbx-drawer-root]');
    var listEl        = drawerSection ? drawerSection.querySelector('[data-bbx-drawer-list]') : null;

    // ── Category chips (derived from rows) ───────────────────────────────────
    var chipsBar = document.createElement('div');
    chipsBar.className = 'bbx-drawer-chips-bar';
    chipsBar.setAttribute('role', 'group');
    chipsBar.setAttribute('aria-label', t('drawer_filter_aria', 'Filter by category'));

    var allRows = listEl ? listEl.querySelectorAll('[data-bbx-drawer-row]') : [];

    // Use admin-defined chips when provided; fall back to deriving from product tags
    var adminChips = bbx.cfg.drawerFilterChips
      ? String(bbx.cfg.drawerFilterChips).split(',').map(function (c) { return htmlEntitiesDecode(c.trim()); }).filter(Boolean)
      : [];
    var categories = adminChips.length ? adminChips : deriveCategories(allRows);

    var activeCategory = '';

    if (categories.length) {
      // "All" chip
      var allChip = document.createElement('button');
      allChip.type = 'button';
      allChip.className = 'bbx-cat-chip is-active';
      allChip.textContent = t('drawer_all_chip', 'All');
      allChip.setAttribute('data-bbx-cat', '');
      allChip.setAttribute('aria-pressed', 'true');
      chipsBar.appendChild(allChip);

      categories.forEach(function (cat) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bbx-cat-chip';
        chip.textContent = cat;
        chip.setAttribute('data-bbx-cat', cat);
        chip.setAttribute('aria-pressed', 'false');
        chipsBar.appendChild(chip);
      });

      panel.appendChild(chipsBar);
    }

    // ── Scrollable product list ───────────────────────────────────────────────
    var bodyEl = document.createElement('div');
    bodyEl.className = 'bbx-drawer-body';

    if (listEl) {
      bodyEl.appendChild(listEl); // move into panel (removes from tmpDiv)
    } else {
      var emptyMsg = document.createElement('p');
      emptyMsg.className = 'bbx-drawer-empty-msg';
      emptyMsg.textContent = t('drawer_empty', 'No varieties found.');
      bodyEl.appendChild(emptyMsg);
    }

    panel.appendChild(bodyEl);

    // ── Drawer footer: gram note + confirm CTA ───────────────────────────────
    var footer = document.createElement('div');
    footer.className = 'bbx-drawer-footer';

    var gramNoteEl = document.createElement('p');
    gramNoteEl.className = 'bbx-drawer-gram-note';
    gramNoteEl.setAttribute('data-bbx-gram-note', '');
    footer.appendChild(gramNoteEl);

    var confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = 'bbx-drawer-confirm-btn';
    refreshConfirmCta(confirmBtn); // sets text + disabled
    footer.appendChild(confirmBtn);

    panel.appendChild(footer);

    // ── Mount into DOM ────────────────────────────────────────────────────────
    mountEl.appendChild(overlay);
    mountEl.appendChild(panel);
    document.body.classList.add('bbx-drawer-body-open');

    _overlay    = overlay;
    _panel      = panel;
    _drawerOpen = true;

    // ── Apply initial row states (committed items appear as "Added" immediately)
    var freshRows = listEl ? listEl.querySelectorAll('[data-bbx-drawer-row]') : [];
    refreshAllRowStates(freshRows, maxItems);
    refreshSlotZone(slotZone);
    refreshGramNote(gramNoteEl);

    // ── Wire category chip clicks ─────────────────────────────────────────────
    chipsBar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-bbx-cat]');
      if (!chip) return;
      var cat = chip.getAttribute('data-bbx-cat') || '';
      activeCategory = cat;

      chipsBar.querySelectorAll('[data-bbx-cat]').forEach(function (c) {
        var isActive = c === chip;
        c.classList.toggle('is-active', isActive);
        c.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      filterRows(freshRows, searchInput ? searchInput.value : '', activeCategory);
    });

    // ── Wire search ───────────────────────────────────────────────────────────
    searchInput.addEventListener('input', function () {
      filterRows(freshRows, searchInput.value, activeCategory);
    });

    // ── Wire row add/remove buttons ───────────────────────────────────────────
    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bbx-drawer-add]');
        if (!btn) return;

        var row       = btn.closest('[data-bbx-drawer-row]');
        if (!row) return;
        var pid       = parseInt(row.getAttribute('data-product-id') || '0', 10);

        // Block unavailable products (no parseable weight in variant title).
        // Fix 10 (branch review): this branch used to also toggle a
        // '.bbx-unavail-tip' tooltip element, but no such element is ever
        // created in the drawer row markup — rowTip was permanently null.
        // Removed the dead lookup; the guard below (blocking the add) is the
        // real, tested behaviour (see the "money bug" self-check further down).
        if (row.classList.contains('is-unavailable')) {
          return;
        }

        var committed = isCommitted(pid);
        var pending   = isPending(pid);

        if (committed) return; // committed items cannot be toggled from the drawer

        if (pending) {
          // Remove from pending
          var idx = _pending.findIndex(function (p) { return p.product.id === pid; });
          if (idx !== -1) _pending.splice(idx, 1);
        } else {
          // Add to pending — guard maxItems
          var committedCount = bbx.state.current.items.length;
          var pendingCount   = _pending.length;
          if (committedCount + pendingCount >= maxItems) {
            // Accessible cap notification — update aria-live region
            var capNote = panel.querySelector('.bbx-drawer-cap-note');
            if (!capNote) {
              capNote = document.createElement('p');
              capNote.className = 'bbx-drawer-cap-note';
              capNote.setAttribute('role', 'alert');
              capNote.setAttribute('aria-live', 'assertive');
              header.appendChild(capNote);
            }
            capNote.textContent = t('drawer_cap_note', 'Box is full (%max% items maximum). Remove an item first.', { max: maxItems });
            return;
          }
          var product = rowToProduct(row);
          _pending.push({ product: product, variants: product.variants });
        }

        refreshAllRowStates(freshRows, maxItems);
        refreshSlotZone(slotZone);
        refreshConfirmCta(confirmBtn);
        refreshGramNote(gramNoteEl);
      });
    }

    // ── Wire confirm CTA ─────────────────────────────────────────────────────
    confirmBtn.addEventListener('click', function () {
      var state = bbx.state.current;
      var pkg   = state.pkg;
      var maxItems = pkg ? (parseInt(pkg.max_items, 10) || 1) : 1;

      _pending.forEach(function (entry) {
        // Guard: do not double-add if already committed (defensive)
        var alreadyIn = state.items.some(function (it) {
          return it.product.id === entry.product.id;
        });
        if (!alreadyIn && state.items.length < maxItems) {
          state.items.push({ product: entry.product, allocatedG: 0, priceP: 0 });
        }
      });

      bbx.rebalance();
      // Re-render grid so cards for drawer-added products reflect added/full state
      bbx.renderGrid();
      closeDrawer();
    });

    // ── Focus trap ────────────────────────────────────────────────────────────
    function getFocusable() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE_SEL));
    }
    function trapFocus(e) {
      var focusable = getFocusable();
      if (!focusable.length) { e.preventDefault(); return; }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDrawer();
      }
    }
    panel.addEventListener('keydown', trapFocus);

    // ── Close triggers ────────────────────────────────────────────────────────
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    // ── Wire inline styles (inherit builder's CSS vars) ───────────────────────
    // Pass the builder's --bbx-* vars down so the drawer rows use the same palette.
    var builderStyles = getComputedStyle(root);
    var drawerVars = [
      '--bbx-bg', '--bbx-text', '--bbx-heading', '--bbx-muted',
      '--bbx-card-bg', '--bbx-border', '--bbx-accent'
    ];
    var styleStr = '';
    drawerVars.forEach(function (v) {
      var val = builderStyles.getPropertyValue(v).trim();
      if (val) styleStr += v + ':' + val + ';';
    });
    if (styleStr) panel.setAttribute('style', styleStr);

    // ── Set initial focus ─────────────────────────────────────────────────────
    requestAnimationFrame(function () {
      searchInput.focus();
    });

    // ── Inject drawer chrome styles (once per page) ───────────────────────────
    injectDrawerStyles();
  }

  // ── Inject drawer chrome CSS ─────────────────────────────────────────────

  /**
   * Inject the drawer chrome CSS once per page load.
   * All values use brand CSS custom properties and global type tokens.
   */
  function injectDrawerStyles() {
    if (document.getElementById('bbx-drawer-styles')) return;
    var style = document.createElement('style');
    style.id = 'bbx-drawer-styles';
    style.textContent = [
      /* Body scroll lock */
      'body.bbx-drawer-body-open{overflow:hidden;}',
      /* Overlay */
      '.bbx-drawer-overlay{',
        'position:fixed;inset:0;z-index:950;',
        'background:rgba(15,15,15,0.45);',
        'animation:bbxFadeIn 0.22s ease both;',
      '}',
      /* Panel */
      '.bbx-drawer-panel{',
        'position:fixed;z-index:951;',
        'background:var(--cream,#FFF8F0);',
        'display:flex;flex-direction:column;',
        'overflow:hidden;',
        /* mobile: bottom sheet */
        'bottom:0;left:0;right:0;',
        'max-height:90dvh;border-radius:20px 20px 0 0;',
        'box-shadow:0 -4px 32px rgba(0,0,0,0.18);',
        'animation:bbxSlideUp 0.28s cubic-bezier(0.32,0.72,0,1) both;',
      '}',
      '@media(min-width:750px){',
        '.bbx-drawer-panel{',
          'top:0;right:0;bottom:0;left:auto;',
          'width:min(400px,92vw);max-height:none;border-radius:0;',
          'animation:bbxSlideRight 0.28s cubic-bezier(0.32,0.72,0,1) both;',
          'box-shadow:-4px 0 24px rgba(0,0,0,0.14);',
        '}',
      '}',
      /* Handle bar */
      '.bbx-drawer-handle-bar{',
        'display:flex;justify-content:center;',
        'padding:10px 0 0;background:#ffffff;flex-shrink:0;',
      '}',
      '.bbx-drawer-handle{',
        'width:36px;height:4px;',
        'background:var(--gray-light,#e8e8e8);border-radius:2px;',
      '}',
      /* Header */
      '.bbx-drawer-header{',
        'display:flex;align-items:flex-start;justify-content:space-between;',
        'gap:12px;padding:12px 20px 14px;',
        'background:#ffffff;',
        'border-bottom:1px solid var(--gray-light,#e8e8e8);',
        'flex-shrink:0;',
      '}',
      '.bbx-drawer-header__text{flex:1;min-width:0;}',
      '.bbx-drawer-heading{',
        'font-family:var(--font-heading--family,"Cormorant Garamond",Georgia,serif);',
        'font-size:1.5rem;font-weight:700;',
        'color:var(--dark-chocolate,#3E2723);',
        'margin:0;line-height:1;letter-spacing:-0.01em;',
      '}',
      '.bbx-drawer-sub{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.7rem;color:var(--gray,#8c8c8c);margin:2px 0 0;',
      '}',
      '.bbx-drawer-close{',
        'flex-shrink:0;background:none;border:none;cursor:pointer;',
        'font-size:var(--type-h3,1.4rem);line-height:1;',
        'color:var(--dark-soft,#4a4a4a);',
        'padding:2px 6px;border-radius:4px;margin-top:-2px;',
        'transition:color 0.15s ease;',
      '}',
      '.bbx-drawer-close:hover{color:var(--dark,#1a1a1a);}',
      '.bbx-drawer-close:focus-visible{outline:2px solid var(--gold,#ab8744);outline-offset:2px;}',
      /* Search bar */
      '.bbx-drawer-search-wrap{',
        'display:flex;align-items:center;gap:8px;',
        'background:#ffffff;',
        'border:none;border-bottom:1.5px solid var(--gray-light,#e8e8e8);',
        'border-radius:0;padding:10px 20px;',
        'margin:0;flex-shrink:0;',
      '}',
      '.bbx-drawer-search-icon{',
        'font-size:0.85rem;color:var(--gray,#8c8c8c);',
        'flex-shrink:0;line-height:1;',
      '}',
      '.bbx-drawer-search{',
        'flex:1;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.82rem;color:var(--dark,#1a1a1a);',
        'background:transparent;border:none;outline:none;',
        '-webkit-appearance:none;appearance:none;',
      '}',
      '.bbx-drawer-search::placeholder{color:var(--gray,#8c8c8c);}',
      '.bbx-drawer-search::-webkit-search-cancel-button{display:none;}',
      /* Category chips bar */
      '.bbx-drawer-chips-bar{',
        'display:flex;gap:6px;overflow-x:auto;',
        'padding:10px 20px 0;flex-shrink:0;',
        'scrollbar-width:none;',
      '}',
      '.bbx-drawer-chips-bar::-webkit-scrollbar{display:none;}',
      '.bbx-cat-chip{',
        'white-space:nowrap;flex-shrink:0;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.7rem;font-weight:500;',
        'padding:5px 12px;border-radius:20px;cursor:pointer;',
        'border:1.5px solid var(--gray-light,#e8e8e8);',
        'background:#ffffff;color:var(--dark-soft,#4a4a4a);',
        'transition:background 0.15s ease,border-color 0.15s ease,color 0.15s ease;',
        'line-height:1;',
      '}',
      '.bbx-cat-chip.is-active{',
        'background:var(--dark-chocolate,#3E2723);',
        'color:var(--cream,#FFF8F0);',
        'border-color:var(--dark-chocolate,#3E2723);',
      '}',
      '.bbx-cat-chip:hover:not(.is-active){',
        'border-color:var(--gold,#ab8744);',
        'color:var(--dark-chocolate,#3E2723);',
      '}',
      '.bbx-cat-chip:focus-visible{outline:2px solid var(--gold,#ab8744);outline-offset:2px;}',
      /* Scrollable body */
      '.bbx-drawer-body{',
        'flex:1;overflow-y:auto;overflow-x:hidden;',
        'padding:0 20px;',
        '-webkit-overflow-scrolling:touch;',
        'scrollbar-width:thin;',
      '}',
      /* Cap notification */
      '.bbx-drawer-cap-note{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:var(--type-micro,0.72rem);color:var(--gray,#8c8c8c);',
        'padding:8px 0 0;display:none;',
      '}',
      '.bbx-drawer-cap-note.is-visible{display:block;}',
      /* Empty message */
      '.bbx-drawer-empty-msg{',
        'padding:32px 0;text-align:center;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:var(--type-body,0.95rem);',
        'color:var(--gray,#8c8c8c);margin:0;',
      '}',
      /* Pending chips strip (above footer, inside footer div) */
      '.bbx-drawer-pending-chips{',
        'padding:8px 20px 0;background:#ffffff;',
        'border-top:1px solid var(--gray-light,#e8e8e8);',
        'flex-shrink:0;',
      '}',
      '.bbx-drawer-pending-chips:empty{display:none;}',
      '.bbx-dchip{',
        'display:inline-flex;align-items:center;gap:4px;',
        'white-space:nowrap;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.7rem;font-weight:500;padding:4px 10px;',
        'background:var(--gold-pale,#f7f0e3);',
        'border:1px solid rgba(171,135,68,0.3);',
        'border-radius:20px;color:var(--dark-chocolate,#3E2723);',
        'margin:0 6px 8px 0;',
      '}',
      '.bbx-dchip__label{color:var(--dark-chocolate,#3E2723);}',
      '.bbx-dchip__dismiss{',
        'background:none;border:none;cursor:pointer;padding:0;',
        'min-width:24px;min-height:24px;',
        'display:inline-flex;align-items:center;justify-content:center;',
        'color:var(--gray,#8c8c8c);font-size:0.6rem;line-height:1;',
        'margin-left:2px;transition:color 0.15s ease;',
      '}',
      '.bbx-dchip__dismiss:hover{color:var(--burgundy,#722F37);}',
      /* Footer */
      '.bbx-drawer-footer{',
        'padding:12px 20px 16px;',
        'background:#ffffff;',
        'border-top:1px solid var(--gray-light,#e8e8e8);',
        'flex-shrink:0;',
      '}',
      /* Confirm CTA — gold button */
      '.bbx-drawer-confirm-btn{',
        'display:block;width:100%;padding:13px;min-height:48px;',
        'background:var(--gold,#ab8744);',
        'color:#ffffff;',
        'border:none;border-radius:8px;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.86rem;font-weight:600;letter-spacing:0.04em;',
        'cursor:pointer;',
        'transition:background 0.15s ease,opacity 0.15s ease;',
      '}',
      '.bbx-drawer-confirm-btn:not(:disabled):hover{background:var(--gold-hover,#977435);}',
      '.bbx-drawer-confirm-btn:disabled{opacity:0.45;cursor:not-allowed;}',
      '.bbx-drawer-confirm-btn:focus-visible{outline:2px solid var(--gold,#ab8744);outline-offset:2px;}',
      /* Slot zone — dark-chocolate bar below header */
      '.bbx-drawer-slots{',
        'background:var(--dark-chocolate,#3E2723);',
        'padding:10px 20px 14px;flex-shrink:0;',
      '}',
      '.bbx-drawer-slots__label{',
        'display:block;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.62rem;font-weight:600;letter-spacing:0.14em;',
        'text-transform:uppercase;color:rgba(255,255,255,0.42);',
        'margin-bottom:9px;',
      '}',
      '.bbx-drawer-slots__track{',
        'display:flex;gap:8px;overflow-x:auto;',
        'scroll-snap-type:x mandatory;scrollbar-width:none;',
      '}',
      '.bbx-drawer-slots__track::-webkit-scrollbar{display:none;}',
      '.bbx-drawer-slot{',
        'flex-shrink:0;scroll-snap-align:start;',
        'width:60px;display:flex;flex-direction:column;align-items:center;gap:3px;',
      '}',
      '.bbx-drawer-slot--empty{opacity:0.3;}',
      '.bbx-drawer-slot__thumb{',
        'width:48px;height:48px;border-radius:10px;',
        'background:rgba(255,255,255,0.1);',
        'border:1.5px solid rgba(255,255,255,0.2);',
        'display:flex;align-items:center;justify-content:center;',
        'overflow:hidden;position:relative;flex-shrink:0;',
      '}',
      '.bbx-drawer-slot--committed .bbx-drawer-slot__thumb{',
        'border-color:var(--gold,#ab8744);background:rgba(171,135,68,0.18);',
      '}',
      '.bbx-drawer-slot--pending .bbx-drawer-slot__thumb{',
        'border-color:var(--gold-light,#d4b978);border-style:dashed;',
        'background:rgba(171,135,68,0.1);',
      '}',
      '.bbx-drawer-slot__img{',
        'width:48px;height:48px;object-fit:cover;border-radius:9px;display:block;',
      '}',
      '.bbx-drawer-slot__letter{',
        'font-family:var(--font-heading--family,"Cormorant Garamond",Georgia,serif);',
        'font-size:1.1rem;font-weight:600;color:var(--cream,#FFF8F0);line-height:1;',
      '}',
      '.bbx-drawer-slot__ph{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.75rem;color:rgba(255,255,255,0.38);line-height:1;',
      '}',
      '.bbx-drawer-slot__name{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.6rem;color:rgba(255,255,255,0.7);',
        'text-align:center;line-height:1.2;',
        'max-width:58px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;',
      '}',
      '.bbx-drawer-slot__remove{',
        'position:absolute;top:-8px;right:-8px;',
        'width:24px;height:24px;border-radius:50%;',
        'background:var(--burgundy,#722F37);color:#fff;',
        'border:none;cursor:pointer;',
        'font-size:0.6rem;line-height:1;',
        'display:flex;align-items:center;justify-content:center;',
        'padding:0;z-index:1;',
      '}',
      /* Gram note */
      '.bbx-drawer-gram-note{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.72rem;color:var(--gray,#8c8c8c);',
        'text-align:center;margin:0 0 8px;line-height:1;',
      '}',
      /* Drawer sub — bump from 0.7rem */
      '.bbx-drawer-sub{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.78rem;color:var(--gray,#8c8c8c);margin:2px 0 0;',
      '}',
      /* Category chip — bump from 0.7rem */
      '.bbx-cat-chip{',
        'white-space:nowrap;flex-shrink:0;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.78rem;font-weight:500;',
        'padding:5px 12px;border-radius:20px;cursor:pointer;',
        'border:1.5px solid var(--gray-light,#e8e8e8);',
        'background:#ffffff;color:var(--dark-soft,#4a4a4a);',
        'transition:background 0.15s ease,border-color 0.15s ease,color 0.15s ease;',
        'line-height:1;',
      '}',
      /* ── Drawer product list — 3-column mini-card grid ──────────────────── */
      /* These rules live in JS (not the Liquid <style> block) because Shopify  */
      /* SRA scopes <style> tags to #shopify-section-<id>, which no longer     */
      /* matches once the JS moves the <ul> into the drawer panel DOM.         */
      '.bbx-drawer-list{',
        'list-style:none;margin:0;padding:12px 0 4px;',
        'display:grid;grid-template-columns:repeat(3,1fr);gap:10px;',
      '}',
      '@media(max-width:400px){',
        '.bbx-drawer-list{grid-template-columns:repeat(2,1fr);gap:8px;}',
      '}',
      /* Mini card */
      '.bbx-drawer-row{',
        'display:flex;flex-direction:column;align-items:center;',
        'gap:5px;padding:10px 6px 8px;border-radius:10px;',
        'border:1.5px solid var(--gray-light,#e8e8e8);',
        'background:var(--bg,#ffffff);',
        'cursor:pointer;position:relative;text-align:center;',
        'transition:border-color 0.15s ease,background 0.15s ease,box-shadow 0.15s ease;',
        'list-style:none;',
      '}',
      '.bbx-drawer-row:hover{',
        'border-color:color-mix(in srgb,var(--gold,#ab8744) 50%,transparent);',
        'box-shadow:0 2px 8px rgba(0,0,0,0.06);',
      '}',
      '.bbx-drawer-row.is-added{',
        'border-color:var(--gold,#ab8744);background:var(--gold-pale,#f7f0e3);',
      '}',
      '.bbx-drawer-row.is-unavailable{opacity:0.5;cursor:help;}',
      /* Thumbnail */
      '.bbx-drawer-row__thumb{',
        'flex-shrink:0;width:56px;height:56px;border-radius:8px;',
        'background:var(--gold-pale,#f7f0e3);',
        'display:flex;align-items:center;justify-content:center;overflow:hidden;',
      '}',
      '.bbx-drawer-row__img{',
        'width:56px;height:56px;object-fit:cover;',
        'border-radius:8px;display:block;max-width:none;',
      '}',
      '.bbx-drawer-row__img-placeholder{',
        'width:56px;height:56px;max-width:none;',
        'display:flex;align-items:center;justify-content:center;',
        'font-family:var(--font-heading--family,"Cormorant Garamond",Georgia,serif);',
        'font-size:var(--type-h5,1.1rem);color:var(--gold,#ab8744);',
        'font-weight:var(--type-h-weight,500);',
      '}',
      /* Name — 2-line clamp */
      '.bbx-drawer-row__name{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.78rem;font-weight:600;',
        'color:var(--dark-chocolate,#3E2723);',
        'margin:0;display:-webkit-box;',
        '-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;',
        'line-height:1.25;width:100%;',
      '}',
      /* Rate — gold */
      '.bbx-drawer-row__rate{',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:0.72rem;font-weight:600;',
        'color:var(--gold,#ab8744);margin:0;width:100%;',
      '}',
      /* Add pill */
      '.bbx-drawer-row__add-btn{',
        'display:block;width:100%;margin-top:auto;',
        'padding:5px 0;border-radius:6px;',
        'border:1.5px solid var(--gold,#ab8744);',
        'background:transparent;color:var(--gold,#ab8744);',
        'font-size:0.72rem;font-weight:600;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'cursor:pointer;',
        'transition:background 0.15s ease,color 0.15s ease;',
        'line-height:1.4;text-align:center;min-height:28px;',
      '}',
      '.bbx-drawer-row.is-added .bbx-drawer-row__add-btn,',
      '.bbx-drawer-row__add-btn[aria-pressed="true"]{',
        'background:var(--gold,#ab8744);color:#ffffff;',
        'border-color:var(--gold,#ab8744);',
      '}',
      '.bbx-drawer-row__add-btn:hover:not(:disabled):not([aria-pressed="true"]){',
        'background:color-mix(in srgb,var(--gold,#ab8744) 12%,transparent);',
      '}',
      '.bbx-drawer-row__add-btn:disabled{',
        'opacity:0.4;cursor:not-allowed;',
        'border-color:var(--gray-light,#e8e8e8);color:var(--gray,#8c8c8c);',
      '}',
      '.bbx-drawer-row__add-btn:focus-visible{',
        'outline:2px solid var(--gold,#ab8744);outline-offset:2px;',
      '}',
      /* Empty state */
      '.bbx-drawer-empty{',
        'padding:32px 16px;text-align:center;',
        'font-family:var(--font-body--family,"DM Sans",sans-serif);',
        'font-size:var(--type-body,0.95rem);',
        'color:var(--dark-soft,#4a4a4a);',
      '}',
      /* Keyframe animations */
      '@keyframes bbxFadeIn{from{opacity:0}to{opacity:1}}',
      '@keyframes bbxSlideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}',
      '@keyframes bbxSlideRight{from{transform:translateX(100%)}to{transform:translateX(0)}}'
    ].join('');
    document.head.appendChild(style);
  }

  // ── closeDrawer() ─────────────────────────────────────────────────────────

  /** Remove the drawer from the DOM and restore focus to the opener. */
  function closeDrawer() {
    if (!_drawerOpen) return;

    var mountEl = root.querySelector('[data-bbx-drawer-mount]');
    if (mountEl) mountEl.innerHTML = '';

    _overlay    = null;
    _panel      = null;
    _slotZone   = null;
    _drawerOpen = false;
    _pending    = [];

    document.body.classList.remove('bbx-drawer-body-open');

    // Restore WhatsApp floater
    if (_waFloater) {
      _waFloater.style.display = _waFloaterDisplay;
      _waFloater = null;
    }

    // Restore focus
    if (_openerEl && typeof _openerEl.focus === 'function') {
      _openerEl.focus();
    }
    _openerEl = null;
  }

  // ── openDrawer() — the public entry point ────────────────────────────────

  /**
   * Open the browse-all drawer.
   * First call lazy-fetches the SRA section HTML; subsequent calls reuse the cache.
   * Guards against double-open.
   */
  function openDrawer() {
    if (_drawerOpen || _drawerFetching) return;

    // Remember what triggered this so we can restore focus on close
    _openerEl = document.activeElement;

    // Hide WhatsApp floater while drawer is open
    _waFloater = document.querySelector('.sp-wa-floater');
    if (_waFloater) {
      _waFloaterDisplay = _waFloater.style.display;
      _waFloater.style.setProperty('display', 'none', 'important');
    }

    // If we already have the HTML, skip the fetch
    if (_drawerHTML) {
      mountDrawer(_drawerHTML);
      return;
    }

    // Fetch the SRA endpoint (cfg.drawerUrl set by the builder section Liquid)
    var url = bbx.cfg.drawerUrl;
    if (!url) {
      console.error('[bbx T9] cfg.drawerUrl is not set. Cannot open drawer.');
      return;
    }
    // Propagate preview_theme_id so the SRA fetch returns the staged theme's section
    // (without this, the fetch hits the published theme on staging preview URLs)
    try {
      var _previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (_previewId) url += (url.indexOf('?') !== -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(_previewId);
    } catch (e) { /* ignore if URLSearchParams unavailable */ }

    // Show a lightweight loading state while fetching
    var mountEl = root.querySelector('[data-bbx-drawer-mount]');
    var loadingEl;
    if (mountEl) {
      loadingEl = document.createElement('p');
      loadingEl.className = 'bbx-drawer-loading';
      loadingEl.textContent = t('drawer_loading', 'Loading all varieties…');
      loadingEl.setAttribute('aria-live', 'polite');
      mountEl.appendChild(loadingEl);
    }

    _drawerFetching = true;
    fetch(url, { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('SRA fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        // Cache for subsequent opens
        _drawerHTML = html;
        bbx.drawerHTML = html; // also expose on namespace per spec

        _drawerFetching = false;
        if (loadingEl && loadingEl.parentNode) loadingEl.parentNode.removeChild(loadingEl);
        mountDrawer(html);
      })
      .catch(function (err) {
        console.error('[bbx T9] Failed to load drawer:', err);
        _drawerFetching = false;
        if (loadingEl) {
          loadingEl.textContent = t('drawer_load_error', 'Could not load varieties. Please try again.');
        }
        _openerEl = null;
      });
  }

  // ── Register on namespace ─────────────────────────────────────────────────
  bbx.openDrawer   = openDrawer;
  bbx.closeDrawer  = closeDrawer;

  // ── Self-check (Task 9) ───────────────────────────────────────────────────
  (function selfCheckT9() {
    // parseRowVariants: verify HTML-entity unescape
    var fakeRow = document.createElement('li');
    fakeRow.setAttribute('data-variants',
      '[{&quot;gid&quot;:&quot;gid://shopify/ProductVariant/1&quot;,&quot;title&quot;:&quot;500g&quot;,&quot;price&quot;:60000,&quot;weight&quot;:500,&quot;weight_unit&quot;:&quot;g&quot;,&quot;available&quot;:true}]'
    );
    var parsed = parseRowVariants(fakeRow);
    console.assert(
      Array.isArray(parsed) && parsed.length === 1 && parsed[0].price === 60000,
      '[bbx T9] parseRowVariants entity-unescape failed', parsed
    );

    // evenSplit guard (reuse from T6 engine via bbx namespace)
    if (bbx.evenSplit) {
      var s = bbx.evenSplit(1000, 3);
      console.assert(s.reduce(function (a, b) { return a + b; }, 0) === 1000,
        '[bbx T9] evenSplit sanity via bbx namespace');
    }

    // filterRows: rows with display:none are filtered
    var fakeList = document.createElement('ul');
    var r1 = document.createElement('li');
    r1.setAttribute('data-bbx-drawer-row', '');
    r1.setAttribute('data-tags', '');
    var n1 = document.createElement('p');
    n1.className = 'bbx-drawer-row__name';
    n1.textContent = 'Cashews Premium';
    r1.appendChild(n1);
    var r2 = document.createElement('li');
    r2.setAttribute('data-bbx-drawer-row', '');
    r2.setAttribute('data-tags', '');
    var n2 = document.createElement('p');
    n2.className = 'bbx-drawer-row__name';
    n2.textContent = 'Almonds Roasted';
    r2.appendChild(n2);
    fakeList.appendChild(r1); fakeList.appendChild(r2);
    filterRows(fakeList.querySelectorAll('[data-bbx-drawer-row]'), 'cash', '');
    console.assert(r1.style.display !== 'none', '[bbx T9] filterRows: matching row should be visible');
    console.assert(r2.style.display === 'none', '[bbx T9] filterRows: non-matching row should be hidden');

    // filterRows must never re-show an is-unavailable row, even on a matching
    // query — an enabled Add button on a weightless row is a money bug (Task 10).
    r1.classList.add('is-unavailable');
    filterRows(fakeList.querySelectorAll('[data-bbx-drawer-row]'), 'cash', '');
    console.assert(r1.style.display === 'none', '[bbx T9] filterRows: is-unavailable row must stay hidden even when query matches');
    r1.classList.remove('is-unavailable');

    console.log('[bbx] Task 9 self-check complete.');
  })();
})();

// ---------------------------------------------------------------------------
// Task 10 — Multi-bundle session flow
// ---------------------------------------------------------------------------
// Adds finalizeBundle() (State 2: complete screen), renderSummary() (State 3:
// order summary sheet/panel), and editBundle(index) (State 4: edit mode).
// Enforces the 5-box cap in the UI. Deep-copy discipline: stored bundles are
// fully independent of state.current — mutating current after finalize must
// NOT affect any stored bundle. Self-check verifies this.
(function () {
  'use strict';

  var root =
    document.querySelector('[data-bbx]') ||
    document.querySelector('.sindhi-bundle-builder');
  if (!root || !root.__bbx) return;

  var bbx = root.__bbx;
  var cfg = bbx.cfg;
  var t = function(key, fallback, vars) { return bbx.t ? bbx.t(key, fallback, vars) : fallback; };

  // ── Constants ──────────────────────────────────────────────────────────────
  var MAX_BUNDLES = 5;

  // ── Helpers ────────────────────────────────────────────────────────────────

  /**
   * Deep-copy a bundle's current state (pkg + items + customisations).
   * No shared object references — subsequent mutations to src do not affect dst.
   * @param {{ pkg, items, customisations }} src
   * @returns {{ pkg, items, customisations }}
   */
  function deepCopyBundle(src) {
    // pkg: metaobject reference — the pkg object itself is read-only config,
    //      but we copy its identity-critical fields to prevent aliasing.
    var pkg = src.pkg ? JSON.parse(JSON.stringify(src.pkg)) : null;

    // items: each item holds a product reference (config, also read-only) and
    //        mutable allocatedG/priceP. We deep-copy the whole thing.
    var items = (src.items || []).map(function (it) {
      return {
        product:    JSON.parse(JSON.stringify(it.product)),
        allocatedG: it.allocatedG,
        priceP:     it.priceP
      };
    });

    // customisations: same — deep-copy the customisation object + priceP.
    var customisations = (src.customisations || []).map(function (c) {
      return {
        customisation: JSON.parse(JSON.stringify(c.customisation)),
        priceP:        c.priceP
      };
    });

    return { pkg: pkg, items: items, customisations: customisations };
  }

  /**
   * Reset state.current to an empty bundle (no pkg, no items, no customisations).
   */
  function resetCurrent() {
    bbx.state.current = { pkg: null, items: [], customisations: [] };
    // state.step must follow `current` back to the start. It used not to, so
    // after finishing a box the pointer stayed wherever it was (commonly 3),
    // and the teaser then rendered the impossible line
    // "No package chosen yet · 0 items · Currently on: Personal Touches".
    // Step 1 is the package step — the true starting point for the next box.
    bbx.state.step = 1;
  }

  /**
   * Compute the total price (paise) for a stored bundle snapshot.
   * Σ item.priceP + package.price×100 + Σ customisation.priceP
   *
   * @param {{ pkg, items, customisations }} bundle
   * @returns {number} paise
   */
  function bundleTotal(bundle) {
    if (!bundle) return 0;
    var pkgP   = bundle.pkg ? Math.round((parseFloat(bundle.pkg.price) || 0) * 100) : 0;
    var itemsP = (bundle.items || []).reduce(function (s, it) { return s + (it.priceP || 0); }, 0);
    var custP  = (bundle.customisations || []).reduce(function (s, c) { return s + (c.priceP || 0); }, 0);
    return pkgP + itemsP + custP;
  }

  /**
   * Grand total across all stored bundles (paise).
   * @returns {number}
   */
  function grandTotal() {
    return bbx.state.bundles.reduce(function (s, b) { return s + bundleTotal(b); }, 0);
  }

  // ── Edit-mode tracking ────────────────────────────────────────────────────

  /** Index of the bundle currently being edited (-1 = not editing). */
  var _editIndex = -1;

  /** Snapshot of the bundle before editing started (for cancel). */
  var _editSnapshot = null;

  // ── State 2: finalizeBundle() — Complete screen ───────────────────────────

  /**
   * Finalize the current bundle and show the "Box N ready" complete screen.
   *
   * 1. Deep-copy state.current into state.bundles (independent; no shared refs).
   * 2. Reset state.current to empty.
   * 3. Replace the builder body with the complete screen.
   */
  function finalizeBundle() {
    if (bbx.closeDrawer) bbx.closeDrawer();
    var cur = bbx.state.current;

    // Guard: need at least 1 item to finalize.
    // Note: !cur.pkg is intentionally NOT a blocking condition — renderCompleteScreen
    // and all downstream functions handle bundle.pkg === null safely.
    if (!cur.items.length) {
      console.error('[bbx] finalizeBundle called with 0 items — button should have been disabled.');
      return;
    }

    // Save index before push (used for "Edit this box")
    var bundleIndex;

    if (_editIndex !== -1) {
      // Edit-save path: replace in place
      bundleIndex = _editIndex;
      bbx.state.bundles[_editIndex] = deepCopyBundle(cur);
      _editIndex    = -1;
      _editSnapshot = null;
    } else {
      // New bundle path: append
      bundleIndex = bbx.state.bundles.length;
      bbx.state.bundles.push(deepCopyBundle(cur));
    }

    resetCurrent();
    removeEditModeBar();
    renderCompleteScreen(bundleIndex);
  }

  /**
   * Extract a package type keyword (Tray / Box / Tin / etc.) from a package name string.
   * Returns empty string if none found.
   */
  function extractPackageType(name) {
    if (!name) return '';
    var types = ['Tray', 'Box', 'Tin', 'Jar', 'Pouch', 'Container', 'Basket', 'Hamper'];
    for (var i = 0; i < types.length; i++) {
      if (name.indexOf(types[i]) !== -1) return types[i];
    }
    return '';
  }

  /**
   * Render the "Box N ready" complete screen into [data-bbx-steps].
   * Replaces the active builder body content.
   *
   * @param {number} bundleIndex  Zero-based index of the just-finalized bundle.
   */
  function renderCompleteScreen(bundleIndex) {
    var elSteps = root.querySelector('[data-bbx-steps]');
    if (!elSteps) return;

    var bundle    = bbx.state.bundles[bundleIndex];
    // Defensive: a stale / out-of-bounds index (e.g. after all bundles were removed)
    // must not dereference an undefined bundle. Fall back to the live builder.
    if (!bundle) {
      if (bbx.showBuilder) bbx.showBuilder(); else if (typeof showBuilder === 'function') showBuilder();
      return;
    }
    var boxNum    = bundleIndex + 1;
    var total     = bundleTotal(bundle);
    var capReached = bbx.state.bundles.length >= MAX_BUNDLES;
    var allTotal  = grandTotal();
    var allCount  = bbx.state.bundles.length;

    // Remove only dynamic builder elements — preserve the static scaffold (elGrid, elCapacity
    // etc.) so editBundle / startNewBundle can re-use them without DOM re-querying.
    // root-scoped, not elSteps-scoped: in stepper mode the chrome lives in the
    // sheet bar, outside [data-bbx-steps], and would otherwise survive as a
    // stale step trail over the receipt. All six selectors are unique in the
    // section, so widening the scope changes nothing else.
    ['.bbx-chrome', '.bbx-step--packages', '.bbx-pkg-banner',
     '.bbx-step--customisations', '.bbx-complete-screen', '[data-bbx-edit-mode-bar]'
    ].forEach(function (sel) {
      var ex = root.querySelector(sel);
      if (ex) ex.remove();
    });
    // Clear + hide static scaffold; showBuilder() reverses this when editing / starting new
    var _elGrid    = root.querySelector('[data-bbx-grid]');
    var _elCap     = root.querySelector('[data-bbx-capacity]');
    var _elPreview = root.querySelector('[data-bbx-preview]');
    var _elDM      = root.querySelector('[data-bbx-drawer-mount]');
    // A customer who ignores the template picker on box 1 and hits Done would
    // otherwise see it floating above the receipt — it uses `hidden`, not
    // style.display, matching how renderTemplatePicker()/applyTemplate() toggle it.
    var _elTpl = root.querySelector('[data-bbx-templates]');
    if (_elTpl) _elTpl.hidden = true;
    // ADDITIVE, not a replacement: see the Step 4 correction note above — the
    // hidden write does 100% of the work on desktop/tablet. In stepper mode
    // showing the receipt must additionally advance the visible panel, since
    // the receipt renders into [data-bbx-steps], which is the panel
    // showStepPanel() has to reveal at the same time.
    if (bbx.showStepPanel) bbx.showStepPanel(2);
    if (_elGrid)    { _elGrid.innerHTML    = ''; _elGrid.style.display    = 'none'; }
    if (_elCap)     { _elCap.innerHTML     = ''; _elCap.style.display     = 'none'; }
    if (_elPreview) { _elPreview.innerHTML = ''; _elPreview.style.display = 'none'; }
    if (_elDM)      { _elDM.style.display  = 'none'; }

    // ── Complete screen container ────────────────────────────────────────────
    var screen = document.createElement('div');
    screen.className = 'bbx-complete-screen';
    screen.setAttribute('role', 'status');
    screen.setAttribute('aria-label', 'Box ' + boxNum + ' is ready');

    // Gold tick
    var tick = document.createElement('div');
    tick.className = 'bbx-complete-tick';
    tick.setAttribute('aria-hidden', 'true');
    tick.textContent = '✓';
    screen.appendChild(tick);

    // Big product title: base name + package type extracted from selected package name
    var pkgTypeName = extractPackageType(bundle.pkg && bundle.pkg.name);
    var baseName = cfg.bundleProductName || 'Premium Assorted Dry Fruits Gift';
    var productTitle = pkgTypeName ? baseName + ' ' + pkgTypeName : baseName;

    var heading = document.createElement('h2');
    heading.className = 'bbx-complete-heading';
    heading.textContent = productTitle;
    screen.appendChild(heading);

    // "Box N is ready" subtitle
    var readySub = document.createElement('p');
    readySub.className = 'bbx-complete-ready-sub';
    readySub.textContent = t('complete_heading', 'Box %n% is ready', { n: boxNum });
    screen.appendChild(readySub);

    // ── Itemized receipt card ─────────────────────────────────────────────────
    var card = document.createElement('div');
    card.className = 'bbx-complete-card';

    // ── helpers ──────────────────────────────────────────────────────────────
    function appendDivider(parent, strong) {
      var hr = document.createElement('div');
      hr.className = strong
        ? 'bbx-complete-card__divider bbx-complete-card__divider--strong'
        : 'bbx-complete-card__divider';
      parent.appendChild(hr);
    }
    function appendLineRow(parent, name, price, isTotalRow) {
      var row = document.createElement('div');
      row.className = isTotalRow
        ? 'bbx-complete-card__line-row bbx-complete-card__line-row--total'
        : 'bbx-complete-card__line-row';
      var nameEl = document.createElement('span');
      nameEl.className = 'bbx-complete-card__line-name';
      nameEl.textContent = name;
      var priceEl = document.createElement('span');
      priceEl.className = 'bbx-complete-card__line-price';
      priceEl.textContent = price;
      row.appendChild(nameEl);
      row.appendChild(priceEl);
      parent.appendChild(row);
    }

    // ── Package section label + row ───────────────────────────────────────────
    appendDivider(card);
    var pkgLabel = document.createElement('p');
    pkgLabel.className = 'bbx-complete-card__section-label';
    pkgLabel.textContent = t('complete_section_package', 'Package');
    card.appendChild(pkgLabel);

    var pkgRow = document.createElement('div');
    pkgRow.className = 'bbx-complete-card__pkg-row';

    if (bundle.pkg) {
      if (bundle.pkg.image) {
        var pkgImg = document.createElement('img');
        pkgImg.className = 'bbx-complete-card__pkg-thumb';
        pkgImg.src = bundle.pkg.image;
        pkgImg.alt = bundle.pkg.name || '';
        pkgImg.width = 48;
        pkgImg.height = 48;
        pkgImg.loading = 'lazy';
        pkgRow.appendChild(pkgImg);
      }
      var pkgMeta = document.createElement('div');
      pkgMeta.className = 'bbx-complete-card__pkg-meta';
      var pkgNameEl = document.createElement('span');
      pkgNameEl.className = 'bbx-complete-card__pkg-name';
      pkgNameEl.textContent = bundle.pkg.name || '';
      pkgMeta.appendChild(pkgNameEl);
      pkgRow.appendChild(pkgMeta);

      var pkgPriceAmt = Math.round((parseFloat(bundle.pkg.price) || 0) * 100);
      var pkgPriceEl = document.createElement('span');
      pkgPriceEl.className = 'bbx-complete-card__pkg-price';
      pkgPriceEl.textContent = bbx.money(pkgPriceAmt);
      pkgRow.appendChild(pkgPriceEl);
    }
    card.appendChild(pkgRow);

    // ── Dry Fruits section ────────────────────────────────────────────────────
    if (bundle.items.length) {
      appendDivider(card);
      var fruitsLabel = document.createElement('p');
      fruitsLabel.className = 'bbx-complete-card__section-label';
      fruitsLabel.textContent = t('complete_section_dryfruit', 'Dry Fruits');
      card.appendChild(fruitsLabel);
      bundle.items.forEach(function (it) {
        var lineName = (it.product.title || '') + ' · ' + it.allocatedG + 'g';
        appendLineRow(card, lineName, bbx.money(it.priceP || 0));
      });
    }

    // ── Add-ons section ───────────────────────────────────────────────────────
    if (bundle.customisations.length) {
      appendDivider(card);
      var addonsLabel = document.createElement('p');
      addonsLabel.className = 'bbx-complete-card__section-label';
      addonsLabel.textContent = t('complete_section_addons', 'Add-ons');
      card.appendChild(addonsLabel);
      bundle.customisations.forEach(function (c) {
        appendLineRow(card, c.customisation.name || '', bbx.money(c.priceP || 0));
      });
    }

    // ── Box total ─────────────────────────────────────────────────────────────
    appendDivider(card, true);
    appendLineRow(card, t('complete_total_label', 'Box total'), bbx.money(total), true);

    // GST note — always shown; text reflects whether prices are inclusive or exclusive
    var taxNote = document.createElement('p');
    taxNote.className = 'bbx-complete-card__tax-note';
    if (cfg.taxesIncluded === false) {
      taxNote.textContent = t('taxes_note_before', '* Prices before GST · tax added at checkout');
    } else {
      taxNote.textContent = t('taxes_note_after', '* All prices inclusive of GST');
    }
    card.appendChild(taxNote);

    screen.appendChild(card);

    // ── CTAs ─────────────────────────────────────────────────────────────────
    var ctaGroup = document.createElement('div');
    ctaGroup.className = 'bbx-complete-ctas';

    // "Add another box"
    var addAnotherBtn = document.createElement('button');
    addAnotherBtn.type = 'button';
    addAnotherBtn.className = 'bbx-complete-cta bbx-complete-cta--secondary';
    if (capReached) {
      addAnotherBtn.disabled = true;
      addAnotherBtn.setAttribute('aria-disabled', 'true');
      addAnotherBtn.textContent = t('complete_cap_reached', 'Maximum %max% boxes per order', { max: MAX_BUNDLES });
    } else {
      addAnotherBtn.textContent = t('complete_add_another', 'Add another box');
      addAnotherBtn.addEventListener('click', function () {
        startNewBundle();
      });
    }
    ctaGroup.appendChild(addAnotherBtn);

    // "View order summary"
    var summaryBtn = document.createElement('button');
    summaryBtn.type = 'button';
    summaryBtn.className = 'bbx-complete-cta bbx-complete-cta--primary';
    summaryBtn.textContent = allCount === 1
      ? t('complete_view_summary', 'View order summary (%n% box · %total%)', { n: allCount, total: bbx.money(allTotal) })
      : t('complete_view_summary_plural', 'View order summary (%n% boxes · %total%)', { n: allCount, total: bbx.money(allTotal) });
    summaryBtn.addEventListener('click', function () {
      renderSummary();
    });
    ctaGroup.appendChild(summaryBtn);

    // "Edit this box"
    var editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'bbx-complete-cta bbx-complete-cta--ghost';
    editBtn.textContent = t('complete_edit_this_box', 'Edit this box');
    editBtn.addEventListener('click', function () {
      editBundle(bundleIndex);
    });
    ctaGroup.appendChild(editBtn);

    screen.appendChild(ctaGroup);
    elSteps.appendChild(screen);

    // Scroll the complete screen into view — it renders at the top of [data-bbx-steps]
    // while the user is scrolled to the sticky CTA at the bottom, so without this the
    // screen is invisible and the button appears to do nothing.
    setTimeout(function () {
      if (bbx.scrollToInBuilder) bbx.scrollToInBuilder(screen);
      else screen.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);

    // Update the sticky CTA bar label/state
    updateCtaForMultiBundle();
  }

  // ── State 3: renderSummary() — Order summary sheet/panel ─────────────────

  /**
   * Render (or re-render) the order summary into [data-bbx-summary].
   * Mobile: bottom sheet. Desktop: right panel.
   * Shows one card per bundle + grand total + "Add all to cart" CTA.
   */
  function renderSummary() {
    var elSummary = root.querySelector('[data-bbx-summary]');
    if (!elSummary) return;

    elSummary.innerHTML = '';
    elSummary.removeAttribute('hidden');
    elSummary.classList.add('bbx-summary--open');
    if (bbx.syncOverlayFlag) bbx.syncOverlayFlag();

    // ── Overlay (dismiss) ─────────────────────────────────────────────────────
    var overlay = document.createElement('div');
    overlay.className = 'bbx-summary-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    // ── Sheet/panel container ─────────────────────────────────────────────────
    var panel = document.createElement('div');
    panel.className = 'bbx-summary-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', t('summary_aria', 'Order summary'));

    // Header
    var header = document.createElement('div');
    header.className = 'bbx-summary-header';

    var title = document.createElement('h2');
    title.className = 'bbx-summary-title';
    title.textContent = t('summary_title', 'Order Summary');
    header.appendChild(title);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'bbx-summary-close';
    closeBtn.setAttribute('aria-label', t('summary_close_aria', 'Close order summary'));
    closeBtn.textContent = '×';
    header.appendChild(closeBtn);

    panel.appendChild(header);

    // ── Scrollable body ───────────────────────────────────────────────────────
    var body = document.createElement('div');
    body.className = 'bbx-summary-body';

    bbx.state.bundles.forEach(function (bundle, idx) {
      var boxTotal = bundleTotal(bundle);

      var bundleCard = document.createElement('div');
      bundleCard.className = 'bbx-summary-bundle-card';

      // Card header: box number + box total + action icons
      var cardHeader = document.createElement('div');
      cardHeader.className = 'bbx-summary-bundle-card__header';

      var boxLabel = document.createElement('span');
      boxLabel.className = 'bbx-summary-bundle-card__label';
      boxLabel.textContent = bundle.pkg
        ? t('summary_box_label_pkg', 'Box %n% — %pkg%', { n: idx + 1, pkg: bundle.pkg.name })
        : t('summary_box_label', 'Box %n%', { n: idx + 1 });
      cardHeader.appendChild(boxLabel);

      var actions = document.createElement('span');
      actions.className = 'bbx-summary-bundle-card__actions';

      // Edit icon — a bare '✏' (no U+FE0F) rendered inconsistently: on most
      // platforms it draws in COLOR (emoji presentation), which ignores the
      // `color:` this button's CSS uses to theme it and to swap colour on
      // hover/focus — the sibling '×' remove button next to it is plain text
      // and picks up those rules fine, so the two looked mismatched/cluttered.
      // An inline stroke="currentColor" SVG fixes both: consistent size across
      // browsers, and it actually responds to the existing hover/focus CSS.
      var editIconBtn = document.createElement('button');
      editIconBtn.type = 'button';
      editIconBtn.className = 'bbx-summary-icon-btn';
      editIconBtn.setAttribute('aria-label', t('summary_edit_aria', 'Edit Box %n%', { n: idx + 1 }));
      editIconBtn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
        'aria-hidden="true" focusable="false"><path d="M12 20h9"></path>' +
        '<path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>';
      editIconBtn.setAttribute('data-bbx-summary-edit', idx);
      actions.appendChild(editIconBtn);

      // Remove icon
      var removeIconBtn = document.createElement('button');
      removeIconBtn.type = 'button';
      removeIconBtn.className = 'bbx-summary-icon-btn bbx-summary-icon-btn--remove';
      removeIconBtn.setAttribute('aria-label', t('summary_remove_aria', 'Remove Box %n%', { n: idx + 1 }));
      removeIconBtn.textContent = '×';
      removeIconBtn.setAttribute('data-bbx-summary-remove', idx);
      actions.appendChild(removeIconBtn);

      cardHeader.appendChild(actions);
      bundleCard.appendChild(cardHeader);

      // 2-col item thumbnails
      if (bundle.items.length) {
        var thumbGrid = document.createElement('div');
        thumbGrid.className = 'bbx-summary-thumb-grid';
        bundle.items.forEach(function (it) {
          var thumb = document.createElement('div');
          thumb.className = 'bbx-summary-thumb';

          if (it.product.featured_image) {
            var img = document.createElement('img');
            img.className = 'bbx-summary-thumb__img';
            img.src = it.product.featured_image;
            img.alt = it.product.title || '';
            img.width = 48;
            img.height = 48;
            img.loading = 'lazy';
            thumb.appendChild(img);
          } else {
            var ph = document.createElement('div');
            ph.className = 'bbx-summary-thumb__placeholder';
            ph.textContent = (it.product.title || 'P').charAt(0).toUpperCase();
            thumb.appendChild(ph);
          }

          var thumbLabel = document.createElement('span');
          thumbLabel.className = 'bbx-summary-thumb__label';
          thumbLabel.textContent = it.allocatedG + 'g';
          thumb.appendChild(thumbLabel);

          var thumbName = document.createElement('span');
          thumbName.className = 'bbx-summary-thumb__name';
          // Was .substring(0,14), which cut mid-word ("Kaju Mota, Ind",
          // "California Alm") on the screen where the shopper pays. The short
          // name fits; CSS ellipsis handles anything still too long.
          thumbName.textContent = (bbx.displayName ? bbx.displayName(it.product) : (it.product.title || ''));
          thumbName.title = it.product.title || '';
          thumb.appendChild(thumbName);

          thumbGrid.appendChild(thumb);
        });
        bundleCard.appendChild(thumbGrid);
      }

      // Customisations
      if (bundle.customisations.length) {
        var custList = document.createElement('div');
        custList.className = 'bbx-summary-cust-list';
        bundle.customisations.forEach(function (c) {
          var tag = document.createElement('span');
          tag.className = 'bbx-summary-cust-tag';
          tag.textContent = c.customisation.name || '';
          custList.appendChild(tag);
        });
        bundleCard.appendChild(custList);
      }

      // Box subtotal — only meaningful with MORE THAN ONE box. With a single
      // box it repeats the grand Total directly below it and the amount on the
      // Add-all button, so the same figure appeared three times on one short
      // screen. Per-box subtotals stay as soon as there is something to
      // subtotal against.
      if (bbx.state.bundles.length > 1) {
        var subtotalEl = document.createElement('p');
        subtotalEl.className = 'bbx-summary-bundle-card__subtotal';
        subtotalEl.textContent = t('summary_subtotal', 'Subtotal: %total%', { total: bbx.money(boxTotal) });
        bundleCard.appendChild(subtotalEl);
      }

      body.appendChild(bundleCard);
    });

    // "Add another box" prompt
    var capReached = bbx.state.bundles.length >= MAX_BUNDLES;
    var addMoreEl = document.createElement('div');
    addMoreEl.className = 'bbx-summary-add-more';
    if (capReached) {
      var capNote = document.createElement('p');
      capNote.className = 'bbx-summary-cap-note';
      capNote.textContent = t('summary_cap_reached', 'Maximum %max% boxes per order reached.', { max: MAX_BUNDLES });
      addMoreEl.appendChild(capNote);
    } else {
      var addMoreBtn = document.createElement('button');
      addMoreBtn.type = 'button';
      addMoreBtn.className = 'bbx-summary-add-more-btn';
      addMoreBtn.textContent = t('summary_add_another', '+ Add another box');
      addMoreBtn.addEventListener('click', function () {
        closeSummary();
        startNewBundle();
      });
      addMoreEl.appendChild(addMoreBtn);
    }
    body.appendChild(addMoreEl);

    panel.appendChild(body);

    // ── Grand total + "Add all to cart" ───────────────────────────────────────
    var footer = document.createElement('div');
    footer.className = 'bbx-summary-footer';

    var grandTotalEl = document.createElement('p');
    grandTotalEl.className = 'bbx-summary-grand-total';
    // Note: no discount in v1; plain sum
    grandTotalEl.textContent = t('summary_grand_total', 'Total: %total%', { total: bbx.money(grandTotal()) });
    footer.appendChild(grandTotalEl);

    var addAllBtn = document.createElement('button');
    addAllBtn.type = 'button';
    addAllBtn.className = 'bbx-summary-add-all-btn';
    var _addAllTotal = bbx.money(grandTotal());
    var _addAllLabel = t('summary_add_all', 'Add all to cart · %total%', { total: _addAllTotal });
    addAllBtn.textContent = '';
    var _amtAt = _addAllLabel.indexOf(_addAllTotal);
    if (_amtAt === -1) {
      addAllBtn.textContent = _addAllLabel;
    } else {
      addAllBtn.appendChild(document.createTextNode(_addAllLabel.slice(0, _amtAt)));
      var _amtEl = document.createElement('span');
      _amtEl.className = 'bbx-amount';
      _amtEl.textContent = _addAllTotal;
      addAllBtn.appendChild(_amtEl);
      addAllBtn.appendChild(document.createTextNode(_addAllLabel.slice(_amtAt + _addAllTotal.length)));
    }
    addAllBtn.addEventListener('click', function () {
      if (typeof root.__bbx.addAllToCart === 'function') {
        root.__bbx.addAllToCart();
      } else {
        // Task 11 will define this function
        console.warn('[bbx T10] addAllToCart not yet defined — pending Task 11');
      }
    });
    footer.appendChild(addAllBtn);

    panel.appendChild(footer);

    // Mount overlay + panel
    elSummary.appendChild(overlay);
    elSummary.appendChild(panel);

    // ── Focus trap ────────────────────────────────────────────────────────────
    var FOCUSABLE = 'a[href]:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function getFocusable() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE));
    }
    function trapFocus(e) {
      var focusable = getFocusable();
      if (!focusable.length) { e.preventDefault(); return; }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        closeSummary();
      }
    }
    panel.addEventListener('keydown', trapFocus);

    // Close triggers
    function closeSummary() {
      elSummary.classList.remove('bbx-summary--open');
      if (bbx.syncOverlayFlag) bbx.syncOverlayFlag();
      elSummary.innerHTML = '';
    }

    overlay.addEventListener('click', closeSummary);
    closeBtn.addEventListener('click', closeSummary);

    // Wire edit/remove icon buttons via delegation
    panel.addEventListener('click', function (e) {
      var editBtn   = e.target.closest('[data-bbx-summary-edit]');
      var removeBtn = e.target.closest('[data-bbx-summary-remove]');

      if (editBtn) {
        var idx = parseInt(editBtn.getAttribute('data-bbx-summary-edit'), 10);
        closeSummary();
        editBundle(idx);
        return;
      }
      if (removeBtn) {
        var ridx = parseInt(removeBtn.getAttribute('data-bbx-summary-remove'), 10);
        // Two-step confirm. This button destroys a fully-built box outright and
        // sits a few pixels from the panel's own close '×', so a mis-tap used
        // to silently delete real work with no undo. First tap arms it and
        // relabels; a second tap within 4s commits. Deliberately not
        // window.confirm(): a native modal blocks the page (and this repo's
        // browser tooling) and does not match the sheet's visual language.
        if (removeBtn.getAttribute('data-bbx-confirm-armed') !== '1') {
          removeBtn.setAttribute('data-bbx-confirm-armed', '1');
          removeBtn.classList.add('is-armed');
          removeBtn.textContent = t('summary_remove_confirm', 'Remove?');
          removeBtn.setAttribute('aria-label',
            t('summary_remove_confirm_aria', 'Tap again to remove Box %n%', { n: ridx + 1 }));
          if (bbx.announceToSR) {
            bbx.announceToSR(t('summary_remove_confirm_aria', 'Tap again to remove Box %n%', { n: ridx + 1 }));
          }
          clearTimeout(removeBtn._bbxDisarm);
          removeBtn._bbxDisarm = setTimeout(function () {
            removeBtn.removeAttribute('data-bbx-confirm-armed');
            removeBtn.classList.remove('is-armed');
            removeBtn.textContent = '×';
            removeBtn.setAttribute('aria-label',
              t('summary_remove_aria', 'Remove Box %n%', { n: ridx + 1 }));
          }, 4000);
          return;
        }
        clearTimeout(removeBtn._bbxDisarm);
        bbx.state.bundles.splice(ridx, 1);
        if (bbx.state.bundles.length === 0) {
          // All bundles removed — go back to fresh builder
          closeSummary();
          startNewBundle();
        } else {
          // Re-render summary with updated bundles
          closeSummary();
          renderSummary();
        }
        return;
      }
    });

    // Set initial focus
    requestAnimationFrame(function () {
      var focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    });
  }

  // ── State 4: editBundle(index) — Edit mode ───────────────────────────────

  /**
   * Load bundle at index into state.current for editing.
   * Re-enters the builder pre-filled with existing selections.
   * Shows a gold edit-mode bar pinned above the steps.
   *
   * @param {number} index  Zero-based index into state.bundles.
   */
  function editBundle(index) {
    if (bbx.closeDrawer) bbx.closeDrawer();
    var bundle = bbx.state.bundles[index];
    if (!bundle) return;

    // Save snapshot for cancel
    _editIndex    = index;
    _editSnapshot = deepCopyBundle(bundle);

    // Load bundle into current (deep copy — editing must NOT affect the stored bundle)
    bbx.state.current = deepCopyBundle(bundle);
    bbx.state.step = 2;

    // Restore static scaffold + chrome (removes complete screen, un-hides grid/capacity)
    if (bbx.showBuilder) bbx.showBuilder(); else showBuilder();

    // Render package step then immediately collapse to compact banner (pkg already chosen)
    if (bbx.renderPackages) bbx.renderPackages();
    var elSteps = root.querySelector('[data-bbx-steps]');
    if (elSteps) {
      var pkgStepEl = elSteps.querySelector('.bbx-step--packages');
      if (pkgStepEl) pkgStepEl.style.display = 'none';
    }
    if (bbx.state.current.pkg) {
      if (bbx.renderPkgBanner) bbx.renderPkgBanner(bbx.state.current.pkg);
      else renderPkgBanner(bbx.state.current.pkg);
    }

    // Render grid + capacity + customisations pre-filled with the saved selections
    if (bbx.renderGrid)           bbx.renderGrid();
    // renderGrid() only paints getProductsForCurrentPkg() (the featured /
    // per-package collection), never state.current.items — so a box built from
    // a template reopened for editing showed NONE of its own varieties as
    // added, except whichever ones happen to also sit in the featured set
    // (which read as "it pre-selected the first ingredient"). Same helper
    // applyTemplate()/selectPkg() already use.
    if (bbx.ensureSeededItemCards) bbx.ensureSeededItemCards(bbx.state.current.pkg);
    if (bbx.renderCapacity)       bbx.renderCapacity();
    if (bbx.renderCustomisations) bbx.renderCustomisations();
    if (bbx.resetPreviewAnimState) bbx.resetPreviewAnimState();
    if (bbx.rebalance)            bbx.rebalance();

    // Show the edit-mode bar at the very top
    renderEditModeBar(index);

    // CTA label only — the action stays with wireDoneCta's delegation on the
    // CTA bar. This used to clone the button and bind finalizeBundle() to it
    // directly, which had two bugs: the delegated handler still fired on the
    // same click (so finalizeBundle ran twice, the second call bailing out on
    // an already-emptied `current`), and, because the direct binding bypassed
    // the step machine entirely, an edit could never reach step 3 — pressing
    // save on Dry Fruits jumped straight to the receipt, so Personal Touches
    // was unreachable when editing. Editing now walks the same 2 → 3 → save
    // path as building, with syncCtaText() owning the label at every step.
    var ctaBtn = root.querySelector('[data-bbx-cta] .bbx-cta-btn');
    if (ctaBtn) ctaBtn.disabled = false;
    if (bbx.syncCtaText) bbx.syncCtaText();

    // Scroll to builder top
    var builderEl = root.querySelector('[data-bbx-steps]');
    if (builderEl) {
      setTimeout(function () {
        if (bbx.scrollToInBuilder) bbx.scrollToInBuilder(builderEl);
        else builderEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
  }

  /**
   * Render the gold edit-mode bar above the steps.
   * @param {number} index
   */
  function renderEditModeBar(index) {
    removeEditModeBar(); // ensure no duplicate

    var elSteps = root.querySelector('[data-bbx-steps]');
    if (!elSteps) return;

    var bar = document.createElement('div');
    bar.className = 'bbx-edit-mode-bar';
    bar.setAttribute('data-bbx-edit-mode-bar', '');
    bar.setAttribute('role', 'status');

    var pkg = bbx.state.current.pkg;
    // Pass the raw name (or '') — the " — " separator lives in the locale
    // template itself now, not glued on here, so the two tokens never sit
    // adjacent with no separator between them.
    var pkgName = pkg ? pkg.name : '';

    var labelText = t('edit_bar_label', 'Editing Box %n% — %pkg%', { n: index + 1, pkg: pkgName });
    if (!pkgName) {
      // No package name to show — degrade to "Editing Box 1" instead of a
      // dangling "Editing Box 1 — ".
      labelText = labelText.replace(/\s*—\s*$/, '');
    }

    var label = document.createElement('span');
    label.className = 'bbx-edit-mode-bar__label';
    label.textContent = '✏ ' + labelText;
    bar.appendChild(label);

    var cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'bbx-edit-mode-bar__cancel';
    cancelBtn.textContent = t('edit_cancel', 'Cancel edit');
    cancelBtn.addEventListener('click', function () {
      cancelEdit();
    });
    bar.appendChild(cancelBtn);

    // Insert before the first child of the steps container
    elSteps.insertBefore(bar, elSteps.firstChild);
  }

  /**
   * Remove the edit-mode bar if present.
   */
  function removeEditModeBar() {
    var bar = root.querySelector('[data-bbx-edit-mode-bar]');
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
  }

  /**
   * Cancel an in-progress edit: discard changes, restore prior state, return to complete screen.
   */
  function cancelEdit() {
    var idx = _editIndex;
    // Restore from snapshot
    if (idx !== -1 && _editSnapshot) {
      // No changes applied yet — snapshot is already in bundles[idx], just clear current
      resetCurrent();
    }
    _editIndex    = -1;
    _editSnapshot = null;
    removeEditModeBar();
    // Return to the complete screen for the bundle that was being edited. Pick a valid
    // index: the edited bundle, else the last bundle. If no bundles exist, restore the
    // fresh builder instead of crashing on bundles[0].
    var safeIdx = idx !== -1 ? idx
                : (bbx.state.bundles.length ? bbx.state.bundles.length - 1 : -1);
    if (safeIdx === -1) {
      startNewBundle();
    } else {
      renderCompleteScreen(safeIdx);
    }
  }

  // ── Start a new bundle (builder reset to package step) ────────────────────

  /**
   * Reset the builder to the package-selection step for a brand-new bundle.
   * current is already empty (reset by finalizeBundle or cancelEdit).
   */
  function startNewBundle() {
    if (bbx.closeDrawer) bbx.closeDrawer();
    resetCurrent();
    // Every existing caller reaches startNewBundle() via renderCompleteScreen(),
    // which already removes '.bbx-pkg-banner' itself — so this was never hit
    // before the teaser's "Cancel and start over" became the first caller that
    // can run with a live banner still on screen (package picked, sheet closed,
    // Cancel tapped without ever finishing a box).
    var _pkgBanner = root.querySelector('.bbx-pkg-banner');
    if (_pkgBanner) _pkgBanner.remove();
    _editIndex    = -1;
    _editSnapshot = null;
    removeEditModeBar();
    bbx.state.step = 1;

    // Restore static scaffold + chrome (removes complete screen, un-hides grid/capacity)
    if (bbx.showBuilder) bbx.showBuilder(); else showBuilder();

    // Re-render builder back to Step 1
    if (bbx.renderPackages)      bbx.renderPackages();
    if (bbx.renderGrid)          bbx.renderGrid();
    if (bbx.renderCapacity)      bbx.renderCapacity();
    if (bbx.renderCustomisations) bbx.renderCustomisations();
    if (bbx.resetPreviewAnimState) bbx.resetPreviewAnimState();
    if (bbx.renderPreview)       bbx.renderPreview();

    // Reset CTA
    restoreDefaultCta();

    // Fix 6 (branch review): applyTemplate() sets this note visible and never
    // clears it — without this a hand-built box 2 kept showing box 1's
    // "Custom boxes are priced by contents." note.
    var elTplPriceNote = root.querySelector('[data-bbx-tpl-price-note]');
    if (elTplPriceNote) {
      elTplPriceNote.hidden = true;
      elTplPriceNote.textContent = '';
    }

    // Scroll to top of builder
    var builderEl = root.querySelector('[data-bbx-steps]');
    if (builderEl) {
      setTimeout(function () {
        if (bbx.scrollToInBuilder) bbx.scrollToInBuilder(builderEl);
        else builderEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
  }

  /**
   * Restore the sticky CTA to the default "Done — review box" / "Add to Cart" state.
   */
  /**
   * Sticky CTA for the complete ("Box N is ready") screen.
   *
   * Previously the bar just kept "Done — review box", which refreshCta() then
   * disabled because `current` is empty by then — a dead button under a box
   * that is already finished, competing with the receipt's own "Add another
   * box". The order-level action is the honest one here, and it is the only
   * route to checkout from this screen.
   */
  function setReviewOrderCta() {
    var ctaBar = root.querySelector('[data-bbx-cta]');
    if (!ctaBar) return;
    var existing = ctaBar.querySelector('.bbx-cta-btn');
    if (!existing) return;

    var n = bbx.state.bundles.length;
    var btn = existing.cloneNode(false); // drop previous listeners
    btn.textContent = n === 1
      ? t('cta_review_order_one', 'Review order · 1 box')
      : t('cta_review_order', 'Review order · %n% boxes', { n: n });
    btn.disabled = n === 0;
    btn.addEventListener('click', function () {
      if (bbx.renderSummary) bbx.renderSummary();
    });
    existing.parentNode.replaceChild(btn, existing);
  }

  function restoreDefaultCta() {
    var ctaBar = root.querySelector('[data-bbx-cta]');
    if (!ctaBar) return;

    var existing = ctaBar.querySelector('.bbx-cta-btn');
    if (!existing) return;

    var btn = existing.cloneNode(false); // clone without children / listeners
    btn.textContent = t('cta_done_review', 'Done — review box');
    btn.disabled = true;
    // No direct click listener: wireDoneCta's delegation on the CTA bar owns
    // the action. Binding finalizeBundle() here as well meant a step-2 click
    // after "Add another box" ran BOTH handlers — the delegation advancing to
    // Personal Touches while this one finalized the box behind it, so step 3
    // was skipped. Same class of bug as editBundle()'s cloned save button.
    existing.parentNode.replaceChild(btn, existing);
    // The delegated handler reads the live step, so the label must be
    // reconciled against it rather than left at the default wording.
    if (bbx.syncCtaText) bbx.syncCtaText();
  }

  /**
   * Update the sticky CTA label/state when in multi-bundle mode.
   * After a bundle is saved the CTA returns to default state (disabled until items added).
   */
  function updateCtaForMultiBundle() {
    // Was a deliberate no-op on the assumption the CTA "belongs to the next
    // flow". In practice that left "Done — review box" sitting under a
    // finished box, disabled by refreshCta because `current` is empty — a dead
    // button competing with the receipt's own "Add another box", and no
    // sticky route to checkout. Hand the bar the order-level action instead.
    setReviewOrderCta();
  }

  // ── Wire the "Done — review box" primary CTA ─────────────────────────────

  /**
   * The sticky CTA acts as "Done — review box" once ≥1 item is added.
   * refreshCta() in Task 7 already enables/disables based on items.length > 0.
   * We upgrade the CTA label and attach finalizeBundle to its click via event delegation
   * (so the listener survives button re-renders).
   *
   * In stepper mode with customisations, the CTA on step 2 advances to step 3
   * ("Personal Touches") instead of finalizing. syncCtaText() (IIFE 1) keeps
   * the button label correct; this handler reads live state to decide action.
   */
  (function wireDoneCta() {
    var ctaBar = root.querySelector('[data-bbx-cta]');
    if (!ctaBar) return;

    // Relabel the button if it exists (it is static in the Liquid, so it should always be present).
    // The early-return on !btn was removed: the delegation listener below must always be
    // registered on ctaBar so it survives any button DOM replacement (restoreDefaultCta /
    // editBundle clone the button node, which would remove direct listeners).
    var btn = ctaBar.querySelector('.bbx-cta-btn');
    if (btn) {
      btn.textContent = t('cta_done_review', 'Done — review box');
    }

    // Attach click via event delegation on the CTA bar (survives button state changes).
    // In stepper mode on step 2 with customisations (and not in edit mode),
    // the CTA advances to step 3 ("Personal Touches") rather than finalizing.
    ctaBar.addEventListener('click', function (e) {
      if (!e.target.closest('.bbx-cta-btn')) return;
      var step = bbx.state && bbx.state.step;
      var hasCus = (bbx.cfg && (bbx.cfg.customisations || []).length > 0);
      var hasPkg = !!(bbx.state && bbx.state.current && bbx.state.current.pkg);
      var stepper = !!(bbx.isStepperMode && bbx.isStepperMode());
      // Mirrors syncCtaText's `goesForward`, so the label and the action can
      // never disagree. Edit mode is NOT excluded any more: it used to be,
      // because editBundle() bound its own save listener directly to the
      // button — which meant an edit skipped step 3 entirely. finalizeBundle()
      // already handles both cases (replace in place while editing, append
      // otherwise), so the terminal branch is correct for edits too.
      if (stepper && step === 1 && hasPkg) {
        bbx.goToStep(2);
      } else if (stepper && step === 2 && hasCus) {
        bbx.goToStep(3);
      } else {
        finalizeBundle();
      }
    });
  })();

  // ── Expose on namespace ───────────────────────────────────────────────────
  bbx.bundleTotal   = bundleTotal;
  bbx.grandTotal    = grandTotal;
  bbx.finalizeBundle = finalizeBundle;
  bbx.renderSummary = renderSummary;
  bbx.editBundle    = editBundle;
  bbx.startNewBundle = startNewBundle;
  bbx.renderCompleteScreen = renderCompleteScreen;
  // Read-only probes for IIFE 1's syncCtaText, which renders the edit-mode
  // terminal label ("Save changes to Box N"). _editIndex stays private here.
  bbx.isEditing     = function () { return _editIndex !== -1; };
  bbx.editingIndex  = function () { return _editIndex; };

  // ── Self-check (Task 10) ─────────────────────────────────────────────────
  (function selfCheckT10() {

    // ── Helper: create a minimal mock bundle ──────────────────────────────────
    var mockPkg = { gid: 'gid://test/pkg/1', name: 'Premium 1kg', price: 299, weight_capacity_g: 1000, max_items: 4 };
    var mockP1  = { id: 101, title: 'Cashews', featured_image: '', variants: [{ gid: 'v1', title: '500g', price: 60000, weight: 500, weight_unit: 'g' }] };
    var mockP2  = { id: 102, title: 'Almonds', featured_image: '', variants: [{ gid: 'v2', title: '1kg',  price: 80000, weight: 1000, weight_unit: 'g' }] };
    var mockCust = { gid: 'gid://test/cust/1', name: 'Gold Ribbon', price: 50 };

    var mockCurrent = {
      pkg:   mockPkg,
      items: [
        { product: mockP1, allocatedG: 500, priceP: 60000 },
        { product: mockP2, allocatedG: 500, priceP: 40000 }
      ],
      customisations: [
        { customisation: mockCust, priceP: 5000 }
      ]
    };

    // ── T10-1: bundleTotal computation ────────────────────────────────────────
    var copy1 = deepCopyBundle(mockCurrent);
    var total1 = bundleTotal(copy1);
    // pkg: 299 * 100 = 29900 paise
    // items: 60000 + 40000 = 100000 paise
    // custs: 5000 paise
    // Expected: 134900 paise
    console.assert(
      total1 === 134900,
      '[bbx T10] bundleTotal should be 134900 paise', total1
    );

    // ── T10-2: Simulate finalizeBundle — 2 bundles ────────────────────────────
    var savedBundles = [];
    savedBundles.push(deepCopyBundle(mockCurrent));

    var mockCurrent2 = {
      pkg:   mockPkg,
      items: [
        { product: mockP1, allocatedG: 333, priceP: 39960 },
        { product: mockP2, allocatedG: 334, priceP: 26720 },
        { product: mockP1, allocatedG: 333, priceP: 39960 }
      ],
      customisations: []
    };
    savedBundles.push(deepCopyBundle(mockCurrent2));

    console.assert(
      savedBundles.length === 2,
      '[bbx T10] After finalizing 2 bundles, bundles.length should be 2', savedBundles.length
    );

    // ── T10-3: Grand total = sum of two box totals ────────────────────────────
    var t1 = bundleTotal(savedBundles[0]);
    var t2 = bundleTotal(savedBundles[1]);
    var fakeGrand = t1 + t2;
    // t2: pkg 29900 + items (39960+26720+39960=106640) + custs 0 = 136540
    console.assert(
      fakeGrand === t1 + t2,
      '[bbx T10] Grand total should equal sum of two box totals',
      { fakeGrand: fakeGrand, t1: t1, t2: t2 }
    );

    // ── T10-4: Remove drops length to 1 ──────────────────────────────────────
    savedBundles.splice(0, 1); // remove first
    console.assert(
      savedBundles.length === 1,
      '[bbx T10] After remove, bundles.length should be 1', savedBundles.length
    );

    // ── T10-5: Deep-copy independence ─────────────────────────────────────────
    // After finalizing, mutating current must NOT change the stored bundle.
    var testCurrent = {
      pkg:   mockPkg,
      items: [{ product: mockP1, allocatedG: 500, priceP: 60000 }],
      customisations: []
    };
    var storedCopy = deepCopyBundle(testCurrent);

    // Now mutate testCurrent as if the user changed the box
    testCurrent.items[0].allocatedG = 999;
    testCurrent.items[0].priceP     = 99999;
    testCurrent.pkg.name = 'MUTATED';

    console.assert(
      storedCopy.items[0].allocatedG === 500,
      '[bbx T10] Deep-copy independence: stored allocatedG must not be affected by current mutation',
      storedCopy.items[0].allocatedG
    );
    console.assert(
      storedCopy.items[0].priceP === 60000,
      '[bbx T10] Deep-copy independence: stored priceP must not be affected by current mutation',
      storedCopy.items[0].priceP
    );
    console.assert(
      storedCopy.pkg.name === 'Premium 1kg',
      '[bbx T10] Deep-copy independence: stored pkg.name must not be affected by current mutation',
      storedCopy.pkg.name
    );

    // ── T10-6: 5-box cap enforcement ─────────────────────────────────────────
    var capTest = [];
    for (var i = 0; i < MAX_BUNDLES; i++) {
      capTest.push(deepCopyBundle(mockCurrent));
    }
    console.assert(
      capTest.length === MAX_BUNDLES,
      '[bbx T10] 5-cap: bundles at max should equal MAX_BUNDLES', capTest.length
    );
    var wouldReachCap = capTest.length >= MAX_BUNDLES;
    console.assert(
      wouldReachCap === true,
      '[bbx T10] 5-cap: capReached should be true when at MAX_BUNDLES'
    );

    console.log('[bbx] Task 10 self-check complete.');
  })();
})();

// ---------------------------------------------------------------------------
// Task 11 — Add-all-to-cart via the Edge Function
// ---------------------------------------------------------------------------
// Reads cfg.edgeFnUrl + cfg.bundleApiKey (set as section settings, emitted in
// data-bbx-config). Sends an identifiers-only POST body — NO prices.
// Only calls /cart/add.js after a successful edge response.
// On failure: re-enables the CTA and shows a non-blocking toast.
(function () {
  'use strict';

  var root =
    document.querySelector('[data-bbx]') ||
    document.querySelector('.sindhi-bundle-builder');
  if (!root || !root.__bbx) return;

  var bbx = root.__bbx;
  var t = function(key, fallback, vars) { return bbx.t ? bbx.t(key, fallback, vars) : fallback; };
  var cfg = bbx.cfg;

  // ── UUID helper ────────────────────────────────────────────────────────────
  /**
   * Generate a UUID v4.
   * Uses crypto.randomUUID() when available (modern browsers + Shopify's
   * sandboxed theme context), falls back to a Math.random-based version.
   * @returns {string}
   */
  function generateUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    // Fallback: RFC 4122 v4 via Math.random
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // ── Toast notification ─────────────────────────────────────────────────────
  /**
   * Show a non-blocking error toast for ~4 seconds, then remove it.
   * Uses CSS custom properties from the builder root for consistent theming.
   * @param {string} message
   */
  function showErrorToast(message) {
    // Remove any existing toast
    var existing = document.getElementById('bbx-error-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    toast.id = 'bbx-error-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.textContent = message;

    // Inject minimal inline styles — no hardcoded colours, all CSS vars
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%)',
      'z-index:9999',
      'max-width:min(420px,90vw)',
      'padding:14px 20px',
      'border-radius:8px',
      'background:var(--dark-chocolate,#3E2723)',
      'color:var(--cream,#FFF8F0)',
      'font-family:var(--font-body--family,"DM Sans",sans-serif)',
      'font-size:var(--type-body,0.95rem)',
      'font-weight:500',
      'box-shadow:0 4px 24px rgba(0,0,0,0.28)',
      'border-left:4px solid var(--burgundy,#722F37)',
      'animation:bbxToastIn 0.22s ease both',
      'pointer-events:none'
    ].join(';');

    // Inject keyframe once
    if (!document.getElementById('bbx-toast-kf')) {
      var kfStyle = document.createElement('style');
      kfStyle.id = 'bbx-toast-kf';
      kfStyle.textContent =
        '@keyframes bbxToastIn{from{opacity:0;transform:translateX(-50%) translateY(12px)}' +
        'to{opacity:1;transform:translateX(-50%) translateY(0)}}';
      document.head.appendChild(kfStyle);
    }

    document.body.appendChild(toast);

    // Auto-remove after 4 s
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 4000);
  }

  // ── Open cart drawer or fall back to /cart ─────────────────────────────────
  /**
   * After a successful /cart/add.js call, open the Sindhi cart drawer
   * (sindhi-cart-drawer custom element) if it exists; otherwise navigate to /cart.
   * Event name discovered in assets/sindhi-cart-drawer.js: the element exposes
   * a public .open() method and dispatches 'sindhi:cart:open' after opening.
   */
  function openCartDrawerOrNavigate() {
    var drawerEl = document.querySelector('sindhi-cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      // Trigger the drawer's built-in refresh + open
      if (typeof drawerEl._refresh === 'function') {
        drawerEl._refresh().then(function () {
          drawerEl.open();
        }).catch(function () {
          drawerEl.open();
        });
      } else {
        drawerEl.open();
      }
    } else {
      // Fallback: hard navigate to cart
      window.location.href = '/cart';
    }
  }

  // ── addAllToCart() ─────────────────────────────────────────────────────────
  /**
   * Build an identifiers-only payload from state.bundles,
   * POST to the edge function, then add the returned variants to the Shopify cart.
   *
   * Security model (§3.10): NO prices are sent — the edge function recomputes
   * them server-side. The self-check below asserts no price keys in the payload.
   *
   * Double-submit guard: sets bbx._adding = true on start, clears on finish.
   */
  function addAllToCart() {
    // Re-entry guard
    if (bbx._adding) return;

    var bundles = bbx.state.bundles;
    if (!bundles || bundles.length === 0) return;

    // ── Disable CTA + show staged progress bar ────────────────────────────────
    var addAllBtn = root.querySelector('.bbx-summary-add-all-btn');
    var originalLabel = addAllBtn ? addAllBtn.textContent : '';
    if (addAllBtn) {
      addAllBtn.disabled = true;
      addAllBtn.innerHTML =
        '<span class="bbx-addbar">' +
          '<span class="bbx-addbar__label" data-bbx-addbar-label></span>' +
          '<span class="bbx-addbar__track"><span class="bbx-addbar__fill" data-bbx-addbar-fill></span></span>' +
        '</span>';
    }
    bbx._adding = true;
    function setProgress(pct, msg) {
      if (!addAllBtn) return;
      var fill = addAllBtn.querySelector('[data-bbx-addbar-fill]');
      var lab  = addAllBtn.querySelector('[data-bbx-addbar-label]');
      if (fill) fill.style.width = pct + '%';
      if (lab)  lab.textContent = msg;
      if (bbx.announceToSR) bbx.announceToSR(msg);
    }
    function restoreCta() {
      bbx._adding = false;
      if (!addAllBtn) return;
      addAllBtn.disabled = false;
      addAllBtn.textContent = originalLabel;
    }
    setProgress(10, t('cart_progress_pricing', 'Pricing your boxes…'));

    // ── Build identifiers-only payload ────────────────────────────────────────
    // IMPORTANT: no price fields in this object — server recomputes (§3.10).
    var payloadBundles = bundles.map(function (bundle) {
      // Assign a UUID if the bundle doesn't already have one.
      // We attach the id to the stored bundle so edits preserve the same id.
      if (!bundle._uuid) {
        bundle._uuid = generateUUID();
      }

      return {
        bundle_id: bundle._uuid,
        package_metaobject_gid: bundle.pkg ? bundle.pkg.gid : '',
        customisation_metaobject_gids: (bundle.customisations || []).map(function (c) {
          return c.customisation.gid;
        }),
        items: (bundle.items || []).map(function (it) {
          var v = bbx.nearestVariant(it.product, it.allocatedG);
          return {
            variant_gid: v ? v.gid : '',
            allocated_weight_g: it.allocatedG
          };
        })
      };
    });

    var edgeFnUrl   = cfg.edgeFnUrl   || '';
    var bundleApiKey = cfg.bundleApiKey || '';

    if (!edgeFnUrl) {
      // Edge function URL not configured — surface a clear dev message, restore CTA
      console.error('[bbx T11] cfg.edgeFnUrl is not set. Cannot add to cart.');
      showErrorToast(t('cart_service_missing', 'Could not add to cart — bundle service URL is missing. Please contact support.'));
      bbx._adding = false;
      if (addAllBtn) {
        addAllBtn.disabled = false;
        addAllBtn.textContent = originalLabel;
      }
      return;
    }

    // ── POST to edge function ─────────────────────────────────────────────────
    var headers = { 'Content-Type': 'application/json' };
    if (bundleApiKey) {
      headers['X-Bundle-Key'] = bundleApiKey;
    }

    fetch(edgeFnUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ bundles: payloadBundles })
    })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json()
          .catch(function () { return {}; })
          .then(function (body) {
            var detail = body && body.error ? body.error : ('HTTP ' + res.status);
            if (body && body.detail) detail += ' — ' + JSON.stringify(body.detail);
            throw new Error('Edge function ' + res.status + ': ' + detail);
          });
      })
      .then(function (resp) {
        if (!resp.ok) throw new Error(resp.error || 'Edge function returned ok:false');

        // ── /cart/add.js — only reached after a successful edge response ────────
        setProgress(65, t('cart_progress_adding', 'Adding to cart…'));
        var cartItems = resp.variants.map(function (v) {
          return { id: Number(v.variant_numeric_id), quantity: 1, properties: v.properties || {} };
        });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
      })
      .then(function (cartRes) {
        if (!cartRes.ok) throw new Error('/cart/add.js returned ' + cartRes.status);
        return cartRes.json();
      })
      .then(function () {
        // Success — open the cart drawer (or navigate to /cart as fallback)
        restoreCta();
        // Close the stepper BEFORE the cart drawer, same reasoning and same
        // fix as buyTemplateAsIs above — otherwise the drawer opens behind a
        // full-screen sheet with document scroll still locked. No-op when the
        // sheet is not open, so desktop is unaffected.
        // Called via bbx (not bare) because this handler runs in a different
        // IIFE than closeStepper's own declaration — a bare call throws
        // ReferenceError, which was silently swallowed by the .catch below
        // (cart write already succeeded, so this had already broken the
        // primary Add-all-to-cart path on every breakpoint before this fix).
        if (bbx.closeStepper) bbx.closeStepper();
        // The boxes are in the cart now, so the saved draft is spent — leaving
        // it would offer to "resume" boxes the shopper has already bought.
        // Independent of closeStepper(); order between the two doesn't matter.
        // Guarded because the draft IIFE bails out early if it can't find root.
        if (bbx.clearDraft) bbx.clearDraft();
        // clearDraft() alone isn't enough: state.bundles still holds the boxes
        // that were just ordered, so the next `pagehide` would re-save them and
        // resurrect the draft. Emptying the array is what makes the clear stick.
        // renderSummary() then refreshes the panel off the new empty array —
        // the same mutate-then-re-render pattern the remove-bundle handler uses.
        // Called as bbx.renderSummary (not bare) because it is defined in the
        // preceding IIFE and only reachable here through the namespace.
        bbx.state.bundles = [];
        // closeStepper() above already saved+repainted the teaser, but it ran
        // BEFORE state.bundles was emptied here, so it paints "Continue your
        // box" for an order that's already in the cart. Repaint now that state
        // and the draft are both actually clean.
        if (bbx.renderTeaser) bbx.renderTeaser();
        if (bbx.renderSummary) bbx.renderSummary();
        openCartDrawerOrNavigate();
      })
      .catch(function (err) {
        // ── Error path: restore CTA, show non-blocking toast ─────────────────
        // The cart is untouched on edge function failure — /cart/add.js is only
        // called after a confirmed edge response.
        console.error('[bbx T11] addAllToCart failed:', err);
        restoreCta();
        showErrorToast(t('cart_add_error', "Couldn't build your boxes — please try again."));
      });
  }

  // ── Register on namespace ─────────────────────────────────────────────────
  bbx.addAllToCart = addAllToCart;
  // Task 15 (IIFE 1) has no reach into this later IIFE's locals — export the
  // real drawer-refresh path so "Buy this box" can reuse it instead of an
  // invented cart-refresh event.
  bbx.openCartDrawerOrNavigate = openCartDrawerOrNavigate;

  // ── Self-check (Task 11) — payload shape verification ────────────────────
  (function selfCheckT11() {
    // Mock bundles replicating the shape produced by Tasks 7-10
    var mockPkgA = {
      gid: 'gid://shopify/Metaobject/100',
      name: 'Premium 1kg',
      price: 299,
      weight_capacity_g: 1000,
      max_items: 4
    };
    var mockPkgB = {
      gid: 'gid://shopify/Metaobject/101',
      name: 'Classic 500g',
      price: 199,
      weight_capacity_g: 500,
      max_items: 2
    };

    var mockP1 = {
      id: 1,
      title: 'Cashews',
      featured_image: '',
      variants: [
        { gid: 'gid://shopify/ProductVariant/501', title: '500g', price: 60000, weight: 500, weight_unit: 'g' }
      ]
    };
    var mockP2 = {
      id: 2,
      title: 'Almonds',
      featured_image: '',
      variants: [
        { gid: 'gid://shopify/ProductVariant/502', title: '1kg',  price: 80000, weight: 1000, weight_unit: 'g' }
      ]
    };

    var mockCustA = { gid: 'gid://shopify/Metaobject/200', name: 'Gold Ribbon',    price: 50 };
    var mockCustB = { gid: 'gid://shopify/Metaobject/201', name: 'Message Card',   price: 30 };

    // Two-bundle mock state (mirrors state.bundles shape)
    var mockBundles = [
      {
        pkg: mockPkgA,
        items: [
          { product: mockP1, allocatedG: 500, priceP: 60000 },
          { product: mockP2, allocatedG: 500, priceP: 40000 }
        ],
        customisations: [
          { customisation: mockCustA, priceP: 5000 }
        ]
      },
      {
        pkg: mockPkgB,
        items: [
          { product: mockP1, allocatedG: 250, priceP: 30000 },
          { product: mockP2, allocatedG: 250, priceP: 20000 }
        ],
        customisations: [
          { customisation: mockCustA, priceP: 5000 },
          { customisation: mockCustB, priceP: 3000 }
        ]
      }
    ];

    // Build the payload using the same logic as addAllToCart()
    var testPayload = mockBundles.map(function (bundle) {
      if (!bundle._uuid) bundle._uuid = generateUUID();
      return {
        bundle_id: bundle._uuid,
        package_metaobject_gid: bundle.pkg ? bundle.pkg.gid : '',
        customisation_metaobject_gids: (bundle.customisations || []).map(function (c) {
          return c.customisation.gid;
        }),
        items: (bundle.items || []).map(function (it) {
          var v = bbx.nearestVariant(it.product, it.allocatedG);
          return {
            variant_gid: v ? v.gid : '',
            allocated_weight_g: it.allocatedG
          };
        })
      };
    });

    // ── Assert: correct structure for bundle 0 ───────────────────────────────
    var b0 = testPayload[0];
    console.assert(
      typeof b0.bundle_id === 'string' && b0.bundle_id.length > 0,
      '[bbx T11] bundle[0].bundle_id must be a non-empty string', b0.bundle_id
    );
    console.assert(
      b0.package_metaobject_gid === 'gid://shopify/Metaobject/100',
      '[bbx T11] bundle[0].package_metaobject_gid wrong', b0.package_metaobject_gid
    );
    console.assert(
      Array.isArray(b0.customisation_metaobject_gids) &&
      b0.customisation_metaobject_gids.length === 1 &&
      b0.customisation_metaobject_gids[0] === 'gid://shopify/Metaobject/200',
      '[bbx T11] bundle[0].customisation_metaobject_gids wrong', b0.customisation_metaobject_gids
    );
    console.assert(
      Array.isArray(b0.items) && b0.items.length === 2,
      '[bbx T11] bundle[0].items must have 2 entries', b0.items
    );
    console.assert(
      b0.items[0].variant_gid === 'gid://shopify/ProductVariant/501',
      '[bbx T11] bundle[0].items[0].variant_gid wrong', b0.items[0].variant_gid
    );
    console.assert(
      b0.items[0].allocated_weight_g === 500,
      '[bbx T11] bundle[0].items[0].allocated_weight_g wrong', b0.items[0].allocated_weight_g
    );
    console.assert(
      b0.items[1].variant_gid === 'gid://shopify/ProductVariant/502',
      '[bbx T11] bundle[0].items[1].variant_gid wrong', b0.items[1].variant_gid
    );
    console.assert(
      b0.items[1].allocated_weight_g === 500,
      '[bbx T11] bundle[0].items[1].allocated_weight_g wrong', b0.items[1].allocated_weight_g
    );

    // ── Assert: bundle 1 with 2 customisations ────────────────────────────────
    var b1 = testPayload[1];
    console.assert(
      b1.customisation_metaobject_gids.length === 2 &&
      b1.customisation_metaobject_gids[1] === 'gid://shopify/Metaobject/201',
      '[bbx T11] bundle[1].customisation_metaobject_gids wrong', b1.customisation_metaobject_gids
    );

    // ── CRITICAL: assert NO price keys anywhere in the payload ────────────────
    // Prices are computed server-side by the edge function (security model §3.10).
    var payloadStr = JSON.stringify(testPayload);
    console.assert(
      payloadStr.indexOf('"price"') === -1,
      '[bbx T11] SECURITY: payload must contain NO "price" keys', payloadStr.substring(0, 200)
    );
    console.assert(
      payloadStr.indexOf('"priceP"') === -1,
      '[bbx T11] SECURITY: payload must contain NO "priceP" keys', payloadStr.substring(0, 200)
    );

    // ── Assert: each item has exactly variant_gid + allocated_weight_g ────────
    testPayload.forEach(function (bundle, bi) {
      bundle.items.forEach(function (item, ii) {
        var keys = Object.keys(item);
        console.assert(
          keys.length === 2 &&
          keys.indexOf('variant_gid') !== -1 &&
          keys.indexOf('allocated_weight_g') !== -1,
          '[bbx T11] item[' + bi + '][' + ii + '] must have exactly variant_gid + allocated_weight_g', keys
        );
      });
    });

    console.log('[bbx] Task 11 self-check complete. Mock payload (2 bundles):',
      JSON.stringify({ bundles: testPayload }, null, 2));
  })();
})();

// ---------------------------------------------------------------------------
// Mobile stepper — draft persistence (spec 2026-08-12)
// ---------------------------------------------------------------------------
// localStorage, device-local. Cross-device resume (a swap to a cart attribute
// behind the same UI) is a documented future upgrade, not built here.
(function () {
  'use strict';

  var root =
    document.querySelector('[data-bbx]') ||
    document.querySelector('.sindhi-bundle-builder');
  if (!root || !root.__bbx) return;

  var bbx = root.__bbx;

  /** Bump when the payload shape changes; a mismatch discards the draft. */
  var DRAFT_VERSION = 1;
  var DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

  // Review finding 7: the `bbx-draft:` prefix namespaces this entry against
  // OTHER localStorage users on the origin — that, and only that, is what it
  // buys. It does NOT make the key unique per template: root.id is rendered as
  // `bbx-{{ section.id }}`, and inside a JSON template section.id is just the
  // section key ("main"), so every page carrying this section produces the same
  // `bbx-draft:bbx-main`. Harmless today (one template uses the section, and a
  // draft is conceptually one-per-shopper anyway); if the builder is ever added
  // to a second template that should hold an independent draft, key it off
  // something genuinely distinct (template name / handle), not root.id.
  // It also does not protect against two builder instances on one page, which
  // every IIFE in this file already precludes by binding to the first
  // [data-bbx] match only.
  var DRAFT_KEY = 'bbx-draft:' + (root.id || 'bbx');

  function readRaw() {
    try { return window.localStorage.getItem(DRAFT_KEY); } catch (e) { return null; }
  }

  function writeRaw(value) {
    try { window.localStorage.setItem(DRAFT_KEY, value); return true; } catch (e) { return false; }
  }

  function clearDraft() {
    try { window.localStorage.removeItem(DRAFT_KEY); } catch (e) { /* private mode */ }
  }

  /** True when the live in-memory state holds anything worth persisting. */
  function draftHasContent() {
    var st = bbx.state;
    if (!st) return false;
    if (st.bundles && st.bundles.length > 0) return true;
    if (!st.current) return false;
    return !!st.current.pkg || (st.current.items && st.current.items.length > 0);
  }

  /**
   * Persist the in-progress box AND every already-finalized box.
   *
   * state.bundles is not optional here: a shopper who finished two boxes and
   * closed the sheet mid-way through a third would otherwise lose the two
   * finished ones — worse than the in-memory-only baseline this replaces.
   *
   * Items carry their FULL product objects (not references). Drawer-added
   * products come from rowToProduct() and never existed in cfg, so a reference
   * would be unresolvable on restore.
   */
  function saveDraft() {
    // Review finding 1 (critical): this branch used to clearDraft(). saveDraft
    // is wired to `pagehide`, which fires on EVERY navigation away — including
    // a fresh page load where state is still empty, or a second tab. Clearing
    // here therefore destroyed a real saved draft the moment the shopper left
    // without resuming it. Auto-save must never destroy; only an explicit
    // clearDraft() call (Task 10, post-addAllToCart) may remove a draft.
    if (!draftHasContent()) return false;
    var payload;
    try {
      payload = JSON.stringify({
        schemaVersion: DRAFT_VERSION,
        savedAt: Date.now(),
        step: bbx.state.step == null ? 1 : bbx.state.step,
        current: bbx.state.current,
        bundles: bbx.state.bundles
      });
    } catch (e) {
      // Circular / unserialisable state — a failed save just means no draft.
      console.warn('[bbx] draft serialise failed:', e);
      return false;
    }
    return writeRaw(payload);
  }

  /**
   * Read the stored draft. Returns null — treated everywhere as "no draft" —
   * for a missing entry, unparseable JSON, a schemaVersion mismatch, or a
   * payload older than the 7-day staleness window.
   */
  function loadDraft() {
    var raw = readRaw();
    if (!raw) return null;
    var parsed;
    try { parsed = JSON.parse(raw); } catch (e) { clearDraft(); return null; }
    if (!parsed || typeof parsed !== 'object') { clearDraft(); return null; }
    if (parsed.schemaVersion !== DRAFT_VERSION) { clearDraft(); return null; }
    if (!parsed.savedAt || (Date.now() - parsed.savedAt) > DRAFT_MAX_AGE_MS) { clearDraft(); return null; }
    if (!parsed.current) { clearDraft(); return null; }
    return parsed;
  }

  /**
   * Drop items whose persisted product can no longer be priced.
   *
   * Deliberately NOT a cfg-membership check: cfg.featuredProducts and
   * templates[].items only ever hold the preloaded top-N, so anything the
   * shopper hand-picked through the browse-all drawer would be flagged
   * "no longer available" on every single restore.
   */
  function pruneItems(items) {
    // Review finding 5: guard the shape. A hand-edited / truncated localStorage
    // entry can hold `items: "oops"`, which .filter would throw on.
    return (Array.isArray(items) ? items : []).filter(function (it) {
      if (!it || !it.product) return false;
      if (!it.product.variants || !it.product.variants.length) return false;
      return bbx.productHasWeightTitle(it.product);
    });
  }

  /**
   * Re-resolve a persisted package against the live cfg.packages list.
   *
   * Stage 3 opus audit, finding 9: unlike products (which can be drawer-added
   * and thus legitimately absent from cfg — never cfg-checked, see pruneItems
   * above), current.pkg / bundles[].pkg always come from cfg.packages. If a
   * package is deactivated during the 7-day draft window, restoring the draft
   * would otherwise carry a dead gid straight into addAllToCart()'s
   * package_metaobject_gid, failing at the bundle edge function AFTER the
   * shopper has refilled the whole box.
   */
  function resolvePkg(pkg) {
    if (!pkg || !pkg.gid) return null;
    var live = (bbx.cfg && bbx.cfg.packages) || [];
    var match = live.filter(function (p) { return p.gid === pkg.gid; })[0];
    // Review finding 6: this returns the LIVE cfg object by reference, not a
    // deep copy like deepCopyBundle() makes. Intentional — the point is to pick
    // up current package values (name, price, capacity), and nothing in the
    // builder mutates a pkg object. Do not "fix" this into a JSON round-trip:
    // that would silently reintroduce the stale-values problem this solves.
    return match || null;
  }

  /**
   * Re-resolve a persisted customisation (add-on) against live cfg.customisations.
   *
   * Review finding 4: exactly the failure resolvePkg() prevents, for a different
   * field. addAllToCart() sends c.customisation.gid as
   * customisation_metaobject_gids, identically to package_metaobject_gid, so a
   * ribbon/add-on deactivated during the 7-day draft window would carry a dead
   * gid into the edge function. Not rare: defaultCustomisations() seeds add-ons
   * onto every new box. Price is re-derived from the live entry with the same
   * paise conversion defaultCustomisations() uses, so a price change in the
   * window is picked up rather than restored stale.
   */
  function resolveCust(entry) {
    var gid = entry && entry.customisation && entry.customisation.gid;
    if (!gid) return null;
    var live = ((bbx.cfg && bbx.cfg.customisations) || []).filter(function (c) { return c.gid === gid; })[0];
    if (!live) return null;
    return { customisation: live, priceP: Math.round((parseFloat(live.price) || 0) * 100) };
  }

  /**
   * Re-derive gram allocations and prices for a restored box.
   *
   * Review finding 2: rebalance() only ever touches state.current, so restored
   * bundles[] kept whatever allocatedG/priceP they were saved with. A 1000g box
   * that loses one of two items to pruning would restore holding 500g, and
   * addAllToCart() posts allocated_weight_g verbatim — an under-filled order.
   * Stale priceP has the same shape after any variant price change in the
   * window. Reuses the section's own evenSplit/allocatedPrice helpers so the
   * restore path derives weights exactly the way the live builder does.
   */
  function repriceItems(pkg, items) {
    var capG = pkg ? (parseInt(pkg.weight_capacity_g, 10) || 0) : 0;
    if (capG > 0 && items.length) {
      var splits = bbx.evenSplit(capG, items.length);
      items.forEach(function (it, i) { it.allocatedG = splits[i] || 0; });
    }
    items.forEach(function (it) { it.priceP = bbx.allocatedPrice(it.product, it.allocatedG); });
    return items;
  }

  /**
   * Normalise a stored payload into restorable state, reporting how many items
   * (and, per finding 9, packages) were dropped so the teaser can show the
   * stale-draft notice.
   */
  function sanitiseDraft(payload) {
    var dropped = 0;

    // Review finding 5: every list read below goes through Array.isArray, so a
    // malformed payload degrades to an empty draft instead of throwing.
    function pruneCusts(list) {
      var src = Array.isArray(list) ? list : [];
      var out = src.map(resolveCust).filter(Boolean);
      dropped += (src.length - out.length);
      return out;
    }

    var srcCurrent = payload.current || {};
    var currentItems = pruneItems(srcCurrent.items);
    dropped += ((Array.isArray(srcCurrent.items) ? srcCurrent.items : []).length - currentItems.length);

    var currentPkg = resolvePkg(srcCurrent.pkg);
    if (srcCurrent.pkg && !currentPkg) dropped += 1;

    var current = {
      pkg: currentPkg,
      items: repriceItems(currentPkg, currentItems),
      customisations: pruneCusts(srcCurrent.customisations)
    };

    var bundles = (Array.isArray(payload.bundles) ? payload.bundles : [])
      .filter(Boolean)
      .map(function (b) {
        var items = pruneItems(b.items);
        dropped += ((Array.isArray(b.items) ? b.items : []).length - items.length);
        var bPkg = resolvePkg(b.pkg);
        if (b.pkg && !bPkg) dropped += 1;
        // _uuid is preserved: the cart identifies a bundle by it, so editing a
        // restored box must not mint a new one.
        return {
          pkg: bPkg,
          items: repriceItems(bPkg, items),
          customisations: pruneCusts(b.customisations),
          _uuid: b._uuid
        };
      })
      // Review finding 3: a finished bundle pruned to zero items would still
      // count toward state.bundles.length and grandTotal(), and addAllToCart()
      // would post it with a real package_metaobject_gid and no items — an
      // empty box billed, or an edge-function rejection. finalizeBundle()
      // enforces items.length > 0 on the live path; the restore path has to
      // enforce the same invariant itself.
      .filter(function (b) { return b.items.length > 0; });

    // Clamp a step-3 draft to step 2 when the merchant has since removed all
    // customisations — avoids restoring onto an empty "Personal Touches" panel.
    var rawStep = payload.step == null ? 1 : payload.step;
    var hasCus = (bbx.cfg && (bbx.cfg.customisations || []).length > 0);
    var safeStep = (rawStep === 3 && !hasCus) ? 2 : rawStep;

    return {
      step: safeStep,
      current: current,
      bundles: bundles,
      dropped: dropped
    };
  }

  bbx.saveDraft       = saveDraft;
  bbx.loadDraft       = loadDraft;
  bbx.clearDraft      = clearDraft;
  bbx.draftHasContent = draftHasContent;
  bbx.sanitiseDraft   = sanitiseDraft;

  // ── Teaser (collapsed page state) ─────────────────────────────────────────

  var t = function (key, fallback, vars) { return bbx.t ? bbx.t(key, fallback, vars) : fallback; };

  var elTeaser      = root.querySelector('[data-bbx-teaser]');
  var elTeaserDraft = root.querySelector('[data-bbx-teaser-draft]');
  var elTeaserCta   = root.querySelector('[data-bbx-teaser-cta]');
  var elTeaserReset = root.querySelector('[data-bbx-teaser-reset]');

  /** Set true by restoreDraft() when sanitising dropped at least one item. */
  var _staleNoticeNeeded = false;

  function makeEl(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function appendLine(parent, label, value, isTotal) {
    var row = makeEl('p', 'bbx-teaser__draft-line' + (isTotal ? ' bbx-teaser__draft-line--total' : ''));
    row.appendChild(makeEl('span', null, label));
    row.appendChild(makeEl('span', null, value));
    parent.appendChild(row);
  }

  /** Total across every finished box plus the box in progress (paise). */
  function snapshotTotal(snap) {
    var total = bbx.bundleTotal ? bbx.bundleTotal(snap.current) : 0;
    (snap.bundles || []).forEach(function (b) {
      total += bbx.bundleTotal ? bbx.bundleTotal(b) : 0;
    });
    return total;
  }

  /**
   * Render the teaser's two CTA states.
   *
   * "Has a box" means either live in-memory state (the sheet was just closed)
   * or a stored draft from an earlier visit — the button and the summary card
   * read the same either way.
   */
  function renderTeaser() {
    if (!elTeaser || !elTeaserCta) return;

    var live = draftHasContent();
    var stored = live ? null : loadDraft();
    var has = live || !!stored;

    elTeaserCta.textContent = has
      ? t('teaser_cta_continue', 'Continue your box')
      : t('teaser_cta', 'Build Your Box');

    if (elTeaserReset) elTeaserReset.hidden = !has;
    if (!elTeaserDraft) return;

    if (!has) {
      elTeaserDraft.hidden = true;
      elTeaserDraft.innerHTML = '';
      return;
    }

    var snap = live
      ? {
          step: bbx.state.step == null ? 1 : bbx.state.step,
          current: bbx.state.current,
          bundles: bbx.state.bundles,
          dropped: 0
        }
      : sanitiseDraft(stored);

    elTeaserDraft.innerHTML = '';
    elTeaserDraft.hidden = false;

    elTeaserDraft.appendChild(
      makeEl('p', 'bbx-teaser__draft-heading', t('teaser_heading', 'Your saved box'))
    );

    // Only describe an in-progress box when one actually exists. With a
    // finished box and an empty `current` (the state right after finalizing)
    // these lines used to render as
    // "Package: No package chosen yet / 0 items / Currently on: Fillers" —
    // three statements about a box the shopper never started, over a teaser
    // whose running total came entirely from the box they HAD finished.
    var itemCount = (snap.current.items || []).length;
    var hasInProgress = !!(snap.current.pkg) || itemCount > 0;

    if (hasInProgress) {
      appendLine(
        elTeaserDraft,
        t('complete_section_package', 'Package'),
        (snap.current.pkg && snap.current.pkg.name) || t('teaser_no_package', 'No package chosen yet')
      );

      // stepLabel() returns '' for a step not in the current trail (e.g. step 0
      // once bundles exist) — fall back to the raw number rather than "Currently
      // on: " with nothing after it.
      var stepText = (bbx.stepLabel && bbx.stepLabel(snap.step)) || String(snap.step);
      appendLine(
        elTeaserDraft,
        itemCount === 1
          ? t('items_count', '%count% item', { count: itemCount })
          : t('items_count_plural', '%count% items', { count: itemCount }),
        t('teaser_progress_step', 'Currently on: %step%', { step: stepText })
      );
    }

    var doneCount = (snap.bundles || []).length;
    if (doneCount > 0) {
      // itemCount === 0 means `current` is empty (e.g. a draft saved from the
      // complete screen) — there is no box actually in progress, so "1 in
      // progress" would be wrong copy.
      var doneText = itemCount > 0
        ? (doneCount === 1
            ? t('teaser_boxes_done_one', '%n% box done, 1 in progress', { n: doneCount })
            : t('teaser_boxes_done_other', '%n% boxes done, 1 in progress', { n: doneCount }))
        : (doneCount === 1
            ? t('teaser_boxes_done_one_only', '%n% box done', { n: doneCount })
            : t('teaser_boxes_done_other_only', '%n% boxes done', { n: doneCount }));
      elTeaserDraft.appendChild(makeEl('p', 'bbx-teaser__draft-line', doneText));
    }

    appendLine(
      elTeaserDraft,
      t('teaser_total_label', 'Running total'),
      bbx.money ? bbx.money(snapshotTotal(snap)) : '',
      true
    );

    if (snap.dropped > 0 || _staleNoticeNeeded) {
      elTeaserDraft.appendChild(makeEl(
        'p',
        'bbx-teaser__draft-notice',
        t('teaser_stale_notice',
          'Some items in your saved box are no longer available — please review before continuing.')
      ));
    }

    // This function runs at the end of closeStepper() (via bbx.renderTeaser),
    // so painting the notice here IS "the first closeStepper() after a
    // resume" — clear right after so it doesn't reappear on every subsequent
    // close for the rest of the page session. Live snapshots always pass
    // dropped: 0, so only _staleNoticeNeeded keeps it alive between renders.
    _staleNoticeNeeded = false;
  }

  /**
   * Rehydrate the builder from a stored draft. Mirrors editBundle()'s render
   * order (which is the proven sequence for loading a box into the live UI),
   * minus the edit-mode bar and the CTA relabel — this is a resume, not an edit.
   */
  function restoreDraft(payload) {
    var snap = sanitiseDraft(payload);
    _staleNoticeNeeded = snap.dropped > 0;

    bbx.state.bundles = snap.bundles;
    bbx.state.current = snap.current;
    bbx.state.step = snap.step;

    if (bbx.showBuilder) bbx.showBuilder();
    if (bbx.renderPackages) bbx.renderPackages();

    var steps = root.querySelector('[data-bbx-steps]');
    if (snap.current.pkg) {
      var pkgStep = steps ? steps.querySelector('.bbx-step--packages') : null;
      if (pkgStep) pkgStep.style.display = 'none';
      if (bbx.renderPkgBanner) bbx.renderPkgBanner(snap.current.pkg);
    }

    if (bbx.renderGrid) bbx.renderGrid();

    // renderGrid() paints getProductsForCurrentPkg() — the featured or
    // per-package collection — never state.current.items. Hand-picked
    // (drawer-added) varieties are by definition not in that set, so without
    // this prepend the shopper sees a full capacity meter above a grid where
    // none of their own items appear. Same shared helper applyTemplate(),
    // selectPkg() and editBundle() use.
    if (bbx.ensureSeededItemCards) bbx.ensureSeededItemCards(snap.current.pkg);

    if (bbx.renderCapacity) bbx.renderCapacity();
    if (bbx.renderCustomisations) bbx.renderCustomisations();
    if (bbx.resetPreviewAnimState) bbx.resetPreviewAnimState();
    if (bbx.rebalance) bbx.rebalance();

    // This function writes state.step directly, bypassing goToStep()/selectPkg()
    // — the two places that normally keep the CTA label in step. Without this,
    // a draft restored at step 2 (with add-ons configured) reopened showing
    // wireDoneCta's init text "Done — review box" while the delegated handler,
    // reading the live step, actually routed the tap to step 3.
    if (bbx.syncCtaText) bbx.syncCtaText();

    if (_staleNoticeNeeded && bbx.announceToSR) {
      bbx.announceToSR(t('teaser_stale_notice',
        'Some items in your saved box are no longer available — please review before continuing.'));
    }

    // A draft with an empty `current` was saved from the complete screen — the
    // only route to the order summary / Add all to cart. Rebuilding the blank
    // builder instead (everything above) strands every finished box with no
    // way back to checkout.
    if (snap.bundles.length && !snap.current.pkg && !snap.current.items.length
        && bbx.renderCompleteScreen) {
      bbx.renderCompleteScreen(snap.bundles.length - 1);
    }
  }

  if (elTeaserCta) {
    elTeaserCta.addEventListener('click', function () {
      if (!draftHasContent()) {
        var stored = loadDraft();
        if (stored) {
          restoreDraft(stored);
          if (bbx.openStepper) bbx.openStepper(bbx.state.step);
          return;
        }
      } else {
        // Live state already in memory (sheet closed and reopened this visit).
        if (bbx.openStepper) bbx.openStepper(bbx.state.step);
        return;
      }
      // Nothing saved — open at the normal entry step.
      if (bbx.openStepper) bbx.openStepper();
    });
  }

  if (elTeaserReset) {
    elTeaserReset.addEventListener('click', function () {
      // No confirmation dialog: nothing of real value is at stake (no payment,
      // no order). Flagged in the spec for Sanjay to override if he wants one.
      clearDraft();
      _staleNoticeNeeded = false;
      bbx.state.bundles = [];
      // startNewBundle() is the existing full reset — package step, empty grid,
      // default CTA, cleared template price note.
      if (bbx.startNewBundle) bbx.startNewBundle();
      // bundles is empty again, so the picker is eligible to show once more.
      if (bbx.renderTemplatePicker) bbx.renderTemplatePicker();
      bbx.state.step = (bbx.hasStep0 && bbx.hasStep0()) ? 0 : 1;
      // Stage 3 opus audit, finding 14: startNewBundle() renders the chrome at
      // its own default (step 1), so without a rebuild here the pill trail
      // shows stale state until the sheet is next opened and self-heals via
      // openStepper()'s own render call. refreshChrome() isn't exported to
      // this IIFE (only renderBuilderChrome() is) — a full rebuild is exactly
      // what openStepper() already does in the same situation.
      if (bbx.renderBuilderChrome) bbx.renderBuilderChrome();
      if (bbx.showStepPanel) bbx.showStepPanel(bbx.state.step);
      renderTeaser();
    });
  }

  bbx.renderTeaser = renderTeaser;
  renderTeaser();

  // ── Self-check ────────────────────────────────────────────────────────────
  (function selfCheckDraft() {
    var priceable = {
      id: 1, title: 'Cashews', handle: 'cashews',
      variants: [{ gid: 'v1', title: '500g', price: 60000 }]
    };
    var unpriceable = {
      id: 2, title: 'Mystery', handle: 'mystery',
      variants: [{ gid: 'v2', title: 'Default Title', price: 100 }]
    };

    // Stage 3 opus audit, finding 9: current.pkg carries a gid that cannot
    // possibly match any live package (cfg.packages is real config, never a
    // fixture) — resolvePkg() must drop it and count it toward `dropped`.
    var out = sanitiseDraft({
      schemaVersion: DRAFT_VERSION,
      savedAt: Date.now(),
      step: 2,
      current: { pkg: { gid: 'gid://shopify/Metaobject/does-not-exist-999999' }, items: [
        { product: priceable, allocatedG: 500, priceP: 60000 },
        { product: unpriceable, allocatedG: 500, priceP: 0 }
      ], customisations: [] },
      bundles: [{ pkg: null, items: [{ product: priceable, allocatedG: 1000, priceP: 120000 }], customisations: [], _uuid: 'abc' }]
    });

    console.assert(out.current.items.length === 1, '[bbx draft] unpriceable item must be dropped', out);
    console.assert(out.current.pkg === null, '[bbx draft] a package no longer in cfg.packages must be dropped', out.current.pkg);
    console.assert(out.dropped === 2, '[bbx draft] dropped count must include both the unpriceable item and the stale package', out.dropped);
    console.assert(out.bundles.length === 1 && out.bundles[0]._uuid === 'abc',
      '[bbx draft] bundle _uuid must survive sanitise', out.bundles);
    console.assert(out.step === 2, '[bbx draft] step must round-trip', out.step);

    // The staleness window is load-bearing (a month-old box would resurface at
    // stale prices), so pin it rather than letting a typo widen it silently.
    // Not exercised against real localStorage here — that would clobber a live
    // shopper's draft under the real key.
    console.assert(DRAFT_MAX_AGE_MS === 604800000,
      '[bbx draft] staleness window must be exactly 7 days', DRAFT_MAX_AGE_MS);
    console.assert(DRAFT_KEY.indexOf('bbx-draft:') === 0 && DRAFT_KEY.length > 'bbx-draft:'.length,
      '[bbx draft] key must be prefixed against other localStorage users', DRAFT_KEY);

    // Review finding 1 (critical): saveDraft() on empty state must NOT delete a
    // stored draft — pagehide fires it on every navigation away, including a
    // fresh load. This is the one check that has to touch real localStorage,
    // so it reads first and writes the identical value back if the regression
    // ever returns, repairing the damage it just caused instead of leaving a
    // live shopper's draft deleted.
    var rawBefore = readRaw();
    var liveState = bbx.state;
    bbx.state = { bundles: [], step: 1, current: { pkg: null, items: [], customisations: [] } };
    var savedEmpty = saveDraft();
    bbx.state = liveState;
    var rawAfter = readRaw();
    console.assert(savedEmpty === false, '[bbx draft] saveDraft on empty state must report false', savedEmpty);
    console.assert(rawAfter === rawBefore, '[bbx draft] saveDraft on empty state must not touch a stored draft');
    if (rawAfter !== rawBefore && rawBefore != null) writeRaw(rawBefore);

    // Review findings 3 + 4: a bundle pruned to zero items must not survive
    // restore, and a customisation whose metaobject is gone must be dropped
    // rather than carried into addAllToCart's customisation_metaobject_gids.
    var out2 = sanitiseDraft({
      current: { pkg: null, items: [], customisations: [
        { customisation: { gid: 'gid://shopify/Metaobject/dead-addon-999999', price: '49' }, priceP: 4900 }
      ] },
      bundles: [
        { pkg: null, items: [{ product: unpriceable, allocatedG: 500, priceP: 0 }], customisations: [], _uuid: 'empty-box' },
        { pkg: null, items: [{ product: priceable, allocatedG: 500, priceP: 60000 }], customisations: [], _uuid: 'keeps' }
      ]
    });
    console.assert(out2.current.customisations.length === 0,
      '[bbx draft] a customisation no longer in cfg.customisations must be dropped', out2.current.customisations);
    console.assert(out2.bundles.length === 1 && out2.bundles[0]._uuid === 'keeps',
      '[bbx draft] a bundle pruned to zero items must not survive restore', out2.bundles);
    console.assert(out2.dropped === 2,
      '[bbx draft] dropped must count the dead add-on and the unpriceable item', out2.dropped);

    // Review finding 5: a malformed payload degrades to an empty draft rather
    // than throwing on .filter/.map of a non-array.
    console.assert(sanitiseDraft({ current: { items: 'oops' }, bundles: 'oops' }).bundles.length === 0,
      '[bbx draft] malformed payload must degrade, not throw');

    console.log('[bbx] draft self-check complete.');
  })();

  // Stage 3 opus audit, finding 10: the draft previously only saved on an
  // explicit closeStepper() call. Backgrounding the tab, refreshing, or
  // navigating away mid-flow lost the whole draft silently — undermining most
  // of the feature's point (auto-save). pagehide fires reliably across
  // browsers on tab close/backgrounding/navigation, unlike beforeunload.
  // Placed after the self-check (not inside the export block above) so
  // Task 9's find/replace anchor — which targets the `bbx.saveDraft = …`
  // export lines — is untouched by this addition.
  window.addEventListener('pagehide', saveDraft);
})();
